const messages = {
  fr: {
    translations: {
      seller_queue: {
        modal: {
          sale_outcome: {
            completed: 'Vente Terminée',
            not_completed: 'Vente Non Terminée',
          },
          reasons: {
            label: 'Raison de la Non-Vente :',
            loading: 'Chargement des raisons...',
            load_error: 'Impossible de charger les raisons. Veuillez réessayer.',
            retry: 'Réessayer',
            placeholder: 'Sélectionnez une raison...',
          },
          buttons: {
            cancel: 'Annuler',
            next: 'Suivant →',
          },
        },
        "seller_queue": "File d'Attente du Vendeur",
        "queue_status": "Statut de la File",
        "queue_position": "Position dans la File",
        "queue_duration": "Durée",
        "queue_seller_status": "Statut du Vendeur",
        "queue_in_service": "En Service",
        "queue_not_in_service": "NNon en Service",
        "queue_no_entry": "Vous n'êtes pas dans la file",
        "queue_loading": "Chargement...",
        "queue_error": "Erreur: {{error}}",
        "queue_view_details": "Voir les Détails",
        "reason": "Raison",
      },
      gridHotelFeedback: {
        dashboard: 'Tableau de bord',
        service_grid: 'Grilles de Sondage et de Satisfaction',
        service_grid_single: 'Grille de Sondage et de Satisfaction',
        listed_grids: 'Les Grilles de Sondage et de Satisfaction sont listées ci-dessous',
        create_service_grid: 'Créer une Grille de Sondage et de Satisfaction',
        title: 'Titre',
        status: 'Statut',
        grid_deleted: 'Grille Supprimée !',
        grid_deleted_message:
          'La Grille de Sondage et de Satisfaction a été supprimée avec succès.',
        error: 'Erreur',
        error_delete_message:
          'Une erreur est survenue lors de la suppression de la Grille de Sondage et de Satisfaction.',
        service_grid_name: 'Titre',
        service_grid_name_placeholder: 'Ex: Enquête de Satisfaction',
        fill_information_create:
          'Remplissez les informations ci-dessous et cliquez sur le bouton "Créer" pour enregistrer les modifications',
        missing_fields: 'Champs obligatoires',
        missing_fields_message: 'Le champ "Titre" et la "Liste des éléments" sont obligatoires !',
        grid_created: 'Grille créée',
        grid_created_message: 'Enregistrement effectué avec succès !',
        error_create_message: 'Erreur lors de la création de la grille !',
        service_list: 'Liste des éléments',
        service_placeholder: 'Ajoutez un élément (Ex: Qualité de la Chambre)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Modifier la Grille de Sondage et de Satisfaction',
        save_changes_edit:
          'Remplissez les informations ci-dessous et cliquez sur le bouton "Sauvegarder" pour confirmer les modifications',
        grid_updated: 'Grille modifiée',
        grid_updated_message: 'Modification effectuée avec succès !',
        error_update_message: 'Erreur lors de la modification de la grille !',

        general: {
          actions: 'Actions',
          edit: 'Modifier',
          delete: 'Supprimer',
          active: 'Actif',
          inactive: 'Inactif',
          select: 'Sélectionner',
          back: 'Retour',
        },
        buttons: {
          create: 'Créer',
          back: 'Retour',
          save: 'Sauvegarder',
        },
      },
      // Traduções para a página de gerenciamento de idiomas das lojas
      translate_stores: {
        page_title: 'Gestion des langues et des relations entre magasins',
        page_subtitle:
          'Gérez les langues de traduction et les relations de chaque magasin du système.',
        page_title_relationships: 'Gestion des Relations entre Magasins',
        page_subtitle_relationships: 'Gérez les relations entre les magasins du système.',
        tab_translations: 'Gérer les Langues',
        tab_relations: 'Relations entre Magasins',
        breadcrumb: {
          dashboard: 'Tableau de bord',
          translate_stores: 'Gérer les Langues',
        },
        filters: {
          status: 'Statut',
          type: 'Type',
          active: 'Actif',
          inactive: 'Inactif',
          both: 'Les deux',
          all_types: 'Tous',
          status_placeholder: 'Statut du Magasin',
          type_placeholder: 'Type du Magasin',
          filter_button: 'Filtrer',
        },
        status_options: {
          active: 'Actif',
          inactive: 'Inactif',
          both: 'Les deux',
          all_types: 'Tous',
        },
        languages: {
          portuguese: 'Portugais',
          spanish: 'Espagnol',
          english: 'Anglais',
          french: 'Français',
          german: 'Allemand',
          italian: 'Italien',
          japanese: 'Japonais',
          korean: 'Coréen',
          chinese: 'Mandarin',
        },
        table: {
          headers: {
            type: 'Type',
            id: 'ID',
            name: 'Nom',
            subdomain: 'Sous-domaine',
            status: 'Statut',
            created: 'Créé le',
            cnpj: 'CNPJ',
            actions: 'Actions',
          },
          type: 'Type',
          id: 'ID',
          name: 'Nom',
          subdomain: 'Sous-domaine',
          status: {
            active: 'Actif',
            inactive: 'Inactif',
          },
          created: 'Créé le',
          cnpj: 'CNPJ',
          actions: 'Actions',
        },
        actions: {
          manage_languages: 'Gérer les Langues',
          edit: 'Modifier',
        },
        messages: {
          success: {
            title: 'Succès',
            save: 'Langues sauvegardées avec succès !',
          },
          error: {
            title: 'Erreur',
            load_data: 'Erreur lors du chargement des données des magasins !',
            save_languages: 'Erreur lors de la sauvegarde des langues !',
          },
        },
        modal: {
          title: 'Gérer les Langues',
          description:
            'Sélectionnez les langues qui seront disponibles pour la traduction dans ce magasin :',
          alert: {
            title: 'Attention',
            message:
              'Activez ou désactivez les langues qui doivent être utilisées pour la traduction dans ce magasin.',
          },
          buttons: {
            cancel: 'Annuler',
            save: 'Sauvegarder',
          },
        },
        relations: {
          no_relations: 'Aucune relation trouvée',
          create_title: 'Créer une Relation',
          edit_title: 'Modifier la Relation',
          parent_label: 'Magasin Parent',
          child_label: 'Magasin Enfant',
          parent_missing: 'Sélectionnez le magasin parent',
          child_missing: 'Sélectionnez le magasin enfant',
          same_store_error: 'Le magasin parent ne peut pas être le même que le magasin enfant',
          created_success: 'Relation créée avec succès',
          updated_success: 'Relation mise à jour avec succès',
          deleted_success: 'Relation supprimée avec succès',
          error_create: 'Erreur lors de la création de la relation',
          error_update: 'Erreur lors de la mise à jour de la relation',
          error_delete: 'Erreur lors de la suppression de la relation',
          store_not_found: 'Magasin non trouvé',
          all_option: 'Tous',
          cancel: 'Annuler',
          save: 'Sauvegarder',
          delete_confirm: 'Oui, supprimer',
          create_button: 'Créer une Relation',
          save_changes: 'Sauvegarder les Modifications',
          create_description:
            'Définissez quel magasin sera le magasin parent et quel sera le magasin enfant. Un magasin parent peut avoir plusieurs magasins enfants et gérer leurs configurations.',
          edit_description:
            'Modifiez la relation entre les magasins sélectionnés. Les changements seront appliqués immédiatement.',
          summary_title: 'Résumé de la relation :',
          tips_title: 'Conseils importants :',
          tip_parent_multiple: 'Un magasin parent peut avoir plusieurs magasins enfants',
          tip_child_single: 'Un magasin enfant peut avoir plusieurs parents',
          tip_all_available:
            'Tous les magasins (actifs et inactifs) sont disponibles pour la sélection',
          click_new: 'Cliquez sur "Nouvelle Relation" pour commencer',
          message_delete:
            'Êtes-vous sûr de vouloir supprimer cette relation ? Cette action est irréversible.',
        },
      },
      hospitality_review: {
        page_title: "Évaluations de l'Hôtel",
        page_subtitle: "Gérez et surveillez les évaluations et les notes des clients de l'hôtel.",
        breadcrumb: {
          dashboard: 'Tableau de bord',
          hospitality: 'Hôtellerie',
          reviews: 'Évaluations',
        },
        statistics: {
          total_reviews: 'Total des Évaluations',
          average_rating: 'Note Moyenne Générale',
        },
        filters: {
          filter_by_type: 'Filtrer par Type',
          filter_by_rating: 'Filtrer par Note',
        },
        type_options: {
          all_types: 'Tous',
          general: 'Général',
          room: 'Chambre',
          food: 'Nourriture',
          service: 'Service',
          cleanliness: 'Propreté',
          activities: 'Activités',
        },
        rating_options: {
          all_ratings: 'Toutes les évaluations',
          five_stars: '5 étoiles',
          four_stars: '4 étoiles',
          three_stars: '3 étoiles',
          two_stars: '2 étoiles',
          one_star: '1 étoile',
        },
        table: {
          headers: {
            rating: 'Note',
            type: 'Type',
            comment: 'Commentaire',
            date: 'Date',
            actions: 'Actions',
          },
          actions: {
            view_full_review: "Voir l'évaluation complète",
          },
          status: {
            approved: 'Approuvée',
            pending: 'En attente',
          },
        },
        modal: {
          review_title: 'Évaluation de',
          fields: {
            rating: 'Note',
            type: 'Type',
            status: 'Statut',
            date: 'Date',
            comment: 'Commentaire',
            email: 'Email',
          },
          guest_anonymous: 'Anonyme',
        },
        messages: {
          success: {
            review_deleted: 'Évaluation supprimée',
            delete_success: 'Suppression effectuée avec succès !',
            status_updated: 'Statut mis à jour',
            approved_success: 'Évaluation approuvée avec succès !',
            suspended_success: 'Évaluation suspendue avec succès !',
          },
          error: {
            title: 'Erreur',
            load_reviews: "Erreur lors du chargement des évaluations de l'hôtel !",
            invalid_id: 'ID invalide pour la suppression !',
            delete_error: "Erreur lors de la suppression de l'évaluation !",
            status_error: "Erreur lors du changement de statut de l'évaluation !",
          },
          confirm: {
            delete_title: 'Confirmer la suppression',
            delete_text: 'Êtes-vous sûr de vouloir supprimer cette évaluation ?',
            delete_confirm: 'Oui, supprimer',
            delete_cancel: 'Annuler',
          },
        },
      },
      hospitality_info: {
        page_title: "Informations sur l'Hôtel",
        page_subtitle: "Gérez le contact, les horaires et les services de l'hôtel.",
        tabs: {
          contact: 'Contact',
          hours: 'Horaires et Informations',
          services: 'Services',
          ramal: 'Extension',
          about: 'À propos',
        },
        contact: {
          phone_label: 'Téléphone',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: "Horaires et Informations de l'Hôtel",
          add_button: 'Ajouter un Horaire/Information',
          remove_button: 'Supprimer',
          hour_number: 'Élément',
          title_label: 'Titre',
          title_placeholder: 'Ex: Réception, Piscine, Restaurant',
          description_label: 'Horaires et Informations',
          description_placeholder:
            "Décrivez les horaires d'ouverture et les informations supplémentaires (Ex: 08:00 - 22:00, fermé le week-end)",
        },
        services: {
          title: "Services de l'Hôtel",
          add_button: 'Ajouter un Service',
          remove_button: 'Supprimer',
          service_number: 'Service',
          service_title_label: 'Titre du Service',
          service_title_placeholder: 'Ex: Service de chambre',
          service_description_label: 'Description',
          service_description_placeholder: 'Décrivez le service',
        },
        ramal: {
          title: "Extensions de l'Hôtel",
          add_button: 'Ajouter une Extension',
          remove_button: 'Supprimer',
          ramal_number: 'Extension',
          ramal_title_label: "Titre de l'Extension",
          ramal_title_placeholder: 'Ex: 504',
          ramal_description_label: 'Description',
          ramal_description_placeholder: "Descriez l'extension",
        },
        about: {
          description_label: "À propos de l'Hôtel",
          description_placeholder:
            "Décrivez des informations générales sur l'hôtel, l'histoire, les caractéristiques uniques et spéciales",
        },
        actions: {
          save_button: 'Sauvegarder',
        },
        messages: {
          error_title: 'Erreur',
          error_text: "Impossible de sauvegarder les informations de l'hôtel.",
          success_title: 'Sauvegardé !',
          success_text: "Informations de l'hôtel sauvegardées avec succès.",
          required_phone: 'Le téléphone est obligatoire.',
          required_email: "L'e-mail est obligatoire.",
          required_hours: 'Tous les éléments doivent avoir un titre et une description.',
          required_service: 'Tous les services doivent avoir un titre et une description.',
          required_ramal: 'Toutes les extensions doivent avoir un titre et une description.',
        },
      },
      hospitality_schedules: {
        page_title: "Programme de l'Hôtel",
        page_subtitle: "Gérez les événements et les programmes de l'hôtel.",
        new_button: 'Nouveau Programme',
        edit_button: 'Modifier le Programme',
        delete_button: 'Supprimer le Programme',
        delete_confirm:
          'Êtes-vous sûr de vouloir supprimer ce programme ? Cette action est irréversible.',
        table: {
          title: 'Titre',
          type: 'Type',
          location: 'Localisation',
          time: 'Heure',
          recurrence: 'Récurrence',
          period: 'Période',
          status: 'Statut',
          actions: 'Actions',
          active: 'Actif',
          inactive: 'Inactif',
          single_event: 'Événement unique',
          all_types: 'Tous',
          all_status: 'Tous les statuts',
          age_group: "Groupe d'âge",
        },
        filters: {
          type: 'Type',
          type_placeholder: 'Sélectionnez le type',
          status: 'Statut',
          status_placeholder: 'Sélectionnez le statut',
          date_init: 'Date de Début',
          date_init_placeholder: 'Date de début',
          date_end: 'Date de Fin',
          date_end_placeholder: 'Date de fin',
          search: 'Rechercher',
          clear: 'Effacer les Filtres',
        },
        messages: {
          load_error: 'Erreur lors du chargement des programmes !',
          delete_success: 'Programme supprimé avec succès !',
          delete_error: 'Erreur lors de la suppression du programme !',
        },
        types: {
          activity: 'Divertissement',
          food: 'Gastronomie',
          event: 'Événement',
          tour: 'Excursion',
        },
        age_groups: {
          all: 'Tous',
          children: 'Enfants',
          teens: 'Adolescents',
          adults: 'Adultes',
          seniors: 'Personnes âgées',
          family: 'Famille',
        },
        singleEvent: 'Événement Unique',
      },
      hospitality_schedule_edit: {
        page_title: 'Modifier le Programme',
        page_subtitle: 'Modification : {{title}}',
        not_found: {
          title: 'Programme non trouvé',
          description: "Le programme que vous essayez de modifier n'a pas été trouvé.",
          back_button: 'Retour à la Liste',
        },
        form: {
          type_label: 'Type',
          type_placeholder: 'Sélectionnez le type',
          type_sports: 'Sports',
          type_wellness: 'Bien-être',
          type_other: 'Autre',
          title_label: 'Titre',
          title_placeholder: 'Entrez le titre du programme',
          description_label: 'Description',
          description_placeholder: 'Décrivez le programme',
          location_label: 'Localisation',
          location_placeholder: 'Localisation du programme',
          time_label: 'Heure',
          time_placeholder: 'Ex: 14:00 - 16:00 ou 14:00',
          time_smalltext: 'Format : "HH:MM - HH:MM" ou "HH:MM"',
          recurrence_config: 'Configuration de la Récurrence',
          single_event_radio: 'Événement Unique - Événement qui a lieu à des dates spécifiques',
          recurring_event_radio:
            'Événement Récurrent - Événement qui se répète certains jours de la semaine',
          day_within_date_range_radio:
            'Événement dans une Plage de Dates - Événement qui se produit dans une plage de dates spécifique',
          days_of_week_label: 'Jours de la Semaine',
          selected_days: 'Sélectionnés : {{days}}',
          date_init_label: 'Date de Début',
          date_init_placeholder: 'Date de début',
          date_end_label: 'Date de Fin',
          date_end_placeholder: 'Date de fin (facultatif)',
          status_label: 'Statut',
          back_button: 'Retour',
          save_button: 'Sauvegarder les Modifications',
        },
      },
      hospitality_schedule_create: {
        page_title: 'Nouveau Programme',
        page_subtitle: "Créer un nouveau programme pour l'hôtel",
        success: {
          title: 'Succès !',
          text: 'Programme créé avec succès !',
        },
        error: {
          title: 'Erreur',
          text: 'Erreur lors de la création du programme !',
        },
        form: {
          title_label: 'Titre *',
          title_placeholder: 'Entrez le titre du programme',
          title_required: 'Le titre est obligatoire',
          type_label: 'Type *',
          type_placeholder: 'Sélectionnez le type',
          type_sports: 'Sports',
          type_wellness: 'Bien-être',
          type_other: 'Autres',
          description_label: 'Description *',
          description_placeholder: 'Décrivez le programme',
          description_required: 'La description est obligatoire',
          location_label: 'Localisation *',
          location_placeholder: 'Localisation du programme',
          location_required: 'La localisation est obligatoire',
          time_label: 'Heure *',
          time_placeholder: 'Ex: 14:00 - 16:00 ou 14:00',
          time_smalltext: 'Format : "HH:MM - HH:MM" ou "HH:MM"',
          time_required: "L'heure est obligatoire",
          recurrence_config: 'Configuration de la Récurrence',
          single_event_radio: 'Événement Unique - Événement qui a lieu à des dates spécifiques',
          recurring_event_radio:
            'Événement Récurrent - Événement qui se répète certains jours de la semaine',
          day_within_date_range_radio:
            'Événement dans une Plage de Dates - Événement qui se produit dans une plage de dates spécifique',
          days_of_week_label: 'Jours de la Semaine',
          selected_days: 'Sélectionnés : {{days}}',
          date_init_label: 'Date de Début',
          date_init_placeholder: 'Date de début',
          date_end_label: 'Date de Fin',
          date_end_placeholder: 'Date de fin (facultatif)',
          status_label: 'Statut',
          back_button: 'Retour',
          save_button: 'Sauvegarder',
        },
      },
      hospitality_banner: {
        page_title: "Bannières de l'Hôtel",
        page_subtitle:
          "Gérez les bannières de votre hôtel. Contrôlez la période d'affichage, l'ordre et le statut.",
        breadcrumb: {
          hospitality: 'Hôtellerie',
          publicity: 'Publicité',
        },
        new_button: 'Nouvelle Publicité',
        table: {
          title: 'Titre',
          image: 'Image',
          order: 'Ordre',
          period: 'Période',
          created_date: 'Date de Création',
          status: 'Statut',
          actions: 'Actions',
        },
        actions: {
          edit: 'Modifier la publicité',
          view: 'Voir les détails',
          delete: 'Supprimer la publicité',
        },
        modal: {
          title: 'Publicité #{{id}}',
          order: 'Ordre',
          status: 'Statut',
          active: 'Active',
          inactive: 'Inactive',
          period: 'Période',
          created: 'Créé le',
          updated: 'Dernière mise à jour',
          image: 'Image',
          no_image: "Pas d'image",
        },
        delete: {
          confirm_title: 'Confirmer la suppression',
          confirm_text: 'Êtes-vous sûr de vouloir supprimer cette publicité ?',
          confirm_button: 'Oui, supprimer',
          cancel_button: 'Annuler',
          success_title: 'Publicité supprimée',
          success_text: 'Suppression effectuée avec succès !',
        },
        status: {
          success_title: 'Statut mis à jour',
          success_text: 'Publicité {{action}} avec succès !',
          activated: 'activée',
          deactivated: 'désactivée',
        },
        error: {
          title: 'Erreur',
          load_data: 'Erreur lors du chargement des données de publicité !',
          invalid_id: 'ID invalide pour la suppression !',
          delete: 'Erreur lors de la suppression de la publicité !',
          status_change: 'Erreur lors du changement de statut de la publicité !',
        },
      },
      hospitality_banner_create: {
        page_title: "Créer une nouvelle Bannière de l'Hôtel",
        page_subtitle: 'Remplissez les informations ci-dessous pour créer une nouvelle bannière.',
        breadcrumb: {
          hospitality: 'Hôtellerie',
          publicity: 'Publicité',
          create: 'Créer Publicité',
        },
        form: {
          title_label: 'Titre de la Bannière *',
          title_placeholder: 'Ex: Randonnées...',
          order_label: "Ordre d'Affichage *",
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext:
            'Ordre de priorité de la publicité (les nombres inférieurs apparaissent en premier)',
          status_label: 'Publicité Active',
          status_smalltext: 'Cochez pour activer la publicité',
          start_date_label: 'Date de Début *',
          start_time_label: 'Heure de Début *',
          end_date_label: 'Date de Fin *',
          end_time_label: 'Heure de Fin *',
          image_label: 'Image de la Publicité',
          image_select: 'Sélectionner une image',
          image_formats: 'Formats acceptés : JPG, PNG, GIF',
          image_optional: 'Facultatif - Une image par défaut sera utilisée si non fournie',
          image_preview: "Aperçu de l'Image",
          image_remove: "Supprimer l'Image",
        },
        preview: {
          period_title: 'Période de la Publicité :',
          start: 'Début',
          end: 'Fin',
        },
        validation: {
          title: 'Erreur de validation',
          order_positive: "L'ordre doit être un nombre supérieur à zéro !",
          start_date_required: 'La date de début est obligatoire !',
          end_date_required: 'La date de fin est obligatoire !',
          dates_required: 'Les dates et heures sont obligatoires !',
          start_before_end: 'La date de début doit être antérieure à la date de fin !',
        },
        success: {
          title: 'Publicité créée',
          text: 'Publicité créée avec succès !',
        },
        error: {
          title: 'Erreur',
          text: 'Erreur lors de la création de la publicité !',
        },
      },
      hospitality_banner_update: {
        page_title: "Modifier la Publicité de l'Hôtel",
        page_subtitle: 'Modification de la publicité #{{id}}',
        breadcrumb: {
          edit: 'Modifier Publicité',
        },
        current_image: 'Image Actuelle',
        save_button: 'Sauvegarder les Modifications',
        not_found: {
          title: 'Publicité non trouvée',
          text: "La publicité que vous essayez de modifier n'a pas été trouvée.",
          back_button: 'Retour à la Liste',
        },
        no_changes: {
          title: 'Aucune modification',
          text: "Aucun champ n'a été modifié !",
        },
        success: {
          title: 'Publicité mise à jour',
          text: 'Publicité mise à jour avec succès !',
        },
        error: {
          title: 'Erreur',
          text: 'Erreur lors de la mise à jour de la publicité',
          load_data: 'Erreur lors du chargement des données de la publicité !',
          update: 'Erreur lors de la mise à jour de la publicité !',
        },
      },
      hospitality_publicity: {
        page_title: "Bannières de Mise en Avant de l'Hôtel",
        page_subtitle:
          "Gérez les bannières de mise en avant de votre hôtel. Contrôlez la période d'affichage, l'ordre et le statut.",
        breadcrumb: {
          hospitality: 'Hôtellerie',
          publicity: 'Publicité',
        },
        new_button: 'Nouvelle Bannière',
        table: {
          image: 'Image',
          order: 'Ordre',
          period: 'Période',
          created_date: 'Date de Création',
          status: 'Statut',
          actions: 'Actions',
        },
        actions: {
          edit: 'Modifier la publicité',
          view: 'Voir les détails',
          delete: 'Supprimer la publicité',
        },
        modal: {
          title: 'Publicité #{{id}}',
          order: 'Ordre',
          status: 'Statut',
          active: 'Active',
          inactive: 'Inactive',
          period: 'Période',
          created: 'Créé le',
          updated: 'Dernière mise à jour',
          image: 'Image',
          no_image: "Pas d'image",
        },
        delete: {
          confirm_title: 'Confirmer la suppression',
          confirm_text: 'Êtes-vous sûr de vouloir supprimer cette publicité ?',
          confirm_button: 'Oui, supprimer',
          cancel_button: 'Annuler',
          success_title: 'Publicité supprimée',
          success_text: 'Suppression effectuée avec succès !',
        },
        status: {
          success_title: 'Statut mis à jour',
          success_text: 'Publicité {{action}} avec succès !',
          activated: 'activée',
          deactivated: 'désactivée',
        },
        error: {
          title: 'Erreur',
          load_data: 'Erreur lors du chargement des données de publicité !',
          invalid_id: 'ID invalide pour la suppression !',
          delete: 'Erreur lors de la suppression de la publicité !',
          status_change: 'Erreur lors du changement de statut de la publicité !',
        },
      },
      hospitality_publicity_create: {
        page_title: "Créer une Publicité d'Hôtel",
        page_title_edit: "Modifier la Publicité d'Hôtel",
        page_subtitle: 'Remplissez les informations ci-dessous pour créer une nouvelle publicité.',
        breadcrumb: {
          hospitality: 'Hôtellerie',
          publicity: 'Publicité',
          create: 'Créer Publicité',
        },
        form: {
          order_label: "Ordre d'Affichage *",
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext:
            'Ordre de priorité de la publicité (les nombres inférieurs apparaissent en premier)',
          status_label: 'Publicité Active',
          status_smalltext: 'Cochez pour activer la publicité',
          start_date_label: 'Date de Début *',
          start_time_label: 'Heure de Début *',
          end_date_label: 'Date de Fin *',
          end_time_label: 'Heure de Fin *',
          image_label: 'Image de la Publicité',
          image_select: 'Sélectionner une image',
          image_formats:
            'Formats acceptés : JPG, PNG, GIF | Dimensions : ~200x112px | Taille max : 2MB',
          image_optional: 'Facultatif - Une image par défaut sera utilisée si non fournie',
          image_preview: "Aperçu de l'Image",
          image_remove: "Supprimer l'Image",
          external_link_checkbox: 'Inclure un Lien Externe',
          external_link_label: 'Lien Externe',
          external_link_placeholder: 'https://example.com',
          description_label: 'Description de la Bannière',
          description_smalltext: '* Maximum {qtd} caractères',
          title_label: 'Titre de la Bannière',
          title_placeholder: 'Exemple : Randonnées...',
          title_smalltext: '* Maximum {qtd} caractères',
        },
        preview: {
          period_title: 'Période de la Publicité :',
          start: 'Début',
          end: 'Fin',
        },
        validation: {
          title: 'Erreur de validation',
          order_positive: "L'ordre doit être un nombre supérieur à zéro !",
          start_date_required: 'La date de début est obligatoire !',
          end_date_required: 'La date de fin est obligatoire !',
          dates_required: 'Les dates et heures sont obligatoires !',
          start_before_end: 'La date de début doit être antérieure à la date de fin !',
          external_link_required:
            "Le lien externe est obligatoire lorsque l'option est sélectionnée !",
          image_size_error: "L'image doit avoir une taille maximale de 2MB !",
          image_dimensions_error:
            "Les dimensions de l'image doivent être d'environ 200x112 pixels ! Actuel : {{current}}",
          image_invalid: "Fichier d'image invalide ! Veuillez sélectionner une image valide.",
        },
        success: {
          title: 'Publicité créée',
          text: 'Publicité créée avec succès !',
        },
        error: {
          title: 'Erreur',
          text: 'Erreur lors de la création de la publicité !',
          update: 'Erreur lors de la mise à jour de la publicité !',
        },
        not_found: {
          title: 'Publicité non trouvée',
          text: "La publicité que vous essayez de modifier n'a pas été trouvée.",
          back_button: 'Retour à la liste',
        },
        no_changes: {
          title: 'Aucune modification',
          text: "Aucun champ n'a été modifié !",
        },
        current_image: 'Image Actuelle',
      },
      // Adicionar ao arquivo
      service_list: {
        filters: {
          categories: 'Catégories',
          category_placeholder: 'Catégorie',
          filter_button: 'Filtrer',
          all_categories: 'TOUS',
        },
        table: {
          schedule: 'Horaire',
          extension: 'Extension',
        },
        actions: {
          delete_service: 'Supprimer le Service',
        },
      },
      // Adicionar ao arquivo
      service_create: {
        page_title: 'Enregistrer un Service',
        breadcrumb: {
          services: 'Services',
          create: 'Créer',
        },
        form: {
          classification_placeholder: 'Sélectionnez une classification',
          name_label: 'Nom',
          name_placeholder: 'Nom du service',
          description_label: 'Description',
          description_placeholder: 'Description du service',
          schedule_label: "Heures d'Ouverture",
          schedule_placeholder: 'Ex: 24h, 08:00-18:00, Sur demande',
          schedule_smalltext: 'Maximum 50 caractères',
          extension_label: 'Extension',
          extension_placeholder: 'Ex: 1001, 2050',
          extension_smalltext: 'Maximum 10 caractères',
          code_label: 'Code',
          code_placeholder: 'Code du service',
          order_label: 'Ordre',
          order_placeholder: "Ordre d'affichage",
          status_label: 'Statut',
          status_active: 'Actif',
          status_inactive: 'Inactif',
          external_link_label: 'Lien Externe',
          external_link_placeholder: 'https://example.com',
          priority_label: 'Priorité',
          priority_low: 'Basse',
          priority_normal: 'Normale',
          priority_high: 'Haute',
          priority_critical: 'Critique',
        },
        icons: {
          title: 'Icônes',
          category_label: "Catégorie de l'Icône",
          all_categories: 'Tous',
          selected_icon: 'Icône sélectionnée',
        },
        validation: {
          missing_fields_title: 'Champs manquants',
          missing_fields_text:
            'Veuillez vérifier si vous avez rempli tous les champs obligatoires : Nom, Classification et Icône !',
        },
        success: {
          title: 'Service enregistré',
          text: 'Enregistrement effectué avec succès !',
        },
        error: {
          title: 'Erreur',
          text: "Erreur lors de l'enregistrement du service !",
          icons_load: 'Erreur lors de la recherche des types',
        },
      }, // Adicionar ao arquivo
      service_update: {
        page_title: 'Modifier le Service',
        page_title_full: 'Mettre à jour le Service',
        breadcrumb: {
          edit: 'Modifier',
        },
        error: {
          title: 'Erreur',
          load_data: 'Erreur lors du chargement des données du service !',
          text: 'Erreur lors de la mise à jour du service !',
        },
        success: {
          title: 'Service mis à jour',
          text: 'Modification effectuée avec succès !',
        },
      },
      // Adicionar ao arquivo
      service_category_create: {
        validation: {
          missing_fields_title: 'Champs manquants',
          missing_fields_text: 'Veuillez vérifier si vous avez rempli tous les champs !',
        },
        success: {
          title: 'Classification enregistrée',
          text: 'Enregistrement effectué avec succès !',
        },
        error: {
          title: 'Erreur',
          text: "Erreur lors de l'enregistrement de la classification !",
          create: 'Erreur lors de la création de la classification !',
        },
      },

      // Adicionar ao arquivo
      service_category_list: {
        page_title: 'Catégories de Contenu',
        page_subtitle: 'Voici les catégories de contenu listées avec leurs actions respectives.',
        breadcrumb: {
          categories: 'Catégories',
        },
        add_button: 'Ajouter',
        table: {
          name: 'Nom',
          status: 'Statut',
          actions: 'Actions',
        },
        actions: {
          edit_category: 'Modifier la catégorie',
          delete_category: 'Supprimer la catégorie',
        },
        delete: {
          error_title: 'Erreur',
          error_text: 'Erreur lors de la suppression de la catégorie !',
          success_title: 'Catégorie supprimée',
          success_text: 'Suppression effectuée avec succès !',
          confirm_title: 'Êtes-vous sûr ?',
          confirm_text: 'La catégorie sera supprimée et ne pourra pas être restaurée !',
          cancel_button: 'Fermer !',
          confirm_button: 'Supprimer !',
        },
      },
      service_category_update: {
        error: {
          title: 'Erreur',
          load_data: 'Erreur lors du chargement des données de la classification !',
          text: 'Erreur lors de la mise à jour de la classification !',
          update: 'Erreur lors de la mise à jour de la classification !',
        },
        success: {
          title: 'Classification mise à jour',
          text: 'Modification effectuée avec succès !',
        },
      },
      hotelRoom: {
        status: {
          available: 'Disponible',
          reserved: 'Réservé',
          maintenance: 'En maintenance',
          occupied: 'Occupé',
          being_cleaning: 'En cours de nettoyage',
        },
        type: {
          single: 'Chambre simple',
          double: 'Chambre double',
          twin: 'Lits jumeaux',
          queen: 'Lit Queen',
          king: 'Lit King',
          suite: 'Suite',
          junior_suite: 'Suite Junior',
          master_suite: 'Suite Master',
          presidential: 'Suite Présidentielle',
          family: 'Chambre familiale',
          accessible: 'Chambre accessible',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Client',
          wizard_step_reservation: 'Réservation',
          wizard_step_confirmation: 'Confirmation',
          wizard_step1: 'Étape 1',
          wizard_step2: 'Étape 2',
          wizard_step3: 'Étape 3',
          wizard_customer_title: 'Sélectionner ou Enregistrer un Client',
          wizard_customer_search_placeholder: 'Rechercher par nom, email ou téléphone...',
          wizard_customer_search_button: 'Rechercher un Client Existant',
          wizard_customer_new_button: 'Enregistrer un Nouveau Client',
          wizard_customer_none_found: 'Aucun client trouvé',
          wizard_customer_showing_first:
            "Affichage des 20 premiers résultats. Affinez votre recherche pour trouver d'autres clients.",
          wizard_reservation_title: 'Données de la Réservation',
          wizard_reservation_room_label: 'Chambre *',
          wizard_reservation_room_subtitle:
            'Cliquez sur les chambres pour les sélectionner. Vous pouvez sélectionner plusieurs chambres.',
          wizard_reservation_room_placeholder: 'Sélectionnez une chambre',
          wizard_reservation_status_label: 'Statut de la Réservation',
          wizard_reservation_status_placeholder: 'Sélectionnez le statut',
          wizard_reservation_checkin_label: "Date et Heure d'Arrivée *",
          wizard_reservation_checkout_label: 'Date et Heure de Départ *',
          wizard_reservation_password_label: 'Mot de passe du Client',
          wizard_reservation_password_placeholder: 'Entrez le mot de passe du client',
          wizard_reservation_generate_password: 'Générer un mot de passe',
          wizard_confirmation_title: 'Confirmer la Réservation',
          wizard_confirmation_customer_data: 'Données du Client',
          wizard_confirmation_reservation_data: 'Données de la Réservation',
          wizard_confirmation_room: 'Chambre',
          wizard_confirmation_capacity: 'Capacité',
          wizard_confirmation_price: 'Prix',
          wizard_confirmation_checkin: 'Arrivée',
          wizard_confirmation_checkout: 'Départ',
          wizard_confirmation_status: 'Statut',
          wizard_confirmation_password: 'Mot de passe',
          wizard_confirmation_address: 'Adresse',
          wizard_confirmation_zipcode: 'Code Postal',
          wizard_confirmation_gender_male: 'Masculin',
          wizard_confirmation_gender_female: 'Féminin',
          wizard_confirmation_gender_other: 'Autre',
          wizard_confirmation_gender_not_informed: 'Préfère ne pas informer',
          wizard_buttons_back: 'Retour',
          wizard_buttons_cancel: 'Annuler',
          wizard_buttons_next: 'Suivant',
          wizard_buttons_create: 'Créer',
          wizard_page_title: 'Nouvelle Réservation de Chambre',
          wizard_page_subtitle: "Créer une nouvelle réservation pour l'hôtel",
          legend: {
            title: 'Légende des Statuts des Chambres',
            available: 'Disponible',
            selected: 'Sélectionné',
            unavailable: 'Non Disponible',
            occupied: 'Occupée',
            reserved: 'Réservée',
            being_cleaning: 'En Nettoyage',
            maintenance: 'En Maintenance',
            no_info: 'Sans Information',
          },
        },
        customer_form: {
          title: 'Données du Client',
          personal_info_title: 'Informations Personnelles',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Nom Complet *',
          name_placeholder: 'Entrez le nom complet',
          email_label: 'E-mail *',
          email_placeholder: "Entrez l'e-mail",
          birthdate_label: 'Date de Naissance *',
          gender_label: 'Genre',
          gender_placeholder: 'Sélectionnez le genre',
          gender_male: 'Masculin',
          gender_female: 'Féminin',
          gender_other: 'Autre',
          contact_info_title: 'Informations de Contact',
          phone_label: 'Téléphone *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Type de Téléphone',
          phone_type_cell: 'Portable',
          phone_type_landline: 'Fixe',
          whatsapp_optin: 'Accepte de recevoir des messages sur WhatsApp',
          address_title: 'Adresse Résidentielle',
          cep_label: 'Code Postal *',
          cep_placeholder: '00000-000',
          street_label: 'Voie *',
          street_placeholder: 'Rue, Avenue, etc.',
          number_label: 'Numéro *',
          number_placeholder: '123',
          extra_label: 'Complément',
          extra_placeholder: 'Appartement, Bloc, etc.',
          district_label: 'Quartier *',
          district_placeholder: 'Nom du quartier',
          city_label: 'Ville *',
          city_placeholder: 'Nom de la ville',
          state_label: 'État *',
          state_placeholder: 'SP',
          reference_label: 'Point de Référence',
          reference_placeholder: 'Près du centre commercial, en face de la place, etc.',
          terms_title: 'Termes et Conditions',
          accept_terms: "J'accepte les termes et conditions d'utilisation *",
          lgpd_consent: "J'autorise le traitement de mes données personnelles (LGPD) *",
        },
        title: 'Réservations de Chambres',
        subtitle: "Gestion des réservations de l'hôtel",
        breadcrumb_dashboard: 'Tableau de bord',
        breadcrumb_reservation: 'Réservations',
        btn_new_reservation: 'Nouvelle Réservation',
        btn_confirm: 'Confirmer la Réservation',
        btn_checkin: "Faire l'Arrivée (Check-in)",
        btn_checkout: 'Faire le Départ (Check-out)',
        btn_cancel: 'Annuler la Réservation',
        btn_no_show: 'Marquer comme Non Présenté',
        btn_delete: 'Supprimer la Réservation',
        btn_details: 'Détails de la Réservation',
        filter_status_label: 'Statut de la Réservation',
        filter_status_placeholder: 'Sélectionnez un statut',
        filter_status_all: 'Tous les Statuts',
        table_reservation: 'Réservation',
        table_room: 'Chambre',
        table_customer: 'Client',
        table_checkin: 'Arrivée',
        table_checkout: 'Départ',
        table_status: 'Statut',
        table_price: 'Valeur',
        table_actions: 'Actions',
        status_confirmed: 'Confirmée',
        status_in_progress: 'En cours',
        status_completed: 'Terminée',
        status_cancelled: 'Annulée',
        status_no_show: 'Non Présenté',
        status_pending: 'En attente',
        msg_success_delete: 'Suppression effectuée avec succès !',
        msg_success_update: 'Statut de la réservation mis à jour avec succès !',
        msg_error_delete: 'Erreur lors de la suppression de la réservation !',
        msg_error_update: 'Erreur lors de la mise à jour du statut de la réservation !',
        msg_confirm_status_change:
          'Voulez-vous changer le statut de la réservation pour "{status}" ?',
        msg_confirm_checkin: "Voulez-vous effectuer l'arrivée pour cette réservation ?",
        msg_confirm_checkout: 'Voulez-vous finaliser le départ ? Cette action est irréversible.',
        msg_checkout_attention: '⚠️ ATTENTION - LISEZ ATTENTIVEMENT :',
        msg_checkout_list: [
          'Le client a déjà effectué le paiement',
          "Il n'y a pas de dettes financières",
          'Tous les services ont été dûment payés',
        ],
        msg_checkout_confirm_read:
          "J'ai lu et je confirme que toutes les validations ont été vérifiées",
        msg_checkout_validation:
          'Vous devez confirmer que vous avez lu et vérifié toutes les validations avant de continuer.',
        msg_confirm_delete: 'Supprimer la Réservation',
        tab_basic: 'Informations de base',
        tab_summary: 'Résumé',
        tab_activities: 'Activités',
        tab_tours: 'Excursions',
        tab_experiences: 'Expériences',
        tab_services: 'Réservations de Services',
        tab_services_list: 'Liste des Services',
        tab_orders: "Commandes de l'Hôtel",
        label_loading: 'Chargement...',
        label_loading_orders: 'Chargement des commandes...',
        label_order_details: 'Détails de la Commande',
        label_no_data: 'Aucune commande trouvée',
        label_pending: "Aucune commande n'est réservée pour le moment.",
        tab_title: "Commandes de l'Hôtel",
        label_order: 'Commande',
        label_orders: 'Commandes',
        label_total_spent: 'Total Dépensé : {value}',
        label_total_orders: 'Total des Commandes',
        label_total_spent_label: 'Total Dépensé',
        label_total_paid_label: 'Total Payé',
        label_products: 'Produits',
        label_quantity: 'Quantité',
        label_sku: 'SKU',
        label_delivery: 'Livraison',
        label_delivery_address: 'Adresse de Livraison',
        label_withdraw_address: 'Adresse de Retrait',
        label_financial_summary: 'Résumé Financier',
        label_products_label: 'Produits',
        label_delivery_fee: 'Frais de Livraison',
        label_discount: 'Remise',
        label_total: 'Total',
        label_payment_na: 'Paiement N/A',
        label_payment_offline: 'Paiement Hors Ligne',
        label_payment_card: 'Paiement par Carte',
        label_payment_credit: 'Crédit',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Informations de Base',
          label_customer: 'Client',
          label_room: 'Chambre',
          label_checkin: 'Arrivée',
          label_checkout: 'Départ',
          label_status: 'Statut',
          label_price: 'Valeur',
          label_notes: 'Observations',
          placeholder_notes: 'Ajoutez des observations sur la réservation',
          status_edit_warning:
            'Le statut de la réservation ne peut pas être modifié après confirmation ou annulation.',
          selected_room_details:
            'Chambre {roomNumber} - {type} (Capacité : {capacity}) - R$ {price}',
          selected_customer_details: 'Client : {name} | Email : {email} | Téléphone : {phone}',
          optional_checkout: 'Le départ est facultatif et peut être rempli ultérieurement.',
          status_pending: 'En attente',
          status_confirmed: 'Confirmée',
          status_in_progress: 'En cours',
          status_completed: 'Terminée',
          status_cancelled: 'Annulée',
          summary_capacity: 'Capacité',
          summary_people: 'personnes',
          btn_change_password: 'Changer le Mot de passe',
        },
        summary: {
          tab_title: 'Résumé',
          room_details: 'étails de la Chambre',
          label_total: 'Total',
          label_paid: 'Payé',
          label_pending: 'En attente',
          label_services: 'Services',
          label_products: 'Produits',
          label_activities: 'Activités',
          label_experiences: 'Expériences',
          label_tours: 'Excursions',
          label_room: 'Chambre',
          label_customer: 'Client',
          label_checkin: 'Arrivée',
          label_checkout: 'Départ',
          label_status: 'Statut',
          label_price: 'Valeur',
          label_notes: 'Observations',
          label_capacity: 'Capacité',
          label_people: 'Personnes',
          label_orders: "Commandes de l'Hôtel",
          label_payment_method: 'Méthode de Paiement',
          label_discount: 'Remise',
          label_tax: 'Taxe',
          label_total_with_tax: 'Total avec Taxe',
          label_total_with_discount: 'Total avec Remise',
          label_total_paid: 'Total Payé',
          label_total_pending: 'Total en Attente',
          label_summary: 'Résumé de la Réservation',
          label_details: 'Détails',
          label_edit: 'Modifier',
          label_delete: 'Supprimer',
          label_confirm: 'Confirmer',
          label_cancel: 'Annuler',
          label_no_data: 'Aucune donnée disponible',
          label_success: 'Opération effectuée avec succès !',
          label_error: "Erreur dans l'opération !",
          label_warning: 'Attention',
          label_info: 'Information',
          label_actions: 'Actions',
          label_service: 'Service',
          label_product: 'Produit',
          label_activity: 'Activité',
          label_experience: 'Expérience',
          label_tour: 'Excursion',
          label_order: 'Commande',
          label_date: 'Date',
          label_time: 'Heure',
          label_type: 'Type',
          label_edit_reservation: 'Modifier la Réservation',
          label_delete_reservation: 'Supprimer la Réservation',
          label_confirm_reservation: 'Confirmer la Réservation',
          label_cancel_reservation: 'Annuler la Réservation',
          label_status_confirmed: 'Confirmée',
          label_status_in_progress: 'En cours',
          label_status_completed: 'Terminée',
          label_status_cancelled: 'Annulée',
          label_status_no_show: 'Non Présenté',
          label_status_pending: 'En attente',
        },
        activities: {
          tab_title: 'Activités',
          label_activity: 'Activité',
          label_activities: 'Activités',
          label_no_data: 'Aucune activité trouvée',
          label_pending: "Aucune activité n'est réservée pour le moment.",
          label_people: 'Participants',
          label_category: 'Catégorie',
          label_location: 'Localisation',
          label_session_time: 'Heure de la Session',
          label_skill_level: 'Niveau de Compétence',
          label_special_requests: 'Demandes Spéciales',
          label_price: 'Valeur',
          label_date: 'Date',
          label_time: 'Heure',
          label_status: 'Statut',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmé',
          status_pending: 'En attente',
          status_cancelled: 'Annulé',
          status_completed: 'Terminé',
          btn_add_activity: 'Ajouter une Activité',
        },
        experiences: {
          tab_title: 'Expériences',
          label_experience: 'Expérience',
          label_experiences: 'Expériences',
          label_no_data: 'Aucune expérience trouvée',
          label_pending: "Aucune expérience n'est réservée pour le moment.",
          label_people: 'Participants',
          label_category: 'Catégorie',
          label_location: 'Localisation',
          label_session_time: 'Heure de la Session',
          label_skill_level: 'Niveau de Compétence',
          label_special_requests: 'Demandes Spéciales',
          label_price: 'Valeur',
          label_date: 'Date',
          label_time: 'Heure',
          label_status: 'Statut',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmé',
          status_pending: 'En attente',
          status_cancelled: 'Annulé',
          status_completed: 'Terminé',
          btn_add_experience: 'Ajouter une Expérience',
          label_duration: 'Durée',
          label_rating: 'Note',
          label_special_occasion: 'Occasion Spéciale',
          label_includes: 'Inclut',
        },
        hotel_orders: {
          tab_title: "Commandes de l'Hôtel",
          label_order: 'Commande',
          label_orders: 'Commandes',
          label_no_data: 'Aucune commande trouvée',
          label_pending: "Aucune commande n'est réservée pour le moment.",
          label_delivery: 'Livraison',
          label_quantity: 'Quantité',
          label_sku: 'SKU',
          label_delivery_address: 'Adresse de Livraison',
          label_withdraw_address: 'Adresse de Retrait',
          label_financial_summary: 'Résumé Financier',
          label_products: 'Produits',
          label_products_label: 'Produits',
          label_total_spent: 'Total Dépensé : {value}',
          label_total_orders: 'Total des Commandes',
          label_total_spent_label: 'Total Dépensé',
          label_total_paid_label: 'Total Payé',
          label_discount: 'Remise',
          label_total: 'Total',
          label_payment_na: 'Paiement N/A',
          label_payment_offline: 'Paiement Hors Ligne',
          label_payment_card: 'Paiement par Carte',
          label_payment_credit: 'Crédit',
          label_delivery_fee: 'Frais de Livraison',
          no_order_title: 'Aucune Commande Trouvée',
        },
        tours: {
          tab_title: 'Excursions',
          label_tour: 'Excursion',
          label_tours: 'Excursions',
          label_no_data: 'Aucune excursion trouvée',
          label_pending: "Aucune excursion n'est réservée pour le moment.",
          label_people: 'Participants',
          label_duration: 'Durée',
          label_difficulty: 'Difficulté',
          label_rating: 'Note',
          label_transfer_included: 'Transfert Inclus',
          label_transfer_yes: 'Transfert Inclus',
          label_transfer_no: 'Sans Transfert',
          label_schedule: 'Horaire',
          label_weather_concerns: 'Préoccupations Météorologiques',
          label_physical_requirements: 'Exigences Physiques',
          label_special_requests: 'Demandes Spéciales',
          label_price: 'Valeur',
          label_date: 'Date',
          label_time: 'Heure',
          label_status: 'Statut',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmé',
          status_pending: 'En attente',
          status_cancelled: 'Annulé',
          status_completed: 'Terminé',
          btn_add_tour: 'Ajouter une Excursion',
        },
        services: {
          title: 'Réservations de Services',
          subtitle: 'Détails des services réservés',
          no_services: 'Aucun service réservé',
          service_info: 'Informations sur le Service',
          service_name: 'Nom du Service',
          service_type: 'Type de Service',
          description: 'Description',
          room_info: 'Informations sur la Chambre',
          room_number: 'Chambre',
          booking_details: 'Détails de la Réservation',
          status: 'Statut',
          check_in: 'Arrivée',
          check_out: 'Départ',
          guest_name: 'Nom du Client',
          reservation_name: 'Nom de Réservation',
          number_of_rooms: 'Nº de Chambres',
          number_of_guests: 'Nº de Clients',
          adults: 'Adultes',
          children: 'Enfants',
          total_price: 'Prix Total',
          price_per_night: 'Prix par Nuit',
          nights: 'Nuits',
          additional_info: 'Informations Supplémentaires',
          booking_date: 'Date de Réservation',
          reservation_code: 'Code de Réservation',
          payment_status: 'Statut de Paiement',
          special_requests: 'Demandes Spéciales',
          service_details: 'Détails du Service',
          view_details: 'Voir les Détails',
          total_services: 'Total des Services',
          active_services: 'Services Actifs',
          pending_services: 'Services en Attente',
          completed_services: 'Services Terminés',
          service_image: 'Image du Service',
          no_image: 'Aucune image disponible',
        },
        services_list: {
          title: 'Liste des Services',
          subtitle: 'Tous les services réservés',
          search_placeholder: 'Rechercher par nom, chambre ou client...',
          filter_all: 'Tous',
          filter_active: 'Actifs',
          filter_pending: 'En Attente',
          filter_completed: 'Terminés',
          table_service_name: 'Service',
          table_service_type: 'Type',
          table_room: 'Chambre',
          table_guest: 'Client',
          table_checkin: 'Arrivée',
          table_checkout: 'Départ',
          table_status: 'Statut',
          table_price: 'Prix',
          table_actions: 'Actions',
          status_active: 'Actif',
          status_pending: 'En Attente',
          status_completed: 'Terminé',
          status_cancelled: 'Annulé',
          no_services: 'Aucun service trouvé',
          no_services_desc: 'Aucun service ne correspond à vos critères',
          showing: 'Affichage',
          of: 'de',
          services: 'services',
          items_per_page: 'Éléments par page',
          page: 'Page',
          previous: 'Précédent',
          next: 'Suivant',
          view_details: 'Voir les Détails',
          total_found: 'Total trouvé',
          active_filters: 'Filtres actifs',
          clear_filters: 'Effacer les filtres',
          filter_by_status: 'Filtrer par statut',
          search_active: 'Recherche active',
          rooms: 'chambres',
          guests: 'clients',
          nights: 'nuits',
          loading: 'Chargement des services...',
          error: 'Erreur lors du chargement des services',
          retry: 'Réessayer',
          export: 'Exporter',
          refresh: 'Actualiser',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Numéro de Chambre *',
        image: 'Image de la Chambre',
        placeholder_room_number: 'Ex: 101, A201, Suite Présidentielle',
        max_20_chars: 'Maximum 20 caractères',
        label_status: 'Statut',
        label_capacity: 'Capacité (personnes)',
        placeholder_capacity: 'Ex: 2',
        label_price: 'Prix (R$)',
        placeholder_price: 'Ex: 150.00',
        label_type: 'Type de Chambre',
        title: "Chambres d'Hôtel",
        subtitle: "Gestion des chambres de l'hôtel",
        create_multiples: 'Créer Plusieurs Chambres',
        add_room: 'Ajouter une Chambre',
        header_number: 'Numéro',
        header_status: 'Statut',
        header_type: 'Type',
        header_capacity: 'Capacité',
        header_price: 'Prix',
        header_actions: 'Actions',
        action_edit: 'Modifier la Chambre',
        action_delete: 'Supprimer la Chambre',
        modal_bulk_title: 'Créer Plusieurs Chambres',
        modal_bulk_prefix: 'Préfixe (facultatif)',
        modal_bulk_prefix_placeholder: 'Ex: A, B, 1er',
        modal_bulk_start: 'Numéro Initial *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Numéro Final *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Capacité',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Prix',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Type',
        type_single: 'Simple',
        type_double: 'Double',
        type_twin: 'Lits Jumeaux',
        type_queen: 'Queen',
        type_king: 'King',
        type_suite: 'Suite',
        type_junior_suite: 'Suite Junior',
        type_master_suite: 'Suite Master',
        type_presidential: 'Présidentielle',
        type_family: 'Familiale',
        type_accessible: 'Accessible',
        modal_bulk_cancel: 'Annuler',
        modal_bulk_create: 'Créer des Chambres',
        breadcrumb_dashboard: 'Tableau de bord',
        breadcrumb_hotel_room: "Chambres d'Hôtel",
        create_title: "Créer une Chambre d'Hôtel",
        create_subtitle: "Ajouter une nouvelle chambre à l'hôtel",
        edit_title: "Modifier la Chambre d'Hôtel",
        edit_subtitle: 'Modifier les informations de la chambre #{room}',
        breadcrumb_create: 'Créer Chambre',
        breadcrumb_edit: 'Modifier Chambre',
      },
      hospitality_experiences: {
        tab_basic: 'Informations de Base',
        edit: "Modifier l'Expérience",
        edit_subtitle: "Mettre à jour l'information de l'expérience",
        create: 'Créer une Expérience',
        create_subtitle: 'Remplissez les détails pour créer une nouvelle expérience',
        tab_details: 'Éléments détaillés',
        tab_image: 'Image',
        tab_schedules: 'Horaires',
        list_title: "Expériences de l'Hôtel",
        list_subtitle: "Gérez toutes les expériences de l'hôtel",
        field_title: 'Titre',
        field_title_placeholder: 'Ex: Dîner Romantique Exclusif',
        field_description: 'Description',
        field_description_placeholder: "Décrivez l'expérience offerte en détail...",
        field_image: 'Nouvelle Image',
        field_price: 'Prix (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Durée',
        field_duration_placeholder: 'Ex: 2 heures',
        field_type: "Type d'Expérience",
        field_rating: 'Note (0-5)',
        field_rating_placeholder: '0',
        field_status: 'Statut Actif',
        field_includes: 'Éléments Inclus',
        field_includes_placeholder: 'Ex: Champagne, décoration spéciale...',
        field_show_additional_services: 'Afficher les options de services prédéfinies',
        field_actions: 'Actions',
        status_active: 'Actif',
        status_inactive: 'Inactif',
        no_rating: 'Sans évaluation',
        no_includes: 'Aucun élément inclus',
        currency: 'R$',
        btn_add: 'Ajouter une Expérience',
        btn_edit: 'Modifier',
        btn_delete: 'Supprimer',
        btn_update: "Mettre à jour l'Expérience",
        btn_create: 'Créer une Expérience',
        btn_remove: 'Supprimer',
        btn_add_item: 'Ajouter un Élément',
        edit_title: "Modifier l'Expérience",
        create_title: 'Créer une Expérience',
        msg_success_create: 'Expérience créée avec succès !',
        msg_success_update: 'Expérience mise à jour avec succès !',
        msg_success_delete: 'Expérience supprimée',
        msg_success_delete_text: 'Expérience supprimée avec succès !',
        msg_error_create: "Erreur lors de la création de l'expérience",
        msg_error_update: "Erreur lors de la mise à jour de l'expérience",
        msg_error_delete: "Erreur lors de la suppression de l'expérience",
        msg_error_delete_text: "Impossible de supprimer l'expérience !",
        msg_error_load: "Erreur lors du chargement de l'expérience",
        msg_error_load_text: "Impossible de charger les données de l'expérience !",
        msg_error_required_title: 'Le titre est obligatoire !',
        msg_error_title_length: 'Le titre doit avoir au maximum 255 caractères !',
        msg_error_required_description: 'La description est obligatoire !',
        msg_error_required_price: 'Le prix est obligatoire !',
        msg_error_price_negative: 'Le prix doit être supérieur ou égal à zéro !',
        msg_error_required_duration: 'La durée est obligatoire !',
        msg_error_duration_length: 'La durée doit avoir au maximum 100 caractères !',
        msg_error_required_includes: 'Au moins un élément doit être inclus !',
        msg_error_rating_range: 'La note doit être comprise entre 0 et 5 !',
        field_order: 'Ordre',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Ordre',
        msg_error_order_negative: "L'ordre doit être supérieur ou égal à zéro !",
      },
      entertainment_services: {
        list_title: 'Services de Divertissement',
        list_subtitle: 'Gérer les services de divertissement disponibles',
        create: 'Créer un Service de Divertissement',
        create_subtitle: 'Remplissez les détails pour créer un nouveau service',
        create_title: 'Créer un Service de Divertissement',
        edit: 'Modifier le Service de Divertissement',
        edit_subtitle: 'Mettre à jour les informations du service',
        edit_title: 'Modifier le Service de Divertissement',
        field_title: 'Titre',
        field_title_placeholder: 'Ex: Spa et Massage',
        field_type: 'Type de Service',
        field_status: 'Statut Actif',
        field_actions: 'Actions',
        type_experience: 'Expérience de Divertissement',
        type_activity: 'Activité de Divertissement',
        type_tour: 'Tour de Divertissement',
        status_active: 'Actif',
        status_inactive: 'Inactif',
        btn_add: 'Ajouter un Service',
        btn_edit: 'Modifier',
        btn_delete: 'Supprimer',
        btn_update: 'Mettre à Jour le Service',
        btn_create: 'Créer un Service',
        btn_search: 'Rechercher',
        btn_clear: 'Effacer',
        search_placeholder: 'Rechercher par titre...',
        msg_success_create: 'Service créé avec succès !',
        msg_success_update: 'Service mis à jour avec succès !',
        msg_success_delete: 'Service supprimé',
        msg_success_delete_text: 'Service supprimé avec succès !',
        msg_error_create: 'Erreur lors de la création du service',
        msg_error_update: 'Erreur lors de la mise à jour du service',
        msg_error_delete: 'Erreur lors de la suppression du service',
        msg_error_delete_text: 'Impossible de supprimer le service !',
        msg_error_load: 'Erreur lors du chargement du service',
        msg_error_load_text: 'Impossible de charger les données du service !',
        msg_error_required_title: 'Le titre est obligatoire !',
        msg_error_title_length: 'Le titre doit comporter au maximum 255 caractères !',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'Réservations de Services',
          details_title: 'Détails de la Réservation',
          cancel_title: 'Annuler la Réservation',
          cancel_reason_label: "Motif de l'Annulation *",
          cancel_reason_placeholder: "Sélectionnez le motif de l'annulation",
          cancel_reason_select: 'Sélectionnez un motif',
          type_tour: 'Excursion',
          type_experience: 'Expérience',
          type_activity: 'Activité',
          type_room_service: 'Service de Chambre',
          status_pending: 'En attente',
          status_confirmed: 'Confirmée',
          status_cancelled: 'Annulée',
          status_completed: 'Terminée',
          error_title: 'Erreur',
          error_load: 'Erreur lors du chargement des réservations !',
          error_details: 'Erreur lors du chargement des détails de la réservation !',
          error_cancel: "Erreur lors de l'annulation de la réservation !",
          success_title: 'Succès',
          success_cancel: 'Réservation annulée avec succès !',
          warning_title: 'Attention',
          warning_cancel_reason: "Veuillez sélectionner un motif d'annulation.",
          no_details: 'Détails spécifiques non disponibles pour ce type de réservation.',
          reasons_tour: [
            'Changement de plans',
            'Problèmes climatiques',
            "Conflit d'horaire",
            'Raisons de santé',
            "Annulation de l'hôtel",
          ],
          reasons_experience: [
            'Changement de date de séjour',
            'Occasion spéciale annulée',
            "Conflit d'agenda",
            'Raisons personnelles',
            'Préférence pour un autre service',
          ],
          reasons_activity: [
            'Je ne me sens pas prêt(e)',
            "Conflit d'horaire",
            'Problèmes de santé',
            'Changement de plans',
            "L'activité ne répond pas aux attentes",
          ],
          reasons_room_service: [
            'Changement de plans',
            'Service non nécessaire',
            "Conflit d'horaire",
            'Raisons personnelles',
            'Préférence pour un autre service',
          ],
        },
        create_title: "Créer une Activité d'Hôtel",
        create_subtitle: "Ajouter une nouvelle activité à l'hôtel",
        edit_title: "Modifier l'Activité d'Hôtel",
        edit_subtitle: "Mettre à jour les informations de l'activité",
        list_title: "Activités de l'Hôtel",
        list_subtitle: 'Gestion des activités et du divertissement',
        field_title: "Titre de l'Activité *",
        field_title_placeholder: 'Ex: Cours de Yoga, Spectacle Musical, Loisirs Enfants',
        field_title_hint: 'Maximum 255 caractères',
        field_time: 'Heure *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Tous les jours à 15h',
        field_time_hint: 'Maximum 100 caractères',
        field_description: 'Description *',
        field_description_placeholder:
          "Décrivez l'activité en détail, ses avantages et ce que les clients peuvent attendre...",
        field_image: "Image de l'Activité",
        field_location: 'Localisation *',
        field_location_placeholder: 'Ex: Piscine principale, Salle de réception, Plage',
        field_location_hint: 'Maximum 255 caractères',
        field_capacity: 'Capacité *',
        field_capacity_placeholder: 'Ex: 20, si 0 est illimité',
        field_capacity_hint: 'Maximum 50 caractères',
        field_period: 'Période *',
        field_period_placeholder: 'Ex: 00:15 ou 01:00 ou 00:30',
        field_category: 'Catégorie *',
        field_age_group: "Groupe d'Âge",
        field_price: 'Prix (R$)',
        field_price_placeholder: '0.00 (laissez vide si gratuit)',
        field_price_hint: 'Laissez vide pour une activité gratuite',
        field_requires_reservation: 'Nécessite une Réservation',
        field_requires_reservation_hint: "Cochez si l'activité nécessite une réservation préalable",
        field_is_active: 'Activité Active',
        field_is_active_hint: "Décochez pour désactiver temporairement l'activité",
        btn_edit: "Modifier l'Activité",
        btn_delete: "Supprimer l'Activité",
        btn_create: 'Créer une Activité',
        btn_cancel: 'Annuler',
        msg_success_create: 'Activité créée avec succès !',
        msg_success_update: 'Activité mise à jour avec succès !',
        msg_success_delete: 'Activité supprimée avec succès !',
        msg_error_create: "Erreur lors de la création de l'activité !",
        msg_error_update: "Erreur lors de la mise à jour de l'activité !",
        msg_error_delete: "Erreur lors de la suppression de l'activité !",
        msg_error_load: "Erreur lors du chargement de l'activité !",
        msg_error_required_title: 'Le titre est obligatoire !',
        msg_error_title_length: 'Le titre doit avoir au maximum 255 caractères !',
        msg_error_required_description: 'La description est obligatoire !',
        msg_error_required_time: "L'heure est obligatoire !",
        msg_error_time_length: "L'heure doit avoir au maximum 100 caractères !",
        msg_error_required_location: 'La localisation est obligatoire !',
        msg_error_location_length: 'La localisation doit avoir au maximum 255 caractères !',
        msg_error_required_capacity: 'La capacité est obligatoire !',
        msg_error_capacity_length: 'La capacité doit avoir au maximum 50 caractères !',
        msg_error_price_negative: 'Le prix doit être supérieur ou égal à zéro !',
        remove_schedule: "Supprimer l'Horaire",
        confirm_remove_schedule: 'Êtes-vous sûr de vouloir supprimer cet horaire ?',
        schedule_seasonal_start: 'Début de Saison',
        schedule_seasonal_end: 'Fin de Saison',
        schedule_start_time: 'Heure de Début',
        schedule_end_time: 'Heure de Fin',
        add_schedule: 'Ajouter un Horaire',
        schedule_time: 'Heure *',
        schedule_time_placeholder: 'Ex: 08:00 - 09:00, Tous les jours à 15h',
        schedule_description: 'Description *',
        schedule_days_of_week: 'Jours de la Semaine',
        schedule_status: 'Horaire Actif',
        schedule_seasonal_hint: 'Définissez une période saisonnière si applicable',
        field_duration_hint: 'Durée en heures et minutes (ex: 2h30min)',
        field_duration_placeholder: 'Durée en heures et minutes (ex: 2h30min)',
        field_order: 'Ordre',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        msg_error_order_negative: "L'ordre doit être supérieur ou égal à zéro !",
      },
      hotel_tour: {
        create_title: "Créer une Excursion d'Hôtel",
        create_subtitle: "Ajouter une nouvelle excursion à l'hôtel",
        edit_title: "Modifier l'Excursion d'Hôtel",
        edit_subtitle: "Mettre à jour les informations de l'excursion",
        list_title: "Excursions d'Hôtel",
        list_subtitle: 'Gérer les excursions et les visites',
        field_title: "Titre de l'Excursion *",
        field_difficulty: 'Difficulté',
        field_duration: 'Durée',
        field_rating: 'Note',
        field_participants: 'Participants',
        field_schedules: 'Horaires',
        field_includes: 'Inclus',
        field_transfer: 'Transfert',
        field_currency: 'Devise',
        field_currency_hint: 'Code de la devise (ex: BRL, USD)',
        currency_brl: 'Réal (BRL)',
        currency_usd: 'Dollar (USD)',
        currency_eur: 'Euro (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: 'Note de 0 à 5 étoiles',
        field_participants_min: 'Participants Minimums *',
        field_participants_min_hint: 'Nombre minimum de participants',
        field_participants_max: 'Participants Maximums',
        field_participants_max_placeholder: 'Laissez vide si illimité',
        field_participants_max_hint: 'Nombre maximum de participants (facultatif)',
        field_age_restriction: "Restriction d'Âge",
        field_age_restriction_placeholder:
          'Ex: Plus de 12 ans, Non recommandé pour les moins de 18 ans',
        field_age_restriction_hint: "Restrictions d'âge (facultatif)",
        field_physical_requirements: 'Exigences Physiques',
        field_physical_requirements_placeholder:
          'Ex: Bonne condition physique, Capacité de marcher de longues distances',
        field_physical_requirements_hint: 'Exigences physiques nécessaires (facultatif)',
        field_cancellation_hours: 'Annulation (heures) *',
        field_cancellation_hours_hint: "Heures avant pour l'annulation",
        field_discount_children: 'Remise Enfants (%)',
        field_discount_children_hint: 'Remise en pourcentage',
        field_weather_dependent: 'Dépend du Climat',
        field_weather_dependent_hint: 'Cochez si cela dépend des conditions climatiques',
        field_is_active: 'Excursion Active',
        field_is_active_hint: 'Décochez pour désactiver temporairement',
        tab_basic: 'Informations de Base',
        tab_details: 'Détails et Configurations',
        tab_schedules: 'Horaires',
        tab_includes: 'Éléments Inclus',
        tab_image: 'Image',
        no_schedule_added: 'Aucun horaire ajouté',
        click_add_schedule: 'Cliquez sur "Ajouter un Horaire" pour commencer.',
        includes_title: "Éléments Inclus dans l'Excursion",
        selected: 'Sélectionnés',
        field_image_hint: "Sélectionnez une image représentative de l'excursion",
        update_info: "Mettre à jour les informations de l'excursion",
        field_title_placeholder:
          'Ex: Visite de la Ville, Excursion à la Plage, Randonnée Historique',
        field_title_hint: 'Maximum 255 caractères',
        field_time: 'Heure *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Tous les jours à 15h',
        field_time_hint: 'Maximum 100 caractères',
        field_description: 'Description *',
        field_description_placeholder:
          "Décrivez l'excursion, les points forts et ce que les clients peuvent attendre...",
        field_image: "Image de l'Excursion",
        field_location: 'Localisation *',
        field_location_placeholder: 'Ex: Centre, Plage, Musée',
        field_location_hint: 'Maximum 255 caractères',
        field_capacity: 'Capacité *',
        field_capacity_placeholder: 'Ex: 20 personnes, Illimité, 10-15 participants',
        field_capacity_hint: 'Maximum 50 caractères',
        field_category: 'Catégorie *',
        field_price: 'Prix (R$)',
        field_price_placeholder: '0.00 (laissez vide si gratuit)',
        field_price_hint: 'Laissez vide pour une excursion gratuite',
        field_requires_reservation: 'Nécessite une Réservation',
        field_requires_reservation_hint:
          "Cochez si l'excursion nécessite une réservation préalable",
        btn_edit: "Modifier l'Excursion",
        btn_delete: "Supprimer l'Excursion",
        btn_create: 'Créer une Excursion',
        btn_cancel: 'Annuler',
        table_title: 'Titre',
        table_time: 'Heure',
        table_location: 'Localisation',
        table_category: 'Catégorie',
        table_price: 'Prix',
        table_capacity: 'Capacité',
        table_actions: 'Actions',
        msg_success_create: 'Excursion créée avec succès !',
        msg_success_update: 'Excursion mise à jour avec succès !',
        msg_success_delete: 'Excursion supprimée avec succès !',
        msg_error_create: "Erreur lors de la création de l'excursion !",
        msg_error_update: "Erreur lors de la mise à jour de l'excursion !",
        msg_error_delete: "Erreur lors de la suppression de l'excursion !",
        msg_error_load: "Erreur lors du chargement de l'excursion !",
        msg_error_required_title: 'Le titre est obligatoire !',
        msg_error_title_length: 'Le titre doit avoir au maximum 255 caractères !',
        msg_error_required_description: 'La description est obligatoire !',
        msg_error_required_time: "L'heure est obligatoire !",
        msg_error_time_length: "L'heure doit avoir au maximum 100 caractères !",
        msg_error_required_location: 'La localisation est obligatoire !',
        msg_error_location_length: 'La localisation doit avoir au maximum 255 caractères !',
        msg_error_required_capacity: 'La capacité est obligatoire !',
        msg_error_capacity_length: 'La capacité doit avoir au maximum 50 caractères !',
        msg_error_price_negative: 'Le prix doit être supérieur ou égal à zéro !',
        schedule_start_time: 'Heure de Début',
        schedule_end_time: 'Heure de Fin',
        add_schedule: 'Ajouter un Horaire',
        schedule_time: 'Heure *',
        schedule_time_placeholder: 'Ex: 08:00 - 09:00, Tous les jours à 15h',
        schedule_description: 'Description *',
        schedule_days_of_week: 'Jours de la Semaine',
        schedule_status: 'Horaire Actif',
        schedule_seasonal_hint: 'Définissez une période saisonnière si applicable',
        field_duration_hint: 'Durée en heures et minutes (ex: 2h30min)',
        field_duration_placeholder: 'Durée en heures et minutes (ex: 2h30min)',
        schedule_seasonal_start: 'Début de Saison',
        schedule_seasonal_end: 'Fin de Saison',
        difficult: {
          easy: 'Facile',
          medium: 'Modérée',
          hard: 'Difficile',
          extreme: 'Extrême',
        },
        field_order: 'Ordre',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Ordre',
        msg_error_order_negative: "L'ordre doit être supérieur ou égal à zéro !",
      },
      months: {
        jan: 'Jan',
        feb: 'Fév',
        mar: 'Mar',
        apr: 'Avr',
        may: 'Mai',
        jun: 'Juin',
        jul: 'Juil',
        aug: 'Aoû',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Déc',
      },
      permissions: {
        color_variations: 'Variations de Couleur',
        food: 'Smart Order',
        content: 'Interface Webapp',
        buttons: 'Boutons',
        sessions: 'Sessions',
        smartorder: 'Gestion des Produits',
        category: 'Catégories',
        subcategory: 'Sous-catégories',
        product: 'Produits',
        mark: 'Marques',
        grid: 'Grilles',
        variation: 'Variations',
        catalog: 'Catalogues',
        integration: 'Intégrations',
        int_pos: 'PDV',
        int_gateway: 'Moyen de Paiement',
        messaging: 'Messagerie',
        sms: 'Statut et SMS',
        multichannel: 'Multicanal',
        report: 'Rapports',
        saleorder: 'Commandes',
        indicators: 'Indicateurs',
        orderReport: 'Commandes',
        imports: "Importation d'Images",
        importProductImage: 'Produits',
        importProductImageSKU: 'Variations',
        importCategoryImage: 'Catégories',
        customers: 'Clients',
        customer_report: 'Liste de Clients',
        measurement_unit: 'Unités de Mesure',
        logs: 'Logs',
        settings: 'Paramètres',
        charge_integration: 'Charges',
        summaryAccess: 'Accès',
        sellerAccess: 'Tableau de Bord Vendeur',
        managerAccess: 'Tableau de Bord Gestionnaire',
        managerGroupAccess: 'Tableau de Bord Gestionnaire de Groupe',
        orders: 'Commandes',
        support: 'Support',
        translate: 'Langues et Relations',
        featuresPluginspace: 'Pluginspace Fonctionnalités',
        application: 'Webapp',
        messenger: 'Messagerie',
        others: 'Autres',
        settings_store: 'Paramètres du Magasin',
        settings_hotel: 'Paramètres ',
        modalities: 'Modalités',
        delivery_tax: 'Frais de livraison',
        shifts: 'Quarts',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'Gestionnaire de Fichiers',
        payment_plans: 'Plans de Paiement',
        settings_account: 'Paramètres du Compte',
        account: 'Compte',
        groups: 'Groupes',
        users: 'Utilisateurs',
        terms: 'Termes',
        highlights: 'Mises en avant',
        menu: 'Menu',
        productReport: 'Produits',
        optional: "Liste d'Articles Additionnels",
        locations: 'Secteurs',
        stores_location: 'Établissements',
        message_hotel: 'Statut et Notification',
        service: 'Services',
        service_items: 'Services',
        service_category: 'Catégories',
        feed: "Fil d'actualité",
        structured_content: 'Services Essentiels',
        orders_room_service: 'Commandes de Chambre',
        orders_activities: "Commandes d'Activités",
        seller: 'Vendeur',
        queue: "File d'attente",
        queue_config: 'Configurations',
        queue_manager: 'Gestion',
        reason: 'Raison',
        seller_queue_config: 'Configuration de la File du Vendeur',
        checkout: 'Données du Client',
        booking: 'Réservation',
        booking_management: 'Gestion',
        booking_config: 'Configurations',
        booking_environment: 'Environnements',
        booking_day: 'Réservations du jour',
        booking_report: 'Rapports',
        booking_managerday: 'Gestion des Réservations du Jour',
        booking_management_dashboard: 'Tableau de Bord de la Gestion des Réservations',
        table_management: 'Gestion des Tables',
        table_allocation_report: "Rapport d'Allocation des Tables",
        table_management_dashboard: 'Tableau de Bord de la Gestion des Tables',
        liveShop: 'Live Commerce',
        icon_library: "Bibliothèque d'Icônes",
        stores: 'Établissements',
        segments: 'Segments',
        payment: 'Paiements',
        serviceCategory: 'Catégorie de Service',
        SDS: 'KDS',
        sds_manage: 'Mes KDS',
        sds_layout: 'Personnalisation',
        sds_link: 'Configurations',
        sds_display: 'Écrans',
        /* Agregador */
        config: 'Configurations',
        config_account: 'Données du compte',
        config_sector: "Secteur d'activité",
        config_user: 'Utilisateurs',
        config_term: 'Termes',
        subCategory: 'Sous-catégorie',
        footer: 'Ressources du pied de page',
        footerFeature: 'Activer les ressources',
        footerContent: "Fil d'actualité des ressources",
        footerContentAddEdit: 'Ressources',
        webapp: 'Personnaliser',
        webapp_qrcode: 'Générer un Code QR',
        ia_menu: 'Intelligence Artificielle',
        ia_config: 'Configurations',
        ia_fit: 'Entraînement',
        ia_file_manager: 'Gestionnaire de Fichiers',
        ia_folders: 'Dossiers',
        ia_files: 'Fichiers',
        ia_settings: 'Paramètres',
        ia_folders_blank: 'Aucun dossier trouvé',
        ia_filter: 'Filtrer',
        ia_recharge: 'Recharger',
        ia_final_date: 'Date de Fin',
        ia_initial_date: 'Date de Début',
        summarize: 'Tableau de bord',
        consumption: 'Consommation IA',
        ct_account: 'Consommation et Valeur',
        ct_s3_account: 'Compte S3',
        ct_data_cost_account: 'Données et Coûts',
        publication_highlight_banner: 'Bannière Mise en avant',
        publication: 'Publicité',
        cost: 'Coûts',
        security_settings: 'Paramètres de sécurité',
        coupon: 'Coupon',
        clean_safe: 'Clean & Safe',
        service_requests: 'Formulaires de Service',
        grid_hotel: 'Grille de Services',
        /*Hotelaria */
        hotel_maintenance: 'Maintenance',
        hotel_room: 'Chambre',
        hotel_reservation: 'Réservations de Chambre',
        hotel_activities_experiences: 'Activités et Expériences',
        hotel_activities: 'Activités',
        hotel_tour: "Excursions d'Hôtel",
        hotel_tour_schedules: "Horaires d'Excursions d'Hôtel",
        hotel_tour_reservation: 'Réservations Générales',
        hotel_experiences: 'Expériences',
        hotel_info: 'Informations',
        hotel_reservations: 'Réservations',
        hotel_schedules: "Programme de l'Hôtel",
        publication_banner: 'Bannière',
        feed_back: 'Rétroaction et Satisfaction',
        feed_back_results: 'Résultats',
        feed_back_analytics: 'Analyse de Sondage',
        feed_back_content: 'Formulaires de Rétroaction',
        feedback_satisfaction: 'Sondage et Satisfaction',
        grid_hotel_feedback: 'Grille',
        feedback_list: 'Formulaires',
        feedback: 'Rétroaction',
        feed_back_category: 'Catégorie de Rétroaction',
        post: 'Publications',
        post_category: 'Catégorie de Publications',
        post_content: 'Contenu de la Publication',
        booking_hotel: 'Gestion des Réservations',
        grid_hotel_booking: 'Grilles de Services',
        booking_config_hotel: 'Réservations de Services',
        page_publications: 'Page des Publications',
        communication: 'Communication',
        communicationCenter: 'Centre de Communication',
        hotel_management: "Gestion de l'Hôtel",
        hotel_management_entertainment: 'Divertissement',
        product_color_variations: 'Variations de Couleur',
        feedback_analytics: 'Analyse des Sondages',
        cashback: 'Cashback',
        cashback_list: 'Mouvements',
        cashback_config: 'Configurations',
        cashback_management: 'Gestion et Règles',
        cashback_report: 'Rapport',
        hotel_points: 'Points Hôtel',
        hotel_points_list: 'Mouvements',
        hotel_points_config: 'Configurations',
        hotel_points_management: 'Gestion et Règles',
        hotel_points_rewards: 'Récompenses',
        hotel_points_redemptions: 'Échanges',
        hotel_points_report: 'Rapport',
        pages_dinamic: 'Pages Dynamiques',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: 'Variations de Couleur',
        page_subtitle: 'Gérez les variations de couleur des produits',
        breadcrumb_dashboard: 'Tableau de bord',
        breadcrumb_workbench: 'Atelier de Couleur',

        // Mode Selection
        selectMode: 'Sélectionner le Mode',
        chooseProdutOrVariation: 'Choisissez de travailler avec un Produit ou une Variation',
        product: 'Produit',
        productDescription: 'Choisissez parmi les produits enregistrés de votre magasin',
        variation: 'Variation',
        variationDescription: 'Choisissez parmi les variations enregistrées',

        // Product/Variation Selection
        selectProduct: 'Sélectionnez un Produit',
        selectVariation: 'Sélectionnez une Variation',
        searchProduct: 'Rechercher un produit par nom ou code...',
        searchVariation: 'Rechercher une variation par SKU ou nom du produit...',
        noProductsFound: 'Aucun produit trouvé',
        noProductsMatchSearch: 'Aucun produit ne correspond aux critères de recherche',
        noVariationsFound: 'Aucune variation trouvée',
        noVariationsMatchSearch: 'Aucune variation ne correspond aux critères de recherche',
        noImagesFound: 'Aucune image trouvée pour ce produit/variation',
        description:
          'Sélectionnez un produit ou une variation pour commencer à créer des variations de couleurs personnalisées.',
        showingResults: 'Affichage',
        of: 'de',
        backButton: 'Retour',

        // Image and Color Selection
        selectImage: 'Sélectionnez une Image',
        selectColor: 'Sélectionnez une Couleur',
        colorDescription: 'Description (Optionnel)',
        descriptionPlaceholder: 'Décrivez le changement que vous souhaitez apporter...',
        selectImageFirst: "Veuillez d'abord sélectionner une image",
        processingError: 'Erreur lors du traitement de la variation',

        // Buttons
        generateVariation: 'Générer une Variation',
        processing: 'Traitement en cours...',
        processingTimeSeconds: '{time}s',

        // Preview
        selectedImagePreview: "Aperçu de l'Image Sélectionnée",
        resultPreview: 'Aperçu du Résultat',
        originalImage: 'Image Originale',
        processedImage: 'Image Traitée',
        targetColor: 'Couleur Cible',
        processingTime: 'Temps de Traitement',

        // Actions
        approveAndApply: 'Approuver et Appliquer',
        reject: 'Rejeter',
        applyVariation: 'Appliquer une Variation',
        applyTarget: 'Où souhaitez-vous appliquer cette variation?',

        // Apply Dialog
        createNewVariation: 'Créer une Nouvelle Variation',
        newVariationInfo: 'Une nouvelle variation sera créée avec cette image',
        replaceExistingVariation: 'Remplacer une Variation Existante',
        selectVariationToReplace: 'Sélectionnez la variation à remplacer',
        replaceProductImage: "Remplacer l'Image du Produit",
        selectProductToReplaceImage: 'Sélectionnez quelle image du produit sera remplacée',

        // Messages
        variationSavedSuccess: 'Variation enregistrée avec succès!',
        errorSavingVariation: "Erreur lors de l'enregistrement de la variation",
        successTitle: 'Succès',
        errorTitle: 'Erreur',
        warningTitle: 'Avertissement',

        // Dialog Buttons
        cancel: 'Annuler',
        save: 'Enregistrer',
        confirm: 'Confirmer',
        close: 'Fermer',
      },
      customer: {
        select_group: 'Sélectionnez un groupe',
        select: 'Sélectionner',
        create: 'Créer un client',
        create_group: 'Créer un groupe',
        edit: 'Voir le client',
        search_custom: 'Rechercher...',
        customer: 'Clients',
      },

      buttons: {
        create: 'Créer',
        back: 'Retour',
        previous: 'Précédent',
        register_pluginspace: 'Enregistrer Pluginspace',
        access: 'Accéder',
        add_modality: 'Ajouter une modalité',
        add_km: 'Ajouter Km',
        zip_code_list: 'Liste des Codes Postaux',
        add_zip_code: 'Ajouter un Code Postal',
        area: 'Zones de Livraison',
        list_of_negative_renge_zip_code: 'Liste des Codes Postaux négatifs',
        add_negative_zip_code: 'Ajouter un Code Postal négatif',
        add_user: 'Ajouter un utilisateur',
        generate_password: 'Générer un mot de passe',
        generate_sku: 'Générer un SKU',
        add_group: 'Ajouter un groupe',
        save: 'Sauvegarder',
        add_term: 'Ajouter un terme',
        add_integration: 'Ajouter une intégration',
        filter: 'Filtrer',
        search: 'Rechercher',
        register_product: 'Enregistrer un Produit',
        choose_files: 'Choisir les fichiers',
        add_categories: 'Ajouter des catégories',
        add_subcategories: 'Ajouter des sous-catégories',
        add_brand: 'Ajouter une marque',
        close: 'Fermer',
        add_grade: 'Ajouter une grille',
        add: 'Ajouter',
        add_variation: 'Ajouter une variation',
        confirm_grades: 'Confirmer les grilles',
        add_catalog: 'Ajouter un catalogue',
        generete_qr_code: 'Générer un Code QR',
        personalize: 'Personnaliser',
        settings: 'Paramètres',
        add_interval: 'Ajouter un intervalle',
        add_gateway: 'Ajouter une passerelle',
        overview: 'Aperçu',
        view: 'Voir',
        load_csv: 'Charger le fichier',
        download_csv: 'Télécharger le XLSX Standard',
        att_page: 'Actualiser la page',
        export: 'Exporter',
        add_service: 'Enregistrer un Service',
        add_environment: 'Ajouter un environnement',
        generate_ia: 'Proposer',
        clear_table_card: 'Effacer la table ou la commande',
        propose_image: 'Proposer une image',
        cancel: 'Annuler',
        next: 'Suivant',
      },

      global: {
        success: 'Succès',
        error: 'Erreur',
        warning: 'Attention',
        active: 'Actif',
        inactive: 'Inactif',
      },

      modals: {
        warning_confirm: 'Êtes-vous sûr ?',
        warning_save: 'Sauvegarder',
        warning_close: 'Fermer',
        text_close: 'Fermer',
      },

      general: {
        delete_item: 'Voulez-vous supprimer cet élément ?',
        delete_product_observation:
          'Les variations de ce produit seront également supprimées, souhaitez-vous continuer ?',
        delete_classification_observation:
          'En supprimant cette catégorie, tous les produits qui y sont liés iront dans Général, souhaitez-vous continuer ?',
        delete: 'Supprimer',
        edit: 'Modifier',
        duplicate: 'Dupliquer',
        attention: 'Attention',
        actions: 'Actions',
        select: 'Sélectionner',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Voici les éléments listés avec leurs actions respectives',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
        save_changes_edit:
          'Remplissez les informations ci-dessous et cliquez sur le bouton sauvegarder pour confirmer les modifications',
        save_changes_duplicate:
          'Validez ou modifiez les informations ci-dessous et cliquez sur le bouton sauvegarder pour confirmer les modifications',
        active: 'Actif',
        inactive: 'Inactif',
        showing: 'Affichage',
        of: 'de',
        to: 'à',
        records: 'enregistrements',
        type: 'Type',
        today: "Aujourd'hui",
        copy: 'Copier',
        linkS3: 'Lien',
        linkedS3: 'Lié',
        downloadS3: 'Télécharger',
        downloadedS3: 'Téléchargement Lancé',
        copied: 'Copié',
        copy_link: 'Copier le lien du vendeur',
        test: 'Tester',
        success: 'Succès',
        error: 'Erreur',
        email: 'E-mail',
        paymentFree: 'Gratuit',
        image_2mb_message: 'La taille du fichier dépasse 2MB. Veuillez sélectionner un fichier plus petit.',
      },

      pluginspaces: {
        hospitality: 'Hôtels',
        food: 'Restauration',
        healthcare: 'Santé',
        varejo: 'Détail',
        fashion: 'Mode',
      },

      dashboard: {
        totals_by_products: 'Totaux par produit',
        totals_by_category: 'Totaux par catégorie',
        last_orders: 'Dernières commandes',
        products: 'Produits',
        quantity: 'Quantité',
        total: 'Total',
        category: 'Catégorie',
        welcome: 'Bienvenue sur Ninegrid',
        describe_dashboard:
          'Ici, vous avez tous les outils pour gérer votre magasin de manière simple et efficace. Explorez les menus latéraux pour naviguer dans nos fonctionnalités. Bon travail !',
      },

      modalities: {
        modalities: 'Modalités',
        modalitie: 'Modalité',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Voici les modalités listées avec leurs actions respectives',
        delivery: 'Livraison',
        withdraw: 'Retrait',
        active: 'Actif',
        inactive: 'Inactif',
        name: 'Nom',
        code: 'Code',
        actions: 'Actions',
        search: 'Rechercher',
        type: 'Type',
        sector_name: 'Nom du secteur',
        table: 'Table',
        room: 'Chambre',
        counter: 'Comptoir',
        internal: 'Livraison Interne',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: 'Frais de livraison',
        create_delivery_fee: 'Créer des frais de livraison',
        edit_delivery_fee: 'Modifier les frais de livraison',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
        save_changes_edit:
          'Remplissez les informations ci-dessous et cliquez sur le bouton sauvegarder pour confirmer les modifications',
        km_min: 'Km Minimum',
        km_max: 'Km Maximum',
        value: 'Valeur',
        actions: 'Actions',
        patterns: "Modèles d'Importation",
        import_file:
          "Pour importer les fichiers, la première cellule du fichier doit suivre l'un des modèles suivants :",
        import_delivery: 'Pour importer par plage : kmmin, kmmax, Valeur',
        import_cep: 'Pour importer le Code Postal : cep_debut, cep_fin, valeur',
        import_cep_negative: 'Pour importer le Code Postal négatif : cep_debut, cep_fin',
        model: 'Modèle',
        continue_import:
          'Tous vos enregistrements seront remplacés, êtes-vous sûr de vouloir continuer ?',
        cep_delivery: 'Codes Postaux de Livraison',
        cep_info: 'Voici les Codes Postaux de livraison listés avec leurs actions respectives.',
        cep_start: 'Code Postal Début',
        cep_end: 'Code Postal Fin',
        create_cep: 'Créer des Codes Postaux de Livraison',
        edit_cep: 'Modifier les Codes Postaux de Livraison',
        cep_delivery_negative: 'Codes Postaux Négatifs de Livraison',
        cep_info_negative:
          'Voici les Codes Postaux négatifs de livraison listés avec leurs actions respectives.',
        create_cep_negative: 'Créer un Code Postal Négatif',
        edit_cep_negative: 'Modifier un Code Postal Négatif',
        delete_cep_negative: 'Supprimer un Code Postal Négatif',
      },

      user: {
        user: 'Utilisateurs',
        here_are_listed_the_users_along_with_their_respective_actions:
          'Voici les utilisateurs listés avec leurs actions respectives',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
        save_changes_edit:
          'Remplissez les informations ci-dessous et cliquez sur le bouton sauvegarder pour confirmer les modifications',
        picture: 'Photo',
        name: 'Nom',
        type: 'Type',
        registration: 'Enregistrement',
        create_user: 'Créer un utilisateur',
        edit_user: "Modifier l'utilisateur",
        profile_picture: 'Image de profil',
        password: 'Mot de passe',
        generate_pass: 'Générer un Mot de passe',
        access_level: "Groupe d'accès",
        select_a_access_level: "Sélectionnez un groupe d'accès",
        select_type: 'Sélectionnez un type',
        active: 'Actif',
        actions: 'Actions',
        discount_permission: 'Permission de remise sur la vente',
        discount_value: 'Valeur maximale de la remise (%)',
        phone: 'Numéro de téléphone',
      },

      groups: {
        groups: 'Groupes',
        group: 'Groupe',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'Voici les groupes listés avec leurs actions respectives',
        name: 'Nom',
        Integrations: 'Intégrations',
        means_of_payment: 'Moyen de paiement',
        products: 'Produits',
        category: 'Catégories',
        subcategory: 'Sous-catégorie',
        indicators: 'Indicateurs',
        requests: 'Commandes',
        reports: 'Rapports',
        messenger: 'Messagerie',
      },

      shifts: {
        shifts: 'Quarts',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          'Voici les quarts listés pour chaque jour de la semaine',
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        start: 'Début',
        end: 'Fin',
      },

      account: {
        account: 'Compte',
        edit_account: 'Modifier le compte',
        registration_number: 'CNPJ',
        corporate_name: 'Raison sociale',
        customer_name: 'Nom',
        name_of_the_establishment: "Nom de l'établissement",
        subdomain: 'Sous-domaine',
        code: 'Code',
        default_language: 'Langue par défaut',
        default_currency: 'Devise par défaut',
        login_of_person_in_charge: 'Identifiant du responsable du compte',
        name_of_person_in_charge: 'Nom du responsable',
        address: 'Adresse',
        zip_code: 'Code Postal',
        number: 'Numéro',
        neighbourhood: 'Quartier',
        city: 'Ville',
        state: 'État',
        public_place: 'Voie publique',
        address_complement: "Complément d'adresse",
        info: 'Pour changer le sous-domaine, contactez le support',
      },

      terms: {
        terms: 'Termes',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          "Voici les termes d'acceptation de la plateforme de vente",
        create_your_term: 'Créez votre terme',
        term_name: 'Nom du terme',
        valid_until: "Valide jusqu'au",
        name: 'Nom',
        expirated: 'Expire',
      },

      payment_plans: {
        payment_plans: 'Plans de paiement',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          'Voici les plans de paiement listés avec leurs actions respectives',
        create_payment_plans: 'Créer des Plans de paiement',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
        erp_integration: 'Intégration ERP',
        integration_type: "Type d'Intégration",
        select_an_integration: 'Sélectionnez une intégration',
        card_flag: 'Marque de la Carte',
        flag: 'Marque',
        type: 'Type',
        erp_code: 'Code ERP',
        card_installment: 'Versements par carte',
        payment_plan: 'Plan de paiement',
        installment: 'Versement',
        time: 'Délai',
        credit: 'Crédit',
        debit: 'Débit',
      },

      indicators: {
        indicators: 'Indicateurs',
        orders: 'Commandes',
        filters: 'Filtres',
        first: 'Début',
        end: 'Fin',
        total_order: 'Total des commandes',
        revenue: 'Revenu',
        orders_by_location: 'Commandes par modalité',
        orders_by_month: 'Commandes par mois',
        orders_by_day: 'Commandes par jour',
        orders_by_hour: 'Commandes par heure',
        orders_by_month_sector: 'Commandes par mois et modalité',
        orders_by_day_sector: 'Commandes par jour et modalité',
        orders_by_hour_sector: 'Commandes par heure et modalité',
        product: 'Produits',
        categories: 'Catégories',
        sales_by_category: 'Ventes par catégorie',
        revenue_by_category: 'Revenu par catégorie',
        average_ticket: 'Ticket moyen',
        quantity: 'Quantité',
        summary: 'Résumé',
        summaryAccess: 'Accès',
        summaryAccessGroup: 'Zones accédées par période',
        summaryTimeAccessGroup: 'Total par heure',
        summaryIPAccessGroup: 'Total par utilisateur',
        summarySellerCart: 'Total des paniers créés par vendeur',
        period: 'Choisissez une période',
        summaryTypeCust: 'Somme par type de coût',
        summaryComposition: 'Composition des coûts',
        cost: 'Coûts',
        customer: 'Clients',
        seller_sales_by_category: 'Ventes du vendeur par catégorie',
        summary_seller: 'Résumé du Vendeur',
        sellers_invoice: 'Facturation du vendeur',
        comparative_sales_by_channel: 'Comparatif des ventes par canal',
        select_view: 'Sélectionnez la vue',
        sales: 'Ventes',
        attended_customers: 'Clients servis',
        carts: 'Paniers enregistrés',
        sales_conversion: 'Conversion des ventes',
        mean_ticket: 'Ticket moyen',
        sales_client: 'Comparatif/Classement des ventes par client',
        sellers: 'Vendeurs',
        summary_store: 'Résumé du Magasin',
        accesses: 'Visites',
        active_sellers: 'Vendeurs actifs',
        revenue_store: 'Facturation du Magasin',
        revenue_group: 'Facturation du Groupe',
        comparative_sales_by_seller: 'Comparatif des ventes par vendeur',
        comparative_sales_by_store: 'Comparatif des unités commerciales',
        comparative_by_seller: 'Force commerciale - Comparatif des vendeurs',
        stores: 'Magasins',
        invoicing: 'Facturation',
        active_stores: 'Magasins actifs',
        summary_group: 'Résumé du Groupe',
        invoice_by_store: 'Facturation par magasin',
        rank_sellers: 'Classement des vendeurs',
        rank_stores: 'Classement des magasins',
      },

      customer_list: {
        customer_list: 'Liste de clients',
        listed_customers: 'Voici les clients listés avec leurs actions respectives.',
        select_time: 'Période des commandes passées',
        name: 'Nom',
        first: 'Début',
        end: 'Fin',
        phone: 'Téléphone',
        date: 'Date',
        detail: 'Détails du Client',
        total_profit: 'Profit Total',
        total_itens: 'Total des Articles',
        total_orders: 'Total des Commandes',
        order_between: 'Commandes entre',
        order_detail: 'Détail de la commande',
        create: 'Créer un Client',
        go_detail: 'Voir les détails',
        product: 'Produit',
        value: 'Valeur',
        quantity: 'Qté.',
        total: 'Total',
        edit: 'Modifier le Client',
      },

      smart_order: {
        smart_order: 'Smart Order',
        service_classification: 'Classification des services',
        message_warning_find_variation:
          'Lors de la recherche par nom, faites attention au code de référence et au SKU, en plus du nom du produit.',
        product: 'Produits',
        create_product: 'Créer un Produit',
        here_are_listed_the_products_along_with_their_respective_actions:
          'Voici les produits listés avec leurs actions respectives',
        name: 'Nom',
        code: 'Code',
        color_code: 'Code Couleur',
        crop_image: "Recadrer l'Image",
        use_original_image: "Utiliser l'Image Originale",
        select_image_format: "Sélectionner le Format de l'Image",
        use_selected_size: 'Utiliser la Taille Sélectionnée',
        format_640x640: '640x640 (Carré)',
        format_600x900: '600x900 (Portrait)',
        product_data: 'Données du Produit',
        mark: 'Marque',
        measurement_unit: 'Unité de Mesure',
        description: 'Description',
        technical_specification: 'Spécification Technique',
        from: 'de',
        characters: 'caractères',
        order: 'Ordre',
        product_image: 'Images du Produit',
        additional_images: 'Images Additionnelles',
        product_groups: 'Groupes de clients pour le Produit',
        categories: 'Catégories',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'Voici les catégories listées avec leurs actions respectives',
        image: 'Image produit',
        image_variation: 'Image variation',
        category: 'Catégorie',
        category_parent: 'Catégorie Parent',
        category_name: 'Nom de la catégorie',
        category_code: 'Code de la catégorie',
        perfil_image: 'Image de profil',

        subcategories: 'Sous-catégories',
        subcategory: 'Sous-catégorie',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'Voici les sous-catégories listées avec leurs actions respectives',
        select_category: 'Sélectionnez une catégorie',

        marks: 'Marques',
        listened_marks: 'Voici les marques listées avec leurs actions respectives',

        measurements_units: 'Unités de Mesures',
        listened_measurement: 'Voici les unités de mesure listées avec leurs actions respectives',

        grid_products: 'Grilles',
        listened_grid: 'Voici les grilles de produits listées avec leurs actions respectives',
        grid_name: 'Nom de la grille',
        grid_code: 'Code',
        variation: 'Variation',
        grid: 'Grille',
        grids: 'Grilles',

        variations: 'Variations',
        listened_variations:
          'Voici les variations de produits listées avec leurs actions respectives',
        modality: 'Modalité',
        select_modality: 'Sélectionnez une modalité',
        prod: 'Produit',
        select_product: 'Sélectionnez un produit',
        no_variation: 'Produit sans variation',
        variation_product: 'Variation du produit',
        cost_price: 'Prix de Coût',
        sell_price: 'Prix de Vente',
        promotional_price: 'Prix Promotionnel',
        weight: 'Poids',
        height: 'Hauteur',
        width: 'Largeur',
        depth: 'Profondeur',
        availability: 'Quelle est la disponibilité du produit ?',
        when_product_stock: 'Quand le produit est en rupture de stock ?',
        stock: 'Quantité de produits en stock',
        min_stock: 'Stock minimum',
        price: 'Prix',

        catalogs: 'Catalogues',
        catalog: 'Catalogue',
        create_catalog: 'Créer un Catalogue',
        edit_catalog: 'Modifier le Catalogue',
        catalog_link: 'Copier le Lien du Catalogue',
        listened_catalogs:
          'Voici les catalogues de produits listés avec leurs actions respectives.',
        validity: 'Validité',
        first: 'Début',
        end: 'Fin',
        search_products: 'Recherche de Produits',

        product_status: 'Statut du produit',
        sku: 'SKU/EAN',
        status_variation: 'Statut de la variation',
        specification: 'Spécification',
        price_promotional: 'Prix avec remise',
        inventory: 'Inventaire',
        preparation_time: 'Temps de préparation',
        service_title: 'Voici les services listés avec leurs actions respectives.',

        initial_hour: 'Heure de début',
        final_hour: 'Heure de fin',

        date_start: 'Date de Début',
        date_end: 'Date de Fin',

        add_group: "Liste d'Articles Additionnels",
        no_add: "Ce produit n'est encore associé à aucune liste d'articles additionnels.",
        already_add: "Ce produit est associé aux listes d'articles additionnels suivantes.",
        associate_add: "Associer à une liste d'articles additionnels",
        associate: 'Associer',
        choose_add:
          "Choisissez les listes d'articles additionnels qui seront associées à ce produit.",
        no_group_add: "Aucune liste d'articles additionnels disponible à associer.",
        remove_add: "Supprimer l'association",
        remove_add_text:
          'Voulez-vous supprimer l\'association de ce produit avec la liste d\'articles additionnels "@" ?',
        limit_range: "Limite maximale d'intervalles atteinte",

        remove_add_soon:
          'Attention ! Cet onglet sera bientôt supprimé. Vous pourrez continuer à gérer vos articles additionnels normalement. Accédez à l\'onglet "Informations de Base" et allez à la section "Groupe d\'Articles Additionnels" pour voir les articles additionnels de ce produit.',
        create_image_ia: "Proposition d'Image IA",
        create_image_ia_text: 'Entrez une description du produit pour générer les images.',
        generate_images: 'Générer des images',
        generate_description: 'Personnaliser la description',
        generate_new_options: 'Générer de nouvelles options',
        save_image_selected: 'Sauvegarder la photo sélectionnée',
        generated_image_review_warning: 'Les images générées peuvent modifier les couleurs, les détails et les proportions du produit. Vérifiez avant de sauvegarder ; la reproduction fidèle du produit réel n’est pas garantie.',
        reference_image_ia: 'Image de référence',
        image_qtd_ia: "Quantité d'images",
        save_img_ia: 'Sauvegarder les images',
        cancel: 'Annuler',

        more_category: 'Voir plus de configurations pour cette catégorie',
        selectAll: 'Sélectionner Tout',
        alterLot: 'Modifier le Lot',
        edit_category:
          "Il n'est pas permis de changer le lien de la catégorie, nous vous conseillons de créer une nouvelle catégorie",

        catalog_image: 'Image du Catalogue',
      },

      service_grid: {
        service_grid: 'Grilles de Services',
        service_grid_single: 'Grille de Service',
        create_service_grid: 'Créer une Grille de Services',
        edit_service_grid: 'Modifier la Grille de Services',
        service_grid_name: 'Nom de la Grille de Services',
        service_grid_name_placeholder: 'Nom de la grille de services',
        start_hour: 'Heure de Début',
        start_hour_placeholder: '00:00',
        end_hour: 'Heure de Fin',
        end_hour_placeholder: '23:59',
        interval: 'Intervalle',
        interval_placeholder: '00:15',
        interval_tooltip: 'Intervalle de temps entre les commandes',
        service_list: 'Liste de Services',
        service_placeholder: 'Services',
        missing_fields: 'Champs manquants',
        missing_fields_message: 'Veuillez vérifier si vous avez rempli tous les champs !',
        grid_created: 'Grille enregistrée',
        grid_created_message: 'Enregistrement effectué avec succès !',
        grid_updated: 'Grille modifiée',
        grid_updated_message: 'Modification effectuée avec succès !',
        error: 'Erreur',
        error_create_message: "Erreur lors de l'enregistrement de la grille !",
        error_update_message: 'Erreur lors de la modification de la grille !',
        fill_information_create:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
        save_changes_edit:
          'Remplissez les informations ci-dessous et cliquez sur le bouton sauvegarder pour confirmer les modifications',
        dashboard: 'Tableau de bord',
        title: 'Titre',
        listed_grids: 'Voici les grilles de services listées avec leurs actions respectives',
        grid_deleted: 'Grille supprimée',
        grid_deleted_message: 'Suppression effectuée avec succès !',
        error_delete_message: 'Erreur lors de la suppression de la grille !',
        status: 'Statut',
        grid_linked_warning: 'Grille liée',
        grid_linked_message:
          'Cette grille est liée à {count} formulaire(s) de service(s) et ne peut pas être supprimée.',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: 'Générer un Code QR',
        personalize: 'Personnaliser',
        settings: 'Paramètres',
        link: 'Lien vers Webapp',

        webapp_data: "Données de l'Webapp",
        name: 'Nom',
        place: 'Lieu',
        product_pagination: 'Quantité de produits dans la pagination',
        logo_ninegrid: 'Logo Ninegrid',
        light: 'Clair',
        dark: 'Foncé',
        logo_totvs: 'Logo TOTVS',
        use_icon_menu: "Utiliser l'icône dans le menu Webapp",
        description: 'Description',
        icon: 'Icône',
        color_setting: 'Configuration des couleurs',
        background_webapp: "Fond de l'Webapp",
        background_default_webapp: "Couleur par Défaut de l'Webapp",
        background_header: "Fond de l'en-tête",
        text_header: "Texte de l'en-tête",
        icon_header: "Icônes de l'en-tête",
        background_footer: 'Fond du pied de page',
        icon_footer: 'Icônes du pied de page',
        highlight_footer: 'Mise en évidence du pied de page',
        notification_cart: 'Notification du panier',
        notification_text: 'Texte de la notification',
        home_button: "Bouton d'accueil",
        text_home_button: "Texte du bouton d'accueil",
        title_bar: 'Barre de titre',
        text_title_bar: 'Texte de la barre de titre',
        icon_title_bar: 'Icônes de la barre de titre',
        text_category: 'Texte des catégories',
        webapp_button: "Thème de l'Webapp",
        text_button: 'Texte des boutons',
        background_menu: 'Fond du menu latéral',
        text_menu: 'Texte du menu latéral',
        price_card_background: 'Arrière-plan de la carte de prix',
        price_card_font_color: 'Couleur de la police de la carte de prix',
        order_status: 'Statut de la commande',
        order_active_status: 'Statut actif de la commande',
        text_order_active_status: 'Texte du statut de la commande',
        info_cart: 'Information du panier',

        settings_webapp: "Paramètres de l'Webapp",
        type_delivery: 'Type de restriction de livraison',
        integration: 'Intégration',
        select_integration: 'Sélectionnez une intégration',
        payment_method_card: 'Moyen de paiement Carte',
        payment_method_pix: 'Moyen de paiement Pix',
        payment_method_delivery: 'Moyen de paiement à la livraison',
        consent_letter: 'Activer la lettre de consentement',
        product_no_stock: 'Vente de produits sans stock',
        show_subcategory: 'Afficher la sous-catégorie',
        show_observation: "Afficher l'observation",
        use_category_list: 'Afficher les sous-catégories et les produits en listes',
        use_category_list_v2: 'Afficher les catégories et sous-catégories en listes',
        use_product_list: 'Afficher les produits en listes',
        remove_shadow: "Ne pas ajouter d'ombre aux catégories et catalogues",
        remove_show_mode: "Supprimer le mode d'affichage",
        no_shadow: "Ne pas ajouter d'ombre aux catégories",
        is_order_number: 'Ordonner la catégorie',
        order_number: 'Par ordre',
        order_category: 'Alphabétique',
        show_layout: 'Afficher la Mise en page',
        image_type: "Style de l'image du produit",

        withdraw_fee: 'Frais de Retrait',
        minimum_value: 'Valeur Minimale de la Commande',
        seller_checkout: 'Modalité de la Caisse',

        no_sales: 'Ne pas permettre les ventes',
         navigation_by_voice: 'Navigation par la voix',
        no_payment_by_pluginbot: 'Ne pas autoriser le paiement par Pluginbot',
         showAccessibilityPage: "Afficher la page d'accessibilité",
        accessibilityOptionsActived: "Options d'accessibilité activées automatiquement",
        customerWithoutDocument: 'Autoriser le client sans document',
        safe_mode: 'Mode de sécurité',
        time_safe_mode: 'Temps de Session du Mode de sécurité (en minutes)',
        limit_characteres_explanation:
          'Pour les magasins avec intégration Wintor ou Protheus, le maximum recommandé est de 50 caractères.',
        limit_characteres: 'Limite de caractères',

        skip_entry: "Passer l'écran d'entrée",
        payment_table: 'Paiement à table',

        payment_card: 'Paiement à la commande',

        slides_homePage: "Images de Mise en Avant Page d'Accueil",
        slides_initial: 'Images de Mise en Avant Initiale',

        slides_not_found: "Aucune image de diaporama n'a été trouvée",

        externalLink: 'Lien externe',
        buttonType: 'Type de Bouton',
        ableUserLocation: "Permettre la recherche d'adresse par localisation",
        ableWaiter: "Désactiver l'option d'appeler le serveur",
        closeAccountButton: 'Retirer le bouton de clôture de compte',
        emitNfChef:
          'Émettre une Facture après le paiement de la commande ? (Comptoir/Table/Commande)',

        seller_cart_limit_time: "Temps d'expiration du panier du vendeur par heure",
        seller_cart_limit_time_explanation:
          'Temps maximum pendant lequel le client peut utiliser le panier du vendeur',
        settings_webapp_aggregator: 'Personnaliser',
        generate_qrcode_webapp_aggregator: 'Générer un code QR',
        qrcode_webapp_aggregator: 'Application Web',
        security_settings: 'Paramètres de sécurité',
        biometric_authentication: 'Authentification Biométrique',
        code_scanner: 'Autoriser la lecture de codes-barres et de codes QR',
        seller_code: 'Autoriser le champ de code du vendeur',
        maximus_radius: 'Localisation : Rayon de proximité autorisé (en mètres)',
        access_maximus: "Nombre maximum d'accès par table",
        limit_time: "Temps d'accès avant expiration de la commande (en minutes)",
        password: "Mot de passe pour débloquer l'accès",
        flag_discount: 'Format du drapeau de remise',
        color_flag_discount: 'Couleur du tag',

        config_tags: 'Configurer les Tags',
        promotional_tags: 'Tag promotionnel',

        pre_created: 'Pré-enregistrement',

        show_classification_button: 'Afficher le bouton pour voir toutes les catégories',
        show_catalog_button: 'Afficher le bouton pour voir tous les catalogues',
        show_catalog_name: 'Afficher le nom des catalogues',
        show_classification_name: 'Afficher le nom des catégories',
        show_mark_name: 'Afficher la marque des produits',
        show_stock_quantity: 'Afficher le stock des produits',
        show_promotional_tags: "Afficher l'Étiquette Promotionnelle",
        show_product_sku: 'Afficher le sku du produit',
        tag_display_groups: 'Afficher les groupes de tags dans la liste des produits',
        text_free_delivery: 'Texte personnalisé pour la livraison ou le retrait gratuit',
        tooltip_free_delivery:
          "S'il est rempli, ce texte sera affiché lorsque la livraison ou le retrait est gratuit. S'il est vide, la valeur R$ 0,00 sera affichée",
        place_holder_free_delivery: 'Ex: Gratuit',
        no_show_grid: 'Omettre les grilles de variations uniques du produit',
        explain_show_grid:
          'Masque les grilles avec des variations uniques. Les grilles avec plusieurs options (ex: tailles G; TG) resteront visibles dans la sélection de produit, mais masquées ailleurs.',

        type_image: "Type d'Image",
        type_image_square: 'Carrée',
        type_image_rectangle: 'Rectangulaire',

        directlink: 'Lien Direct',
        infoDirectLink:
          'Non obligatoire, seulement lorsque cela est nécessaire pour envoyer directement à une autre page ou site, maximum 350 caractères',

        block_add_in_limit: "Bloquer l'ajout à la limite",

        family_fonte: 'Famille de Police',
        rounding_images: 'Arrondi des Images',
        rounding_bars: 'Arrondi des Barres',
        color_icons: 'Couleur des icônes',
        color_icons_header_footer: "Couleur des icônes dans l'en-tête et le pied de page",
        background_icon_button: 'Couleur de fond des icônes',
        background_icon_custom: 'Couleur personnalisée',
        restaurant_list: 'Afficher les restaurants dans les listes',
        restaurant_display_mode: "Modifier le mode d'affichage des restaurants",
        icon_button_size: 'Taille des icônes des boutons',
        shadow_image: "Ombre de l'Image",
        black_logo_nine: 'Logo Ninegrid Sombre',
        skip_loud_screen: "Passer l'écran de chargement",
        can_acesse_restaurant:
          'Autoriser la consultation du catalogue (Magasin/Restaurant) sans connexion',
        info_acesse_restaurant:
          "L'activation de ce drapeau permet à l'utilisateur d'accéder au menu/catalogue du restaurant ou du magasin sans avoir besoin de se connecter. S'il existe une intégration de paiement active, la connexion sera demandée directement dans la WebApp du magasin ou du restaurant, avant l'étape de paiement, afin que la commande soit correctement associée au contexte de l'utilisateur (profil/réservation) dans le système de l'hôtel.",
      },

      integration: {
        integration: 'Intégration',
        means_of_payment: 'Moyen de Paiement',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          'Voici les moyens de paiement listés avec leurs actions respectives',
        PDV: 'Intégration PDV',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          'Voici les intégrations listées avec leurs actions respectives',
        integration_name: "Nom de l'Intégration",
        type_of_integration: "Type d'Intégration",
        actions: 'Actions',
        search: 'Rechercher',
        example: 'Exemple de Charge Utile',

        loads: 'Charges',
        name: 'Nom',
        price: 'Prix',
        stock: 'Stock',
        measurements_units: 'Unités de Mesures',
        grid: 'Grilles',
        classifications: 'Catégories',
        products: 'Produits',
        status_sync: 'Synchronisation de Statut',
        marks: 'Marques',
        orders: 'Commandes',
        trigger_load: 'Déclencher la Charge',
        first: 'Début',
        end: 'Fin',
        load: 'Charger',
        messenger: 'Messagerie',
        others: 'Autres',
        test: "Voulez-vous tester l'intégration",
        params_test: 'Voir les paramètres de cette intégration',
        copy_params: 'Copier les paramètres',
        result_test: "Résultats du test de l'intégration",
        success_1: "Succès ! L'intégration",
        success_2: 'a réussi.',
        result_log: 'Log de résultat',
        copy_result: 'Copier le résultat',
        search_result: 'Rechercher dans les résultats',
        error_1: "L'intégration",
        error_2: "a retourné une erreur. Consultez le log ci-dessous pour plus d'informations.",

        success_food_1: "Succès ! L'intégration",
        success_food_2: 'a réussi.',
        error_food_1: "L'intégration",
        error_food_2: 'est hors ligne.',

        integrationPrint: 'Tester la Connexion',
      },

      reports: {
        orders: 'Commandes',
        order_report: 'Rapport de Commandes',
        order_list: 'Liste de Commandes',
        first: 'Début',
        end: 'Fin',
        firstTime: 'Heure de début',
        endTime: 'Heure de fin',
        orders_between: 'Commandes entre',
        order_number: 'Numéro de Commande',
        date: 'Date',
        consumer: 'Consommateur',
        modality: 'Modalité',
        total_value: 'Valeur',
        cancel_order: 'Annuler la commande',

        products: 'Produits',
        quantity: 'Quantité',
        qtt: 'Qté',
        product: 'Produit',
        value: 'Valeur',
        total: 'Total',
        order_status: 'Statut de la Commande',
        payment_method: 'Mode de paiement',
        billing_address: 'Adresse de facturation',
        product_value: 'Valeur des produits',
        discount: 'Remise',
        order: 'Commande',

        listened_logs: 'Voici les logs listés avec leurs actions respectives.',
        methods: 'Méthodes',
        log_details: 'Détails du Log',

        withdraw: 'Retrait',
        delivery: 'Livraison',
        table: 'Table',
        counter: 'Comptoir',
        responsible_withdraw: 'Responsable du retrait',
        responsible_delivery: 'Responsable de la réception',
        address_withdraw: 'Adresse de retrait',
        address_delivery: 'Adresse de livraison',
        seller: 'Vendeur',
        seller_link: 'Lien du Vendeur',
        external_code: 'Numéro externe',
        payment: 'Paiement',
        internal_delivery: 'Livraison Interne',
        origin: 'Origine',
        historial: 'Historique de la commande',
        approval_moment: "Date et heure de l'approbation",
        id: 'Code de la Réservation',
        pluginspace: 'Hôtel',
        hotel: "Commande associée à l'hôtel",
        document: 'Document de la Réservation',
        room: 'Code de la Chambre',
        status_payment: 'Statut du paiement',
        authorization_code: "Code d'autorisation",
        transaction: 'ID de la transaction',
        made_in: 'Réalisé le',
        send_method: "Méthode d'envoi",
        send_date: "Date d'envoi",
        estimated_delivery: 'Estimation de la livraison',
        freight: 'Fret',
        tracking_code: 'Code de suivi',
        website: 'Ouvrir le site de suivi',
        label: "Imprimer l'étiquette d'envoi",
        payment_delivery: 'Paiement à la livraison',
        payment_money: 'Paiement en espèces',
        change_money: 'Monnaie',
        label_code: 'Étiquette',
        label_website: "Ouvrir le site de l'étiquette",
        declaration_code: 'Déclaration',
        declaration_website: 'Ouvrir le site de la déclaration',
        height: 'Hauteur (cm)',
        width: 'Largeur (cm)',
        length: 'Longueur (cm)',
        weight: 'Poids (kg)',
        send_text: "Mode d'envoi choisi par le client : ",
        success_label: "Votre étiquette d'envoi a été générée avec succès.",
        continue: 'Continuer',
        confirm: 'Confirmer',
        change_multiple_status: 'Changer le statut de plusieurs commandes',
        change_status_text: 'Voulez-vous changer le statut des commandes ci-dessous ?',
        new_status: 'Nouveau statut',
        change_status: 'Changer le statut',

        synkar: 'Automatisation',
        invalid_data: 'Veuillez sélectionner les dates de début et de fin.',
        robot_attention_title: 'Attention',
        robot_error_title: 'Erreur',
        robot_success_title: 'Succès !',
        robot_delivery_title: 'Livraison avec robot',
        robot_delivery_description: 'Sélectionnez le robot et le point de destination pour envoyer la livraison.',
        robot_label: 'Robot',
        robot_fallback_name: 'Robot #{{id}}',
        robot_no_data: 'Aucune donnée renvoyée pour ce robot.',
        robot_map: 'Carte',
        robot_map_alt: 'Carte du robot',
        robot_delivery_points: 'Points de livraison',
        robot_no_points: 'Aucun point enregistré.',
        robot_send: 'Envoyer au robot',
        robot_load_points_error: 'Impossible de charger les points du robot.',
        robot_fetch_points_error: 'Échec de la récupération des points du robot.',
        robot_send_unavailable: 'Impossible d\'envoyer cette commande au robot.',
        robot_select: 'Sélectionnez un robot.',
        robot_select_point: 'Sélectionnez un point de livraison.',
        robot_send_success: 'Commande envoyée au robot avec succès !',
        robot_send_error: 'Échec de l\'envoi de la commande au robot.',

        details: 'Détails',
      },

      imports: {
        imports: 'Importations',
        import_image_product: "Importations d'Images pour Produits",
        import_image_category: "Importations d'Images pour Catégories",
        listened_import_product:
          "Voici les importations d'images pour produits listées avec leurs actions respectives.",
        no_upload_images: "Ne pas télécharger d'images",
        first: 'Début',
        end: 'Fin',
        total_products: 'Total des Produits',
        sync_products: 'Produits Synchronisés',
        import_image_sku: "Importations d'Images pour Variations",
        listened_import_sku:
          "Voici les importations d'images pour variations listées avec leurs actions respectives.",
        verify_verification: 'Vérification de la variation',
        product_code: 'Code du produit',
        code: 'Code',
        total_variations: 'Total des Variations',
        sync_variations: 'Variations Synchronisées',
        total_categories: 'Total des Catégories',
        sync_categories: 'Catégories Synchronisées',
        problem_title: 'Images avec problème',
        images_success: 'images ont été envoyées avec succès.',
        images_error: "images ont présenté un problème et n'ont pas été envoyées.",
        file: 'Fichier',
        status: "Statut de l'importation",
        new_import: 'Effectuer une nouvelle importation',
        import_xls: 'Importer des images avec un fichier XLS',
        import_repo: 'Importer des images depuis Google Drive ou Dropbox',
        steps: "Procédure d'importation",
        step_1: '1. Placez toutes les images sur un serveur web public.',
        step_2: '2. Vérifiez si le serveur est public et accessible via le web.',
        step_3: '3. Téléchargez notre fichier XLSX vierge.',
        step_4: "4. Remplissez avec les données de votre banque d'images.",
        step_5: '5. Téléchargez le fichier rempli.',
        step_1_repo:
          '1. Vérifiez si le dossier du magasin est créé comme "fotos_loja_<identifiant du magasin>".',
        step_2_repo: '2. Créez le dossier "produits" dans le dossier de votre magasin.',
        step_2_repo_sku: '2. Créez le dossier "variacoes" dans le dossier de votre magasin.',
        step_2_repo_category: '2. Créez le dossier "categorias" dans le dossier de votre magasin.',
        step_3_repo:
          '3. Confirmez que les fichiers sont sous la forme "<code du produit>.<extension>".',
        step_3_repo_sku: '3. Confirmez que les fichiers sont sous la forme "<sku>.<extension>".',
        step_3_repo_category:
          '3. Confirmez que les fichiers sont sous la forme "<code de la catégorie>.<extension>".',
        step_4_repo: "4. S'il s'agit d'un produit additionnel, vérifiez s'il a \"_<numero>\".",
        step_4_repo_sku:
          "4. Confirmez que la variation est une image et qu'elle est au format JPG ou PNG.",
        step_4_repo_category:
          "4. Confirmez que la catégorie est une image et qu'elle est au format JPG ou PNG.",
        step_5_repo: "5. Confirmez que le produit est une image et qu'il est au format JPG ou PNG.",
        download: 'Télécharger le fichier XLSX vierge',
        download_problems: 'Exporter le rapport',
        upload: 'Envoyer le fichier',
        upload_anex: 'Joindre le fichier',
        import_dropbox: 'Importer avec Dropbox',
        import_drive: 'Importer avec Google Drive',
        spreadsheet: 'Feuille de calcul',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'Type',
        type_resize: 'Type de Redimensionnement',
        agroup_color: 'Regrouper les photos par couleur',
        banner_size: 'Traiter la catégorie N1 comme bannière',
        select_dimensions: 'Sélectionnez les dimensions',
        square: 'Traiter comme 640x640',
        vertical: 'Traiter comme 600x900',
      },

      sms: {
        sms: 'SMS',
        listened_sms: 'Voici les messages (SMS) listés avec leurs actions respectives.',
        order: 'Ordre',
        name: 'Nom',
        message: 'Message',
        markers: 'Les marqueurs [commande] et [statut] doivent être dans le message',
        waiting: 'En attente',
        opened: 'Ouvert',
        ready: 'Prêt',
        refused: 'Refusé',
        message_hotel: 'SMS Hôtel',
        listened_sms_hotel: "Voici les messages de l'hôtel listés avec leurs actions respectives.",
        status_hotel: 'Statut Hôtel',
        listened_status_hotel:
          "Voici les statuts et messages de l'hôtel listés avec leurs actions respectives.",
        edit_status: 'Modifier le statut',
        edit_status_hotel: "Modifier le statut de l'hôtel",
        notification: 'Notification',
        email_group_status: 'Statut',
        email_group_service_forms: 'Formulaires de Service',
        email_group_services: 'Services',
        email_group_services_booking: 'Services - Booking',
        email_group_tours: 'Tours',
        email_group_activities: 'Activit�s',
        email_group_experiences: 'Exp�riences',
        send_email_simple: 'Envoyer e-mail',
        status_label: 'Statut',
        write_message_status: 'Écrivez ici un message pour ce statut',
        markers_hotel:
          'Les marqueurs [pedido], [status], [cliente], [quarto], [hotel] doivent être dans le message',
        status_updated: 'Statut mis à jour',
        status_update_success: 'Mise à jour effectuée avec succès !',
        status_update_error_title: 'Erreur',
        status_update_error: 'Erreur lors de la mise à jour du statut !',
      },

      multichannel: {
        multichannel: 'Multicanal',
        listened_multichannel:
          'Voici les configurations multicanales listées avec leurs actions respectives.',
      },

      feed: {
        content: 'Contenu',
        title: 'Titre',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Remplissez les informations ci-dessous et cliquez sur le bouton créer pour sauvegarder les modifications',
      },
      feedCategory: {
        feedCategory: 'Catégorie de Contenu',
      },

      structured_content: {},

      queue: {
        index: "File d'attente",
        menage: 'Gestion',
        config: "Configurations de la file d'attente",
        able: "Permettre la file d'attente",
        link: "Lien de la file d'attente :",
        limit_people: 'Nombre maximum de personnes',
        limit_people_text: "Limite de la file d'attente",
        limit_time: "Limite de temps pour afficher l'alerte",
        limit_time_text: 'Temps maximum en minutes pour considérer comme en retard',
        image_title: 'Définition des images',
        image_text:
          "Le système de file d'attente affiche 2 images. Téléchargez des photos de votre restaurant, ou sélectionnez des photos par défaut ci-dessous. Les photos envoyées seront ajustées à la taille de 350x250 pixels.",
        image: 'Image',
        position: 'Position',
        time: "Temps d'attente",
        people: 'personnes',
        cancel: 'Annulation',
        cancel_text: "Voulez-vous retirer cette personne de la file d'attente ?",
        cancel_button: 'Retirer',
        confirm: 'Confirmation',
        confirm_text: "Voulez-vous confirmer l'arrivée du réservant ?",
        confirm_button: "Confirmer l'arrivée",
        empty: "Il n'y a pas de liste d'attente pour le moment",
        confirm_all: 'Confirmer tout',
        cancel_all: 'Annuler tout',
        observation: 'Observation',
        use_terms: 'Activer les termes de consentement',
        total_people: 'Total de personnes par groupe',
        total_people_text: "Limite de la file d'attente par groupe",
        all: 'Tous',
        in_queue: 'Dans la file',
        preferential: 'Préférentiel',
        confirmed: 'Confirmé',
        removed: 'Refusé',
        show: 'Afficher',
        show_text: 'Dernières @ heures',
        yes: 'Oui',
        no: 'Non',
        add: 'Ajouter un Client à la File',
        use_location: 'Autoriser la localisation ?',
        use_menu: 'Voulez-vous utiliser un menu ?',
        use_ninegrid_menu: 'Utiliser le menu Ninegrid ?',
        external_menu_link: 'Entrez le lien du menu',
        edit: 'Modifier le Client dans la File',
      },
      booking: {
        index: 'Réservation',
        config: 'Configurations de la réservation',
        able: 'Permettre la réservation',
        link: 'Lien de la réservation :',
        image_title: 'Définition des images',
        image_text:
          'Le système de réservation affiche 2 images. Téléchargez des photos de votre restaurant, ou sélectionnez des photos par défaut ci-dessous. Les photos envoyées seront ajustées à la taille de 350x250 pixels.',
        image: 'Image',
        days_week: 'Jours de la semaine',
        booking_day: 'Autoriser les réservations ce jour-là ?',
        booking_day_text: 'Définissez ci-dessous les heures autorisées pour les réservations.',
        booking_day_subtext:
          'En sélectionnant une heure, une fenêtre de 1 heure sera définie. Exemple : en sélectionnant 19h00, les gens pourront faire des réservations entre 19h00 et 20h00.',
        max_people: 'Nombre maximum de personnes par réservation',
        max_people_text:
          "C'est la taille maximale d'un groupe de personnes pouvant faire une réservation",
        expiry_time: "Temps maximum jusqu'à l'expiration de la réservation",
        expiry_time_text: "Temps en minutes pour attendre l'arrivée du réservant",
        day_confirm: 'Exiger une confirmation le jour même',
        day_confirm_text: "L'utilisateur doit confirmer la réservation à la date choisie",
        payment_confirm: 'Exiger un paiement anticipé pour la réservation',
        value_payment_confirm: 'Valeur du paiement anticipé',
        week: 'Semaine',
        month: 'Mois',
        year: 'Année',
        use_terms: 'Activer les termes de consentement',
        empty: "Il n'y a pas de réservations pour le moment",
        use_time: 'Autoriser la réservation par période',
        time: 'Durée de la réservation (HH:mm)',
        time_cancel: "Délai limite pour l'annulation de la réservation (HH:mm)",
        time_change: 'Délai limite pour la modification de la réservation (HH:mm)',
        use_change: 'Autoriser la modification de la réservation',
      },
      booking_day: {
        booking: 'Réservations du jour',
        date: 'Date',
        people: 'personnes',
        expiry: 'Expire dans',
        cancel_title: 'Annulation',
        cancel_subtitle: 'Voulez-vous annuler cette réservation ?',
        cancel_button: 'Annuler la réservation',
        confirm_title: 'Confirmation',
        confirm_subtitle: "Voulez-vous confirmer l'arrivée du réservant ?",
        confirm_button: "Confirmer l'arrivée",
        accessibility_needs: "Besoin d'Accessibilité",
        accessibility_elderly: 'Aide aux Personnes Âgées',
        accessibility_wheelchair: 'Utilisateur de Fauteuil Roulant',
        accessibility_physical: 'Handicap Physique',
        filter_accessibility: 'Filtrer par Accessibilité',
        all_accessibility: 'Tous les besoins',
      },
      booking_report: {
        report: 'Rapports',
        search: 'Recherche de réservations',
        time: 'Sélectionnez la période',
        date_start: 'Date de début',
        date_end: 'Date de fin',
        confirm: 'Confirmation',
        noShow: 'Non présenté',
        confirmed: 'Réservations confirmées',
        canceled: 'Réservations annulées',
        open: 'Ouvert',
        map: 'Carte des réservations',
        booking: 'réservations',
        accessibility_stats: "Statistiques d'Accessibilité",
        accessibility_total: 'Total avec besoins',
        accessibility_percentage: 'Pourcentage',
      },
      booking_report_management: {
        management: 'Gestion des réservations',
        search: 'Recherche de réservations',
        phone: 'Téléphone',
        date_start: 'Date de début',
        date_end: 'Date de fin',
        today: "Aujourd'hui",
        tomorrow: 'Demain',
        calendar: 'Calendrier',
        see_all: 'Voir tout',
        people: 'personnes',
        noShow: 'Non présenté',
        confirmed: 'Confirmée',
        canceled: 'Annulée',
        open: 'Ouvert',
        search_text: 'Résultats de la recherche par téléphone ou sélection de date',
      },
      environment: {
        map: 'Carte des environnements',
        environment: 'Environnement',
        index: 'Environnements',
        name: "Nom de l'environnement",
        tables: 'Nombre de tables',
        seats_available: 'Total des places disponibles',
        actions: 'Actions',
      },
      week_day: {
        sun: 'Dim',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thur: 'Jeu',
        fri: 'Ven',
        sat: 'Sam',
      },
      week_day_full: {
        sun: 'Dimanche',
        mon: 'Lundi',
        tue: 'Mardi',
        wed: 'Mercredi',
        thur: 'Jeudi',
        fri: 'Vendredi',
        sat: 'Samedi',
      },
      checkout: {
        title: 'Données du Client',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Voici les champs nécessaires pour la création du client.',
        active_mandatory: 'Champ Obligatoire',
        active_visibility: 'Champ Visible',
      },

      liveShop: {
        liveShop: 'Live Commerce',
        liveShop_list: 'Voici les événements Live Commerce listés avec leurs actions respectives.',
        create: 'Créer un Live Commerce',
        edit: 'Modifier le Live Commerce',
        dateInit: 'Début',
        hourInit: 'Heure de Début',
        dateEnd: 'Fin',
        hourEnd: 'Heure de Fin',
        status: 'Statut',
        initDate: 'Date et Heure de Début',
        fimDate: 'Date et Heure de Fin',
        name: 'Nom',
        variations: 'Variations du Produit',
        search_products_Attentions:
          'Les Produits et Variations retournés doivent avoir un statut activé, posséder un prix, un stock et une image',
        alert_delete: 'Impossible de supprimer un Live qui a commencé ou est terminé !',
        alert_Edit: 'Impossible de modifier un Live qui a commencé ou est terminé !',
        delete: 'Supprimer le Live Commerce',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Erreur code téléphone Pagseguro',
        pagseguroPaymentErrorCountry: 'Erreur code pays Pagseguro',
        pagseguroPaymentErrorEmail: 'Erreur email Pagseguro',
        authenticatePagseguro: 'Authentification Pagseguro',
        pagseguroPayment: 'Paiement Pagseguro',
        pagseguroPaymentCatch: 'Paiement Pagseguro',
        pagseguroPaymentResponse: 'Réponse du paiement Pagseguro',
        pagseguroPaymentTransactions: 'Transaction du paiement Pagseguro',
        pagseguroReturnPayment: 'Retour du paiement Pagseguro',
        paymentPixPagseguro: 'Paiement Pix Pagseguro',

        pagseguroPaymentGateway: 'Passerelle de paiement Pagseguro',
        getAuthPagseguroEmailSpace: 'Authentification Pagseguro par email',
        getOneApplicationClientId: "Obtenir l'application du client Pagseguro",
        createAuthPagseguro: "Créer l'authentification Pagseguro",
        generatePublicKeyPagseguro: 'Générer la clé publique Pagseguro',
        updateCodeRedirectApplication: "Mise à jour du Code de redirection d'application Pagseguro",
        deleteAuthPagseguroByEmail: "Supprimer l'authentification Pagseguro",
        createPluginconfig: 'Configuration du plugin',

        //Totvs pagamento HUB
        refundTotvs: 'Remboursement via Totvs',
        refundPayCard: 'Remboursement via Totvs par carte',
        paymentTotvs: 'Paiement via Totvs',
        paymentPixTotvs: 'Paiement Pix via Totvs',

        //Card Structure
        sendUnregisteredCardBrands: 'Marque de carte non trouvée',
        cardStructure: 'Structure de la carte',
        cardStructureInvalidPlugin: 'Plugin invalide pour la passerelle',
        cardStructureGatewayError: 'Erreur de carte pour la passerelle',
        cardStructureData: 'Données de la Carte',
        cardStructureError: 'Erreur des Données de la carte',
        cardStructureDecrypt: 'Déchiffrement de la carte',
        cardStructureFields: 'Champs de la Carte',
        refundCard: 'Remboursement de la Carte',

        //Status
        analysisSatusOrder: 'Statut de la commande pour analyse',
        statusPayPix: 'Statut Pix',

        //Antifraude
        analyseAntifraud: 'Analyse Antifraude',
        dataClearSale: 'Données ClearSale',
        statusAnalysis: "Statut de l'Analyse",

        //estoque
        addSkuInventory: 'Ajouter au stock',
        subtractSku: 'Retirer du stock',
        viewCargoHistory: "Voir l'historique de charge",
        viewCargoHistoryBySku: "Voir l'historique de charge par SKU",

        // Order-Pedido
        sendOrderIn: 'Envoi de la commande',
        cancelOrder: 'Annuler la Commande',
        sendOrder: 'Envoyer la Commande',
        sendOrderRefund: 'Remboursement de la Commande',
        sendOrderError: "Erreur lors de l'envoi de la commande",
        sendOrderResultRefund: 'Résultat du remboursement de la commande',
        sendOrderResultData: "Résultat de l'envoi de la commande",
        sendOrderAntifrud: "Antifraude lors de l'envoi de la commande",
        sendOrderPaymentStruct: 'Structure du paiement de la commande',

        sendOrderDescryptor: 'Déchiffrement de la Commande',
        sendOrderStatus: 'Statut de la commande',
        sendOrderConfigNotFound: "Configuration de l'envoi de la commande",
        sendOrderMandatoryCustomer: 'Client de la commande',
        sendOrderMandatory: 'Structure obligatoire de la commande',
        sendOrderResultGateway: "Résultat de l'envoi à la passerelle",
        OrderFashionService: 'Service de commande Fashion',
        OrderFashionServiceError: 'Erreur dans le service de commande Fashion',
        cartOrderLive: 'Panier de la commande Live',
        cartOrderLiveError: 'Erreur dans le panier de la commande Live',
        sendOrderErrorGeral: 'Erreur dans la commande',
        sendPushNotification: 'Envoyer une notification push',

        //Pre-Order
        preOrderStatusPix: 'Statut de la Pré-commande via Pix',
        processQueuePreOrder: "Traitement de la file d'attente de la pré-commande",
        getAllPreOrderBySpace: 'Obtenir toutes les pré-commandes par pluginspace',
        sendPreOrder: 'Envoi de la Pré-commande',
        makeOrderTransparent: 'Vérification de la commande',
        statusPreOrder: 'Mise à jour du Statut Pix de la Pré-commande',
        preOrderStatusCanceledPix: 'Annuler la Pré-commande via Pix',

        //Totvs Wintor
        buildOrderTotvsWinthor: 'Créer la Commande',
        sendOrderWinthor: 'Envoi de la commande à Totvs',
        sendCustomerOrderWinthor: 'Envoi du client à Totvs',

        //Totvs Varejo
        buildOrderTotvsVarejo: 'Créer la Commande',
        setConfimTicket: 'Confirmation du Ticket',
        SyncOrderLive: 'Synchronisation des Commandes',
        ObterProdutos: 'Obtenir les Produits',
        taskPrice: 'Charge de Prix',
        calculationPromotion: 'Calcul de Promotion',
        PayloadCalcPromotion: 'Charge Utile Calcul de Promotion',

        //Totvs Moda
        changeStatus: 'Changement de Statut',
        sendOrderFashion: 'Envoi de la commande à Totvs',
        sendCustomerFashion: 'Envoi du client à Totvs',
        searchPersonTotvsByCPF: 'Recherche de Client Totvs',
        sendErrorCustomerFashion: "Erreur dans l'envoi du Client au Fashion",
        buildCustomerTotvsFashion: 'Création de client chez Totvs',
        ResumeSnyOrderFashion: 'Résumé de la synchronisation avec Fashion',
        changeStatusFashion: 'Changer le Statut',
        buildOrderTotvsFashion: 'Créer la Commande Fashion',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'Changement de Statut',
        buildOrderTotvsFood: 'Créer la Commande',
        changeStatusOrderFood: 'Changement de Statut',
        sendOrderTotvsFood: 'Envoi de la commande à Totvs',
        confirmMenu: 'Menu Confirmé',
        getMenu: 'Obtenir le Menu Totvs',

        //Totvs Live
        sendCustomerLive: 'Envoi du Client Live',
        sendOrderLive: 'Envoi de la Commande Live',

        //Synkar
        updateStatusOrderSynkar: 'Mise à jour de la Commande Synkar',
        sendingOrderMessageSynkar: 'Envoi de Messagerie Synkar',
        responseOrderMessageSynkar: 'Réponse de Messagerie Synkar',
        sendingOrderSynkar: 'Envoi Synkar',
        responseOrderSynkar: 'Réponse Synkar',

        //SDS
        sdsGetOrders: 'Obtenir les commandes SDS',
        sdsOrderIn: 'Envoi des commandes SDS',
        sdsOrderInResult: 'Envoi de la commande à SDS',
        sdsSyncCardapio: 'Synchronisation du menu avec SDS',
        'sendOrderfood-sdsOrderIn': "Erreur lors de l'envoi de la commande à SDS",

        //S3
        createRoute: 'Créer Route S3',
        getStatusfiftythree: 'Statut Route 53',
        updateDistribution: 'Mettre à jour la Distribution',
        deleteRoute: 'Supprimer Route S3',
        deleteDistribution: 'Supprimer la Distribution',

        //Erede
        refundErede: 'Remboursement Erede',
        paymentErede: 'Paiement Erede',

        //Cielo
        refundCielo: 'Remboursement Cielo',
        paymentCielo: 'Paiement Cielo',

        //Pagseguro
        refundPagseguro: 'Remboursement Pagseguro',
        getApplicationPagseguro: 'Passerelle Application Pagseguro',

        //pagamento offline
        paymentOffline: 'Paiement à la livraison',

        //Geral
        chargeSyncOrderErro: 'Erreur dans la Synchronisation de Statut',
        chargeSyncOrder: 'Synchronisation de Statut',
        chargeProductLive: 'Synchronisation des Produits Live',
        chargeBalanceLive: 'Synchronisation du Stock Live',
        chargePriceLive: 'Synchronisation des Prix Live',
        chargeProductLiveErro: 'Erreur dans la Synchronisation des Produits Live',
        chargeBalanceLiveErro: 'Erreur dans la Synchronisation du Stock Live',
        chargePriceLiveErro: 'Erreur dans la Synchronisation des Prix Live',

        chargeProduct: 'Synchronisation des Produits',
        chargeBalance: 'Synchronisation du Stock',
        chargePrice: 'Synchronisation des Prix',
        chargeProductErro: 'Erreur dans la Synchronisation des Produits',
        chargeBalanceErro: 'Erreur dans la Synchronisation du Stock',
        chargePriceErro: 'Erreur dans la Synchronisation des Prix',

        taskBalanceIntegration: 'Intégration de la Charge de stock',
        taskBalanceCharge: 'Charge de stock initiée',
        SnyOrder: 'Synchronisation de statut de commande',
        syncronyzePriceInteration: 'Charge de Prix',
        syncronyzePrice: 'Synchronisation de Prix',
        chargeClassification: 'Charge de catégorie et sous-catégorie',
        chargeGrid: 'Charge de grille',
        chargeGridItens: 'Éléments de Charge de grille',
        chargeMeasure: "Charge d'unité de mesure",
        deleteAllProducts: 'Supprimer tous les Produits',

        chargeGridToken: 'Jeton pour la charge de Grille',
        classificationChargeToken: 'Jeton pour la charge de Classification',
        syncronyzeBalanceToken: 'Jeton pour la synchronisation de Stock',
        syncronyzePriceToken: 'Jeton pour la synchronisation de Prix',
        chargeMeasureToken: "Jeton pour la charge d'Unité de Mesure",
        taskClassificationBySpace: 'Charge de Classification',
        syncStatusOrderPayload: 'Charge Utile de Synchronisation de Statut de Commande',
        syncStatusOrder: 'Synchronisation de Statut de Commande',
        syncStatusOrderToken: 'Jeton de Synchronisation de Statut de Commande',
        syncronyzeBalancePayload: 'Charge Utile de Synchronisation de Stock',
        syncronyzeBalance: 'Synchronisation de Stock',
        taskBalanceChargeBySpace: 'Charge de Stock',
        syncronyzePricePayload: 'Charge Utile de Synchronisation de Prix',
        priceSkuVariationItens: 'Prix des Éléments de la Variation',
        configSyncOrderBySpace: 'Configuration de Synchronisation de Commande',
        configSyncOrder: 'Configuration de Synchronisation de Commande',
        taskGridChargeBySpace: 'Charge de Grille',
        productChargeInternal: 'Charge de Produit',
        taskChargeProductBySpace: 'Charge de Produit',
        skuLocationVariation: 'Synchronisations de Variation par Localisation',
        stockSkuVariation: 'Synchronisations de Variation',
        taskPriceChargeBySpace: 'Charge de Prix par Pluginspace',

        automaticChargeBalance: 'Sync Auto de Stock',
        automaticChargePrice: 'Sync Auto de Prix',
        automaticChargeClassification: 'Sync Auto de Classification',
        automaticTaskGridCharge: 'Sync Auto de Grille',
        automaticTaskMeassure: "Sync Auto d'Unité de Mesures",
        automaticSnyOrder: 'Sync Auto Statut de Commandes',
        chargeMeasureItens: "Éléments de charge d'Unité de Mesure",
        searchMeasurementAll: "Charge d'unité de mesure",
        taskGridCharge: 'Charge de Grille',
        taskMeassure: "Charge d'unité de mesure",

        getCredential: 'Obtenir le Jeton',
        LoadPricePerList: 'Charge de Prix',
        processPriceList: 'Traitement de la Liste de Prix',
        updateProductKit: 'Mise à jour des Produits',
        UpdateProductSingle: 'Mise à jour des Produits',
        updateProductStatus: 'Mise à jour du Statut de Produit',
        taskBalanceIntegrationLink: "Lien d'intégration de stock",
        taskPriceIntegrationLink: "Lien d'intégration de prix",
        taskProductIntegrationLink: "Lien d'intégration de produit",
        token: 'Obtention de Jeton',
        automaticChargeProduct: 'Charge automatique de produits',

        //Desconto Ninegrid
        calculateDiscount: 'Calcul de la remise dans ninegrid',
        sendDiscountNinegrid: 'Remise Ninegrid',

        //Customer Cart
        updateCustomerCartStatus: 'Mise à jour du panier du Client',

        //Cliente
        createCustomer: 'Création du Client',
        validCodeCustomer: 'Code de validation du Client',

        //clearSale
        statusAnalisis: 'Analyse du Statut',
        antifraudValidation: "Validation de l'antifraude",
        clearSale: 'ClearSale Garanti',
        searchOrderStatusClearSale: 'Recherche Statut ClearSale',

        printLabelFrenet: 'Étiquette Frenet',
        changeStatusFrenet: 'Changement de statut Frenet',
        callWaiter: 'Appeler le Serveur',
        paymentTable: 'Paiement à table',

        // Geracao de nota Fiscal Do Chef
        generateNfOrderFood: 'Générer la facture de la commande',
        getNotaFiscalChef: 'Récupérer la facture du Chef',
        finishOrderFood: 'Vérification préalable à la facture',

        // Log de erro do pedido Chef
        buildCardData: 'Erreur lors de la création de données pour la Commande',
        buildTableData: 'Erreur lors de la création de données pour la Table',
        buildTablePaymentData: 'Erreur lors de la création de données pour le Paiement à Table',
        buildCounterData: 'Erreur lors de la création de données pour le Comptoir',
        buildDeliveryData: 'Erreur lors de la création de données pour la Livraison/Retrait',

        generateCustomerWholeSalerByCSV: 'Générer un client grossiste par CSV',

        validateStockWholeSaleCart: 'Alerte de commande',
        validateWholeSaleCart: 'Alerte de commande',

        chargeImageService: "Service de charge d'images",

        webhookNisRedis: 'Nettoyage du Redis du Magasin',

        /*Envio de email  */
        sendEmailWelcome: 'Envoyer un email de bienvenue',
        sendEmailOrderNotification: 'Envoyer une notification de commande par email',
        sendEmailAccountNotification: 'Envoyer une notification de compte par email',
        createCustomerLogin: 'Envoyer un email de création de login client',
        /*Seller Queue */
        sellerOrderFilterPDVTotvsPersistResponse: 'Persistance du filtre de commandes PDV Totvs',
        sellerOrderFilterPDVTotvsPersistRequest: 'Requête du filtre de commandes PDV Totvs',
      },

      copy: {
        definition: 'Définition de Pluginspace',
        origin: "Sélectionnez le Pluginspace d'origine",
        destination: 'Sélectionnez le Pluginspace de destination',
        configurations: 'Configurations de la copie',
        store: 'Paramètres du Magasin',
        deliveryFee: 'Frais de livraison',
        shifts: 'Quarts',
        paymentPlans: 'Plans de paiement',
        clientData: 'Données du Client',
        account: 'Paramètres du Compte',
        groups: 'Groupes',
        terms: 'Termes',
        webapp: 'Webapp',
        webappConfig: 'Configurations',
        webappPersonalize: 'Personnalisation',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: 'Configurations',
        whatsappwebPersonalize: 'Personnalisation',
        integrations: 'Intégrations',
        integrationPayment: 'Moyens de paiement',
        integrationPdv: 'PDV',
        integrationMessaging: 'Messagerie',
        integrationOthers: 'Autres',
        button: 'Copier Pluginspace',
      },

      payment: {
        methods: 'Moyens de paiement',
        method: 'Mode de paiement',
        gateway: 'Passerelle de paiement',
        card: 'Carte de crédit',
        debit: 'Carte de débit',
        food: 'Chèque alimentaire',
        pix: 'Pix',
        others: 'Autres',
        pay_money: 'Espèces',
        config: 'Configurations',
        add: 'Configurer le moyen de paiement',
        back: 'Retour aux passerelles de paiement',
        basic_settings: 'Configurations de base',
        modalities: 'Modalités où ce moyen de paiement sera utilisé',
        add_payment: 'Ajouter un mode de paiement',
        code_erp: 'Code ERP',
        installments: 'Nombre de versements',
        edit_payment: 'Modifier le mode de paiement',
        delete: 'Supprimer le mode de paiement',
        money: 'Paiement en espèces',
        max_installments: 'Quel est le nombre maximum de versements ?',
        min_value_installments: 'Quelle est la valeur minimale pour les versements ?',
        confirm: 'Confirmer la suppression',
        delete_payment: 'Voulez-vous supprimer le mode de paiement',
        change: 'Voulez-vous effectuer cet échange ?',
        inative: 'Voulez-vous désactiver ce mode de paiement ?',
        inative_change: "Voulez-vous activer ce mode de paiement et désactiver l'ancien ?",
        motive: 'Veuillez indiquer le motif',
        /* usado para desconto */
        config_descount_payment: 'Configuration de remise par moyen de paiement',

        able_discount_pix: 'Activer la remise pour le paiement Pix',
        able_discount_card: 'Activer la remise pour le paiement par Carte',
        able_discount: 'Activer la remise pour le paiement',

        discount_percentage: 'Remise en Pourcentage',
        discount_monetary: 'Remise Monétaire',
        discount_value: 'Valeur de la remise',
      },

      icon: {
        title: 'Icônes',
        subtitle: 'Voici tous les icônes de la bibliothèque listés',
      },
      freight: {
        title: "Modalités d'envoi",
        map: 'Carte',
        map_text: 'Option de paiement à la livraison de la commande',
        range: 'Rayon',
        range_text: 'Option de paiement à la livraison de la commande',
        cep: 'Liste de Code Postal',
        cep_text: 'Option de paiement à la livraison de la commande',
        config: 'Configurations',
        delivery: 'Livraison propre',
        delivery_text: 'Il y a 3 options de livraison personnalisables :',
        frenet: 'Frenet',
        frenet_text: "Gestion complète des frets avec divers transporteurs et modes d'envoi.",
        frenet_text_2: "Pour activer cette intégration, il est nécessaire d'avoir un plan Frenet.",
        site: 'Voir le site officiel',
        coming_soon: 'Bientôt disponible...',
      },
      frenet: {
        title: 'Intégration avec Frenet',
        back: 'Retour aux moyens de livraison',
        integration: 'Intégration',
        config: 'Configurations',
        dimensions: 'Dimensions de base de la livraison en centimètres',
        height: 'Hauteur',
        width: 'Largeur',
        length: 'Longueur',
        value: 'Valeur déclarée des produits',
        use: 'Utiliser',
        dont_use: 'Ne pas utiliser',
        price: 'Utiliser la cotation simplifiée ?',
        yes: 'Oui',
        no: 'Non',
        branchCode: 'Point de dépôt Jadlog',
        no_balance: 'Pas de solde chez Frenet',
        value_balance: 'Vous avez @ de solde chez Frenet',
        print_balance:
          "Pour imprimer l'étiquette d'envoi de cette commande, vous devez charger du solde sur votre compte Frenet.",
        click_balance:
          'Cliquez sur le bouton ci-dessous pour accéder à Frenet dans un autre onglet.',
        open_balance: 'Ouvrir le compte Frenet',
        valid_token: 'Jeton invalide',
        declared_value: "La valeur déclarée est utilisée en cas d'assurance par le transporteur.",
        getToken:
          'Pour trouver le jeton chez Frenet, vous devez accéder à la section des clés d\'accès et copier la valeur du champ "TOKEN".',
        weight_frenet: 'Poids standard (kg)',
        height_frenet: 'Hauteur standard (cm)',
        width_frenet: 'Largeur standard (cm)',
        depth_frenet: 'Profondeur standard (cm)',
        alert_title: 'Dimensions de référence pour le calcul du fret',
        alert_warning: 'Attention !',
        alert_description:
          'Ces mesures seront utilisées pour calculer le fret des produits sans volumétrie enregistrée.',
        alert_wrong_values: 'Des valeurs incorrectes peuvent générer :',
        alert_overpriced: 'Fret surfacturé (éloignant les clients).',
        alert_additional_costs:
          'Coûts additionnels (si le transporteur ajuste la valeur ultérieurement).',
        alert_recommendation:
          "Nous recommandons d'enregistrer la volumétrie réelle de chaque produit.",
        alert_reference: 'Dimensions de référence :',
        alert_small_products: 'Petits produits',
        alert_small_examples: '(ex: accessoires, bijoux, câbles)',
        alert_small_weight: 'Poids: 0,1–0,3 kg',
        alert_small_dimensions: 'Dimensions: 10 × 10 × 5 cm',
        alert_medium_products: 'Produits moyens',
        alert_medium_examples: '(ex: vêtements, livres, petits appareils électroniques)',
        alert_medium_weight: 'Poids: 0,5–2 kg',
        alert_medium_dimensions: 'Dimensions: 25 × 20 × 10 cm',
        alert_large_products: 'Grands produits',
        alert_large_examples: '(ex: appareils électroménagers, boîtes volumineuses)',
        alert_large_weight: 'Poids: 5–20 kg ou plus',
        alert_large_dimensions: 'Dimensions: 50 × 40 × 30 cm ou plus',
      },
      chat: {
        you: 'Vous',
        now: 'Envoyé maintenant',
        send: 'Envoyer',
        type_message: 'Envoyez un message...',
        initial_message: 'Bienvenue dans le chat IA de Ninegrid',
        error_message:
          "Je n'ai pas pu trouver de réponse à votre message, veuillez être plus précis ou réessayer plus tard.",
        tip_language: 'Veuillez répondre en français.',
        title_config: "Configurations d'Intelligence Artificielle",
        config: "Configurer l'Intelligence Artificielle",
        fit: "Entraînement de l'Intelligence Artificielle",
        fit_header: 'Voici les questions listées avec les réponses créées respectives',
        add_question: 'Ajouter une question',
        edit_question: 'Modifier la question',
        delete_question: 'Voulez-vous supprimer la question ci-dessous ?',
        question: 'Question',
        answer: 'Réponse',
        date: 'Date',
        actions: 'Actions',
        active: 'Actif',
        delete: 'Supprimer',
        sync: "Synchroniser l'IA",
        upload: 'Téléchargement du fichier',
        about: 'À propos',
        chatia: 'Chat',
        about_title: 'À propos de Ninegrid IA',
        about_description_title: 'Description',
        about_description:
          'Ninegrid IA est un assistant virtuel intelligent conçu pour vous aider avec les tâches de support.',
        about_support_title: 'Support',
        about_support_description:
          "Si vous avez des questions ou avez besoin d'aide, notre équipe de support est prête à vous aider.",
        about_support_contact_1: 'Pour parler au support, contactez-nous par email',
        about_support_contact_2: 'ou ouvrez un ticket sur notre portail :',
        about_features_title: 'Fonctionnalités',
        tips: 'Conseils pour créer vos questions',
        about_tips_1:
          'Utilisez des questions claires et objectives pour obtenir de meilleures réponses.',
        about_tips_2: "Évitez l'argot ou les termes techniques complexes.",
        about_tips_3: "Si la réponse n'est pas satisfaisante, essayez de reformuler la question.",
        about_tips_4:
          "Ninegrid IA apprend des interactions, donc plus vous l'utiliserez, meilleur il deviendra.",
        feature_1: 'Conversation en langage naturel',
        feature_2: 'Support des commandes vocales',
        feature_3: 'Synthèse vocale pour les réponses',
        feature_4: 'Interface intuitive et réactive',
        about_manuals: 'Manuels',
        about_manuals_description:
          "Consultez nos manuels pour en savoir plus sur l'utilisation de l'Environnement Ninegrid,",
        about_faq: 'Questions Fréquentes',
        about_faq_description:
          'Consultez les questions les plus fréquentes et leurs réponses pour clarifier les doutes courants,',
        about_version_title: 'Informations sur le Système',
        version: 'Version',
        last_update: 'Dernière mise à jour',
        rights_reserved: 'Tous droits réservés',
        access_here: 'accédez ici',
        our_faq: 'voir les questions fréquentes',
        or: 'ou',
        and: 'et',
      },
      sumary_access: {
        cart: 'Panier',
        seller: 'Connexion Vendeur',
        category: 'Catégories',
        pdv: 'Détails du Produit',
        subcategory: 'Sous-catégorie',
        product: 'Liste de Produits',
        home: 'Écran Initial',
        'search-order': 'Commandes',
        'store-info': 'Informations du Magasin',
        customer: 'Enregistrement de client',
        receipt: 'Reçu de paiement',
        order: 'Paiement',
        card: 'Paiement par Carte',
        'order-qrcode': 'Paiement Pix Client',
        'success-order': "Succès de l'Achat",
        'filter/pdv': 'Résultat des Filtres',
        filter: 'Sélection de Filtres',
        'seller-qrcode': 'Lien de Paiement',
        'vendor-order ': 'Consultation du panier Vendeur',
        'finalize-order': "Résumé de l'achat",
      },
      optional: {
        optionals: 'Articles Additionnels',
        list: "Liste d'Articles Additionnels",
        name: 'Nom',
        used: 'Utilisé dans',
        config: 'Configurer',
        link: 'Associer des produits',
        products_optional: 'Produits associés à la liste',
        edit: "Modifier la liste d'articles additionnels",
        type: 'Type de sélection',
        max: 'Maximum',
        mandatory: 'Obligatoire',
        order: 'Ordre',
        code: 'Code',
        qtd: 'Qté maximale',
        price: 'Prix',
        include: 'Inclure un article additionnel',
        create: "Créer une liste d'articles additionnels",
        description: 'Description webapp',
        emptyProduct: "Aucun produit n'utilise cet article additionnel",
      },

      coupons: {
        title: 'Coupons',
        report: 'Rapports de Coupons',
        titleCreate: 'Créer des Coupons',
        titleUpdate: 'Modifier des Coupons',
        subTitle: 'Voici les coupons listés avec leurs actions respectives.',
        create: 'Créer un Coupon',
        edit: 'Modifier le Coupon',
        delete: 'Supprimer le Coupon',

        //variaveis do input
        name: 'Nom du Coupon',
        name_helper: 'Maximum 15 caractères',
        description: 'Description',
        description_placeholder: 'devra accepter au maximum 200 caractères',
        seller: 'Vendeur',
        catalog: 'Catalogue',
        discountValue: 'Valeur de la Remise',
        discountPercentage: 'Pourcentage de la Remise',
        type: 'Type',
        dateInit: 'Date de début',
        dateEnd: 'Date de fin',
        quantitative: "Quantité d'utilisations",
        typeOptions: {
          all: 'Tous les Types',
          classification: 'Classification',
          product: 'Produit',
          individuality: 'Individuel',
          exclusive: 'Exclusif',
          quantitative: 'Quantitatif',
          periodical: 'Périodique',
          cupomday: 'Jour du Coupon',
        },
        filters: 'Filtres',
        status: 'Statut',
        selectStatuses: 'Sélectionnez les statuts',
        actions: {
          filter: 'Filtrer',
          export: 'Exporter',
        },
        quick: {
          today: "Aujourd'hui",
          week: 'Cette semaine',
          month: 'Ce mois',
          lastMonth: 'Mois dernier',
          year: 'Cette année',
        },
        stats: {
          title: 'Statistiques Générales',
          totalCoupons: 'Total des Coupons',
          activeCoupons: 'Coupons Actifs',
          totalUsages: 'Total des Utilisations',
          totalDiscount: 'Total des Remises',
        },
        distribution: {
          title: 'Répartition par Type',
        },
        monthlyUsage: {
          title: 'Utilisation Mensuelle',
        },
        series: {
          usageCount: "Nombre d'utilisations",
          numberOfUses: "Nombre d'utilisations",
          discountValue: 'Valeur de la Remise',
        },
        table: {
          details: 'Détails des Coupons',
        },
        statusLabels: {
          true: 'Actif',
          false: 'Inactif',
        },
        statusOptions: {
          all: 'Tous',
          active: 'Actif',
          inactive: 'Inactif',
          expired: 'Expiré',
        },
      },

      order_print: {
        title: "Vérifiez les informations de la commande avant de confirmer l'impression",
        print_text: 'Imprimer',
        information:
          'QZ Tray demandera la permission d\'établir la connexion. Cliquez sur "Autoriser" pour continuer l\'impression.',
        order_details: 'Détails de la Commande',
        client: 'Client',
        payment: 'Paiement',
        created: 'Créé',
        print: 'Imprimer la Commande',
        print_confirm:
          "Voulez-vous imprimer cette commande ? Assurez-vous que l'imprimante est connectée et configurée correctement avant de continuer",
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle: 'Voici les configurations WhatsApp listées avec leurs actions respectives.',
        titleCreate: 'Synchroniser WhatsApp',
        titleDelete: 'Supprimer la Synchronisation WhatsApp',
        create: 'Synchroniser WhatsApp',
        delete: 'Supprimer la Session WhatsApp',
        active: 'Actif',
        welcome: 'WhatsApp Web de Ninegrid',
        describe_whatsappweb:
          'Ici, il est possible de lier WhatsApp WEB avec le téléphone portable du magasin !',
        config: 'Pour configurer WhatsApp',
        step1: 'Ouvrez WhatsApp sur votre téléphone.',
        step2: "Appuyez sur Plus d'options ⋮ sur Android ou sur Paramètres ⚙️ sur iPhone.",
        step3: 'Appuyez sur Appareils connectés, puis sur Connecter un appareil.',
        step4: 'Pointez votre téléphone vers cet écran pour scanner le Code QR.',
      },
      fileManagement: {
        title: 'Gestionnaire de Fichiers',
        subtitle: 'Voici les fichiers listés avec leurs actions respectives.',
        create: 'Créer un Fichier',
        edit: 'Modifier le Fichier',
        delete: 'Supprimer le Fichier',
        download: 'Télécharger le Fichier',
        upload: 'Envoyer le Fichier',
        file: 'Fichier',
        file_name: 'Nom du Fichier',
        file_item: 'Élément',
        file_itens: 'Éléments',
        file_type: 'Type de Fichier',
        file_size: 'Taille du Fichier',
        file_date: 'Date de Création',
        file_actions: 'Actions',
        file_folder: 'Dossier',
        file_new_folder: 'Nouveau Dossier',
        file_folder_name: 'Nom du Dossier',
        file_last_modified: 'Dernière Modification',
        file_description: 'Description du Fichier',
        file_description_placeholder: 'Description du fichier',
        file_description_helper: 'Maximum 200 caractères',
        file_name_placeholder: 'Nom du fichier',
        file_name_helper: 'Maximum 15 caractères',
        file_page_showing: 'Affichage',
        file_not_found: 'Aucun fichier trouvé',
        file_uploading: 'Chargement du fichier',
        file_upload: 'Charger un Fichier',
        file_changing: 'Modification du fichier',
        file_Loading: 'Chargement des fichiers',
        file_update: 'Mettre à jour',
        file_sync_knowledge_base: 'Synchroniser la Base de Connaissances',
        file_history_sync: 'Historique de Synchronisation',
        scanned: 'Scanné',
        indexed: 'Indexé',
        modified: 'Modifié',
        completed: 'Terminé',
        deleted: 'Supprimé',
        failed: 'Échoué',
        available: 'Disponible',
        last_update: 'Dernière mise à jour',
        status: 'Statut',
        status_job: 'Statut de la Tâche',
        data_source: 'Source de Données',
        knowledge_base: 'Base de Connaissances',
        history_sync: 'Historique de Synchronisation',
        chart_scanned_doc: 'Documents Scannés',
        chart_indexed_doc: 'Documents Indexés',
        chart_modified_doc: 'Documents Modifiés',
        chart_deleted_doc: 'Documents Supprimés',
        chart_failed_doc: 'Documents en Échec',
        chart_docs_processed: 'Documents Traités',
        chart_docs_total: 'Total des Documents',
        total_jobs_processed: 'Total des Tâches Traitées',
        jobs_info: 'Informations sur les Tâches',
        observation_table_jobs_phase:
          'Le Tableau des Tâches Traitées présente les 5 dernières tâches de chaque source de données.',
      },
      service_requests: {
        title: 'Formulaires de Service',
        subtitle: 'Gérez les formulaires de demande de services',
        create: 'Créer un Formulaire de Service',
        edit: 'Modifier le Formulaire de Service',
        delete: 'Supprimer le Formulaire de Service',
        create_form: 'Créer un Formulaire',
        edit_form: 'Modifier le Formulaire',
        delete_form: 'Supprimer le Formulaire',
        form_title: 'Titre',
        form_icon: 'Icône',
        form_status: 'Statut',
        form_description: 'Description',
        form_components: 'Composants',
        form_grids: 'Grilles',
        priority_label: 'Priorité',
        priority_low: 'Basse',
        priority_normal: 'Normale',
        priority_high: 'Haute',
        priority_critical: 'Critique',
        choose_icon: 'Choisir',
        add_component: 'Ajouter',
        sections: 'Sections',
        empty_message:
          'Cliquez sur Ajouter pour insérer des composants et faites glisser pour réordonner.',
        success_created: 'Le formulaire de service a été créé avec succès.',
        success_updated: 'Le formulaire de service a été mis à jour avec succès.',
        success_deleted: 'Formulaire de service supprimé avec succès.',
        error_create: 'Une erreur est survenue lors de la création du formulaire de service.',
        error_update: 'Une erreur est survenue lors de la mise à jour du formulaire de service.',
        error_delete: 'Erreur lors de la suppression du formulaire de service.',
        error_load: 'Erreur lors du chargement !',
        validation_title: 'Veuillez entrer un titre pour la session',
        validation_icon: 'Veuillez choisir une icône pour la session',
        validation_components: 'Ajoutez au moins un composant avant de sauvegarder',
        placeholder_title: 'Ex: Nettoyage',
        icon_selected: 'Icône sélectionnée (SVG)',
        icon_none: 'Aucune icône sélectionnée',
        visual_instructions:
          'Construisez la session visuellement. Faites glisser pour réordonner. Les champs sont uniquement visuels (non interactifs).',
        component: 'composant',
        components_plural: 'composants',
        grid: 'grille',
        grids_plural: 'grilles',
        grid_services: 'Grilles de Services',
        grid_services_title: 'Sélectionner les Grilles de Services',
        grid_services_search: 'Rechercher des grilles',
        grid_services_label: 'Grilles',
        grid_services_selected: 'Grilles sélectionnées',
        grid_services_error: "Erreur lors de la recherche des grilles d'hôtel",
        add_component_modal: 'Ajouter un composant',
        validation_grids_required: 'Grilles obligatoires',
        validation_grids_text:
          'Tous les composants de sélection doivent avoir au moins une grille de services sélectionnée.',
        actions: 'Actions',
        breadcrumb_dashboard: 'Tableau de bord',
        breadcrumb_essential_services: 'Services Essentiels',
        // UI Elements
        drag_title: 'Glisser',
        drag_action: 'Glissez',
        remove_title: 'Supprimer',
        remove_aria_label: 'Supprimer le bloc',
        max_quantity_title: 'Quantité maximale :',
        max_prefix: 'Max:',
        description_label: 'Description',
        sections_label: 'Sections',
        // Modal titles and actions
        select_icon_title: 'Sélectionner',
        no_icons_available: 'Aucun icône disponible…',
        search_placeholder: 'Tapez pour rechercher...',
        grid_services_selected_label: 'Sélectionnées :',
        no_grid_found: 'Aucune grille trouvée',
        no_grid_available: 'Aucune grille disponible',
        grid_status_active: 'Actif',
        grid_status_inactive: 'Inactif',
        grid_item_name_placeholder: 'Nom (Ex. : Massage Relaxant)',
        grid_item_value_placeholder: 'Valeur (Ex. : 50,00)',
        cancel_button: 'Annuler',
        save_button: 'Sauvegarder',
        confirm_button: 'Confirmer',
        // Quantity modal
        max_quantity_modal_title: 'Définir la Quantité Maximale',
        max_quantity_label: 'Quantité maximale',
        max_quantity_placeholder: 'Entrez la quantité maximale',
        max_quantity_helper:
          "Définit le nombre maximum d'éléments qui peuvent être sélectionnés dans ce champ.",
        // Breadcrumbs
        breadcrumb_create: 'Créer',
        breadcrumb_edit: 'Modifier',
        // Form components
        sample_service_1: 'Service 1',
        sample_service_2: 'Service 2',
        sample_hygiene: 'Hygiène',
        sample_drinks: 'Boissons',
        room_number_label: 'Numéro de chambre',
        select_placeholder: 'Sélectionnez...',
        date_label: 'Date',
        hour_label: 'Heure',
        quantity_label: 'Quantité',
        between_placeholder: 'Entre',
        and_placeholder: 'et',
        select_list_label: 'Sélection (liste)',
        select_item_placeholder: 'Sélectionnez un élément',
        select_checkbox_label: 'Sélection (case à cocher)',
        // Visibility
        visible_to_label: 'Visible pour',
        visible_to_employees: 'Employés',
        visible_to_customers: 'Clients',
        visible_to_both: 'Les deux',
        select_category_placeholder: 'Sélectionnez une catégorie',
        select_quantity_label: 'Sélection (quantité)',
        qty_label: 'Qté.',
        // Catalog titles
        catalog_room_number: 'Numéro de chambre',
        catalog_date: 'Date',
        catalog_hour: 'Heure',
        catalog_date_hour: 'Date + Heure',
        catalog_select_list: 'Sélection (liste)',
        catalog_select_list_quantity: 'Sélection (Liste) + Quantité',
        catalog_select_checkbox: 'Sélection (case à cocher)',
        catalog_select_count: 'Sélection (quantité)',
        catalog_quantity: 'Quantité',
      },
      base_modal: {
        attention_title: 'Attention !',
        unsaved_changes_text:
          'Les changements effectués seront perdus, êtes-vous sûr de vouloir quitter ?',
        confirm_button: 'Oui',
        cancel_button: 'Non',
      },
      summarize_ia: {
        title: "Résumé de l'Utilisation de l'IA",
        subtitle: "Voici les informations de résumé de l'IA listées.",
        create: 'Créer un Résumé IA',
        edit: 'Modifier le Résumé IA',
        delete: 'Supprimer le Résumé IA',
        summarize: 'Résumer',
      },
      hospitality: {
        add_room: 'Ajouter une Chambre',
        create_multiples: 'Créer Plusieurs',
        add_activity: 'Ajouter une Activité',
        add_experience: 'Ajouter une Expérience',
        experiences: 'Expériences ',
        experience_type: "Type d'Expérience",
        experience_duration: "Durée de l'Expérience",
        experience_price: "Prix de l'Expérience",
        experience_rating: "Note de l'Expérience",
        experience_includes: "Inclus dans l'Expérience",
        create_experience: 'Créer une Expérience',
        edit_experience: "Modifier l'Expérience",
        experience_created: 'Expérience créée avec succès !',
        experience_updated: 'Expérience mise à jour avec succès !',
        experience_deleted: 'Expérience supprimée avec succès !',
      },
      hospitality_content: {
        page_title: 'Boutons',
        page_subtitle: 'Voici la liste des boutons des sections.',
        add_button: 'Ajouter un bouton',
        filters: {
          sections: 'Sections',
        },
        table: {
          headers: {
            title: 'Titre',
            order: 'Ordre',
            formTitle: 'Titre du formulaire',
            type: 'Type',
            visibility: 'Visibilité',
            actions: 'Actions',
          },
        },
        tabs: {
          buttons: 'Boutons',
          native_buttons: 'Boutons Natifs',
        },
        actions: {
          edit: 'Modifier le bouton',
          delete: 'Supprimer le bouton',
          delete_confirm: 'Êtes-vous sûr de vouloir supprimer ce bouton ?',
        },
        type_labels: {
          service_form: 'Formulaires de service',
          feedback: 'Votre Opinion',
          service: 'Services',
          information: 'Informations',
          activities_leisure: 'Activités et Loisirs',
          bars_restaurants: 'Bars et Restaurants',
          schedule: 'Programme',
          experience: 'Expérience',
          booking: 'Planification',
          check_in: 'Enregistrement',
          check_out: 'Départ',
          tours: 'Visites',
          page_dynamic: 'Page Dynamique',
        },
        no_category: 'Sans catégorie',
        messages: {
          filter_error_title: 'Erreur',
          filter_error_text: 'Erreur lors du filtrage des sections',
          load_error_title: 'Erreur de chargement',
          load_error_text: 'Échec du chargement des sections !',
          section_not_found_title: 'Erreur',
          section_not_found_text: 'Section introuvable !',
          deleted_title: 'Section supprimée',
          deleted_text: 'Suppression effectuée avec succès !',
          delete_error: 'Erreur lors de la suppression de la section !',
          visibility_updated_title: 'Visibilité Mise à Jour',
          visibility_updated_text: 'La visibilité du bouton a été mise à jour avec succès !',
          visibility_error_title: 'Erreur de Mise à Jour',
          visibility_error_text: 'Erreur lors de la mise à jour de la visibilité du bouton !',
          form: 'Formulaire',
          page: 'Page',
        },
        create_modal: {
          modal_title: 'Ajouter du Contenu',
          alert_title: 'Sélection de la Section et du Contenu',
          alert_subtitle: 'Sélectionnez la section et le contenu correspondants.',
          label_section: 'Section',
          label_content: 'Contenu',
          placeholder_select: 'Sélectionner',
          placeholder_select_section: 'Sélectionnez la section',
          placeholder_select_content: 'Sélectionnez le contenu',
          order_label: 'Ordre',
          selection_summary: 'Résumé de la sélection :',
          badge_section: 'Section',
          badge_content: 'Contenu',
          select_form_label: 'Sélectionnez le formulaire (roomService)',
          tips_title: 'Conseils',
          tips: {
            item1: 'La section peut avoir plusieurs contenus',
            item2: 'Le contenu peut appartenir à plusieurs sections',
            item3: "L'ordre définit la position dans la liste",
          },
          buttons: {
            cancel: 'Annuler',
            create: 'Créer',
          },
          swal: {
            missing_field_title: 'Champ manquant',
            missing_section: 'Sélectionnez une section pour continuer',
            missing_content: 'Sélectionnez un contenu pour continuer',
            invalid_field_title: 'Champ invalide',
            invalid_order: "L'ordre doit être un nombre positif ou zéro",
            created_title: 'Contenu enregistré',
            created_text: 'Enregistrement effectué avec succès !',
            create_error: "Erreur lors de l'enregistrement du contenu !",
          },
        },
        edit_modal: {
          modal_title: 'Modifier le Contenu',
          alert_title: 'Modification du Contenu',
          alert_subtitle:
            "Modifiez la section et l'ordre si nécessaire. Le contenu actuel ne peut pas être modifié.",
          label_section: 'Section',
          label_content: 'Contenu',
          placeholder_select: 'Sélectionner',
          placeholder_select_section: 'Sélectionnez la section',
          placeholder_select_content: 'Sélectionnez le contenu',
          order_label: 'Ordre',
          selection_summary: 'Résumé de la sélection :',
          badge_section: 'Section',
          badge_content: 'Contenu',
          tips_title: 'Conseils',
          tips: {
            item1: 'Vous ne pouvez modifier que la section',
            item2: "L'ordre définit la position dans la liste",
          },
          buttons: {
            cancel: 'Annuler',
            save: 'Enregistrer',
          },
          swal: {
            missing_field_title: 'Champ manquant',
            missing_section: 'Sélectionnez une section pour continuer',
            missing_content: 'Sélectionnez un contenu pour continuer',
            invalid_field_title: 'Champ invalide',
            invalid_order: "L'ordre doit être un nombre positif ou zéro",
            updated_title: 'Contenu mis à jour',
            updated_text: 'Mise à jour effectuée avec succès !',
            update_error: 'Erreur lors de la mise à jour du contenu !',
          },
        },
        category: {
          page_title: 'Sections',
          page_subtitle: 'Les sections de contenu sont listées ici avec leurs actions respectives.',
          add_button: 'Ajouter',
          breadcrumbs: {
            dashboard: 'Tableau de bord',
            categories: 'Catégories',
          },
          table: {
            headers: {
              section: 'Section',
              order: 'Ordre',
              status: 'Statut',
              actions: 'Actions',
            },
          },
          options: {
            edit_category: 'Modifier la catégorie',
            delete_section: 'Supprimer la section',
            delete_confirm: 'Supprimer la section',
          },
          swal: {
            deleted_title: 'Section supprimée',
            deleted_text: 'Suppression effectuée avec succès !',
            delete_error: 'Erreur lors de la suppression de la section !',
          },
          create: {
            missing_fields_title: 'Champs manquants',
            missing_fields_text: 'Vérifiez que vous avez correctement rempli tous les champs !',
            created_title: 'Catégorie enregistrée',
            created_text: 'Enregistrement effectué avec succès !',
            create_error: "Erreur lors de l'enregistrement de la catégorie !",
          },
          update: {
            missing_fields_title: 'Champs manquants',
            missing_fields_text: 'Vérifiez que vous avez correctement rempli tous les champs !',
            updated_title: 'Catégorie mise à jour',
            updated_text: 'Modification effectuée avec succès !',
            update_error: 'Erreur lors de la mise à jour de la catégorie !',
          },
          type: {
            default: 'Standard',
            banner: 'Bannière en Vedette',
          },
        },
      },
      clean_safe: {
        title: 'Clean & Safe',
        subtitle:
          'Gérez les mesures de sécurité, les protocoles de nettoyage et les certifications',
        security_measures: 'Mesures de Sécurité',
        cleaning_protocols: 'Protocoles de Nettoyage',
        certifications: 'Certifications',
        add_security_measure: 'Ajouter une Mesure',
        add_cleaning_protocol: 'Ajouter un Protocole',
        add_certification: 'Ajouter une Certification',
        add_new_security_measure: 'Ajouter une Nouvelle Mesure',
        add_new_cleaning_protocol: 'Ajouter un Nouveau Protocole',
        add_new_certification: 'Ajouter une Nouvelle Certification',
        security_measure: 'Mesure de Sécurité',
        cleaning_protocol: 'Protocole de Nettoyage',
        certification: 'Certification',
        icon: 'Icône',
        choose_icon: "Choisir l'Icône",
        title_field: 'Titre',
        description: 'Description',
        status: 'Statut',
        active: 'Actif',
        inactive: 'Inactif',
        remove: 'Supprimer',
        save: 'Sauvegarder',
        required_title: 'Le titre est obligatoire',
        required_icon: "L'icône est obligatoire",
        required_fields: 'Champs obligatoires',
        required_fields_message: 'Veuillez remplir tous les champs obligatoires.',
        confirmation: 'Confirmation',
        delete_security_measure_confirm:
          'Êtes-vous sûr de vouloir supprimer cette mesure de sécurité ?',
        delete_cleaning_protocol_confirm:
          'Êtes-vous sûr de vouloir supprimer ce protocole de nettoyage ?',
        delete_certification_confirm: 'Êtes-vous sûr de vouloir supprimer cette certification ?',
        yes: 'Oui',
        no: 'Non',
        error: 'Erreur',
        error_delete: "Erreur lors de la suppression de l'élément.",
        success: 'Succès',
        success_save: "Données d'hygiène et de sécurité sauvegardées avec succès !",
        error_save: 'Une erreur est survenue lors de la sauvegarde des données.',
        empty_security_measures: 'Aucune mesure de sécurité ajoutée pour le moment.',
        empty_cleaning_protocols: 'Aucun protocole de nettoyage ajouté pour le moment.',
        empty_certifications: 'Aucune certification ajoutée pour le moment.',
        empty_start_message: 'Cliquez sur "Ajouter" pour commencer.',
        placeholder_security_title: 'Entrez le titre de la mesure de sécurité',
        placeholder_protocol_title: 'Entrez le titre du protocole',
        placeholder_certification_title: 'Entrez le titre de la certification',
        placeholder_security_description: 'Entrez une brève description (maximum 100 caractères)',
        placeholder_protocol_description:
          'Entrez la description détaillée du protocole de nettoyage',
      },
      orders_room_service: {
        title: 'Commandes de Chambre',
        subtitle: "Gestion des demandes de services de l'hôtel",

        // Filtros
        status: 'Statut',
        start_date: 'Date de Début',
        end_date: 'Date de Fin',
        reservation_id: 'Code de la Réservation',
        post_id: 'ID du Post',
        service_type: 'Type de Service',
        search: 'Rechercher',
        clear_filters: 'Effacer les Filtres',

        // Status
        status_pending: 'En attente',
        status_confirmed: 'Confirmée',
        status_in_progress: 'En Cours',
        status_cancelled: 'Annulée',
        status_concluded: 'Terminée',
        status_completed: 'Terminée',

        // Opções de filtro
        all_status: 'Tous les statuts',
        all_types: 'Tous les types',
        service_forms: 'Formulaires de Service',
        services: 'Services',

        // Headers da tabela
        service: 'Service',
        room: 'Chambre',
        price: 'Prix',
        people_qty: 'Nombre de Personnes',
        reservation: 'Réservation',
        date: 'Date',
        time: 'Heure',
        priority: 'Priorité',
        created_at: 'Créé le',
        actions: 'Actions',

        // Tooltip actions
        view_details: 'Voir les Détails',
        change_status: 'Changer le Statut',

        // Modal de detalhes
        order_details: 'Détails de la Commande',
        close: 'Fermer',
        loading_details: 'Chargement des détails de la commande...',
        loading: 'Chargement...',

        // Informações do pedido
        order: 'Commande',
        room_service: 'Service de Chambre',
        location: 'Localisation',
        room_number: 'Numéro de Chambre',
        scheduled_date: 'Date Prévue',
        no_time: 'Sans heure',
        reservation_id_label: 'Code de la Réservation',

        // Informações do cliente
        customer_info: 'Informations du Client',
        full_name: 'Nom Complet',
        email: 'E-mail',
        phone: 'Téléphone',

        // Detalhes da solicitação
        request_summary: 'Résumé de la Demande',
        service_details: 'Détails du Service',
        request_details: 'Détails de la Demande',
        no_items_selected: 'Aucun élément sélectionné',
        not_informed: 'Non informé',
        units: 'unités',

        // Informações técnicas
        technical_info: 'Informations Techniques',
        post: 'Post',
        booking_type: 'Type de Réservation',
        hotel_info: "Informations de l'Hôtel",
        hotel_name: "Nom de l'Hôtel",
        subdomain: 'Sous-domaine',
        type: 'Type',
        service_form: 'Formulaire de Service',
        last_update: 'Dernière Mise à jour',
        additional_notes: 'Observations Additionnelles',

        // Modal de alteração de status
        change_status_title: 'Changer le Statut',
        current_status: 'Statut Actuel',
        new_status: 'Nouveau Statut',
        select_status: 'Sélectionnez un statut',

        // Placeholders
        select_status_placeholder: 'Sélectionnez le statut',
        select_service_type_placeholder: 'Sélectionnez le type de service',
        start_date_placeholder: 'Date de début',
        end_date_placeholder: 'Date de fin',
        reservation_id_placeholder: "Entrez l'ID de la réservation",
        post_id_placeholder: "Entrez l'ID du post",
        new_status_placeholder: 'Sélectionnez le nouveau statut',

        // Mensagens de erro e sucesso
        error: 'Erreur',
        success: 'Succès',
        warning: 'Attention',
        error_loading_orders: 'Erreur lors du chargement des commandes !',
        error_loading_details: 'Erreur lors du chargement des détails de la commande !',
        error_changing_status: 'Erreur lors du changement de statut de la commande !',
        success_status_changed: 'Statut changé avec succès !',
        select_status_warning: 'Veuillez sélectionner un statut.',

        // Évaluation du client
        customer_review: 'Évaluation du Client',
        rating: 'Note',
        review_comment: 'Commentaire',
      },
      s3Analytics: {
        title: 'Analytics S3',
        startDate: 'Date de Début',
        endDate: 'Date de Fin',
        pluginspaceId: 'ID du Pluginspace',
        pluginspaceIdPlaceholder: "Entrez l'ID du pluginspace",
        method: 'Méthode',
        methodPlaceholder: 'Entrez la méthode (GET, POST, etc.)',
        loadData: 'Charger les Données',
        generateAIAnalysis: "Générer l'Analyse IA",
        chatWithAI: "Discuter avec l'IA",
        showRanking: 'Afficher le Classement',
        analyzeWithAI: "Analyser avec l'IA",
        close: 'Fermer',
        totalRequests: 'Total des Requêtes',
        totalCost: 'Coût Total',
        averageCostPerRequest: 'Coût Moyen par Requête',
        consumptionByPluginspace: 'Consommation par Pluginspace',
        consumptionByMethod: 'Consommation par Méthode',
        consumptionByDate: 'Consommation par Date',
        costAnalysis: 'Analyse des Coûts',
        aiAnalysis: "Analyse de l'IA",
        chatMessage: 'Entrez votre question sur les données...',
        speakAnalysis: "Écouter l'Analyse",
        filterData: 'Filtrer les Données',
        noDataFound: 'Aucune donnée trouvée pour les filtres sélectionnés',
        errorLoadingData: 'Erreur lors du chargement des données',
        errorGeneratingAnalysis: "Erreur lors de la génération de l'analyse IA",
        analysisGenerated: 'Analyse générée avec succès !',
        dataLoaded: 'Données chargées avec succès !',
        rankingData: 'Données de Classement',
        aiChatResponse: "Réponse de l'IA",
        s3Analytics: 'Analytics S3',
        filters: 'Filtres',
        totalConsumption: 'Consommation Totale',
        totalRecords: 'Total des Enregistrements',
        error: 'Erreur',
        fetchError: 'Erreur lors de la récupération des données S3',
        aiAnalysisError: "Erreur lors de la génération de l'analyse IA",
        aiChatError: "Erreur lors de la discussion avec l'IA",
        askQuestion: 'Entrez votre question sur les données...',
        ask: 'Demander',
        cancel: 'Annuler',
        ok: 'OK',
        aiResponse: "Réponse de l'IA",
        aiAnalysisTitle: "Analyse de l'IA",
        account: 'Compte',
        pluginspace: 'Magasin',
        uniquePluginspaces: 'Magasins Uniques',
        methodDistribution: 'Distribution par Méthode',
        timeAnalysis: 'Analyse Temporelle',
        dataTable: 'Tableau de Données',
        showingFirst10: 'Affichage des 10 premiers',
        of: 'de',
        records: 'enregistrements',
        consumption: 'Consommation',
        cost: 'Coût',
        date: 'Date',
        allMethods: 'Toutes les Méthodes',
        exportData: 'Exporter les Données',
      },
      hospitality_store: {
        establishment: 'Établissement',
        select_establishment: 'Sélectionnez...',
        link: 'Lien',
        status: 'Statut',
        payment_integrated: 'Paiement Intégré',
        order: 'Ordre',
        store_image: 'Image du Magasin',
        store_image_hint: 'Sélectionnez une image représentative du magasin',
        description: 'Description',
        cnpj: 'CNPJ',
        code: 'Code',
        store_id_placeholder: 'ID du magasin',
        type: 'Type',
        store_type_placeholder: "Type de l'établissement",
        no_store_found: 'Aucun établissement trouvé.',
        edit_store: "Modifier l'Établissement",
        edit_store_subtitle: "Modifiez les données de l'établissement.",
      },
      stores_pages: {
        title: 'Établissements',
        subtitle: "Voici les établissements de l'hôtel listés avec leurs actions respectives.",
        create: 'Créer un Établissement',
        no_results: 'Aucun établissement trouvé.',
        table: {
          code: 'Code',
          image: 'Image',
          name: 'Magasin',
          cnpj: 'CNPJ',
          vinculation: 'Type de liaison',
          vinculation_default: 'Par défaut',
          vinculation_dynamic: 'Dynamique',
          type: 'Type',
          order: 'Ordre',
          status: 'Statut',
          status_active: 'Actif',
          status_inactive: 'Inactif',
          payment_integrated: 'Paiement Intégré',
          actions: 'Actions',
        },
        actions: {
          edit: "Modifier l'Établissement",
          delete_confirm: 'Êtes-vous sûr de vouloir supprimer ?',
          delete: "Supprimer l'Établissement",
        },
        delete_success: 'Établissement supprimé avec succès.',
        delete_error: "Erreur lors de la suppression de l'établissement. Veuillez réessayer.",
        success: 'Succès !',
        error: 'Erreur !',
      },
      stores_pages_create: {
        title: 'Créer un Établissement',
        subtitle: "Créez un nouvel établissement pour l'hôtel.",
        form: {
          establishment: 'Établissement',
          select_placeholder: 'Sélectionnez...',
          link: 'Lien',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Statut',
          status_options: { active: 'Actif', inactive: 'Inactif' },
          payment_integrated: 'Paiement Intégré',
          payment_options: { active: 'Actif', inactive: 'Inactif' },
          order: 'Ordre',
          image_label: "Image de l'Établissement",
          image_smalltext: "Sélectionnez une image représentative de l'établissement",
          description: 'Description',
          info_title: "Informations de l'Établissement",
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Type',
          vinculation_label: 'Type de liaison',
          vinculation_options: { default: 'Par défaut', dynamic: 'Dynamique' },
          empty_message: 'Aucun établissement trouvé.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID du magasin',
        },
        console_messages: {
          image_upload_error: "Erreur de téléchargement de l'image",
        },
        messages: {
          warning_title: 'Attention',
          select_store_warning:
            'Veuillez sélectionner un établissement valide avant de sauvegarder.',
          error_saving:
            "Une erreur est survenue lors de la sauvegarde de l'établissement. Veuillez réessayer.",
          success_saved: 'Établissement sauvegardé avec succès.',
        },
      },
      feedback_reviews: {
        title: 'Revues de Recherche et de Satisfaction',
        subtitle:
          'Visualiser et gérer toutes les évaluations et réponses des formulaires de feedback',
        breadcrumb_feedback: 'Feedback de Satisfaction',
        error: 'Erreur',
        success: 'Succès',
        loading: 'Chargement...',
        loading_details: 'Chargement des détails de la revue...',
        close: 'Fermer',
        error_loading_reviews: 'Erreur lors du chargement des revues',
        error_loading_details: 'Erreur lors du chargement des détails de la revue',
        error_changing_status: 'Erreur lors du changement de statut de la revue',
        success_status_changed: 'Statut changé avec succès',
        confirm_status_change: 'Confirmer le changement de statut',
        confirm_status_change_text: 'Êtes-vous sûr de vouloir changer le statut de cette revue ?',

        // Status
        status_pending: 'En attente',
        status_approved: 'Approuvé',
        status_rejected: 'Rejeté',

        // Types de champs affichés dans les réponses
        types: {
          title: 'Titre',
          text: 'Texte',
          textarea: 'Zone de texte',
          stars: 'Notation',
          checkbox: 'Case à cocher',
          radio: 'Choix unique',
          select: 'Sélection',
          number: 'Nombre',
          date: 'Date',
          time: 'Heure',
          image: 'Image',
          link: 'Lien',
        },

        anonymous_active: 'Actif',
        anonymous_inactive: 'Inactif',

        // Filtres
        filters: {
          feedback_form: 'Formulaire',
          status: 'Statut',
          anonymous: 'Anonyme',
          select_anonymous_placeholder: 'Tous',
          rating: 'Évaluation',
          reservation_id: 'ID de Réservation',
          start_date: 'Date de Début',
          end_date: 'Date de Fin',
          date: 'Date',
          all_forms: 'Tous les Formulaires',
          all_status: 'Tous les Statuts',
          all_ratings: 'Toutes les Évaluations',
          select_form_placeholder: 'Sélectionner un formulaire',
          select_status_placeholder: 'Sélectionner un statut',
          select_rating_placeholder: 'Sélectionner une évaluation',
          reservation_id_placeholder: "Entrer l'ID de la réservation",
          start_date_placeholder: 'Sélectionner la date de début',
          end_date_placeholder: 'Sélectionner la date de fin',
          filter_button: 'Filtrer',
          clear_filters: 'Effacer les Filtres',
        },

        // Tableau
        table: {
          feedback_form: 'Formulaire',
          customer: 'Client',
          room: 'Chambre',
          reservation: 'Réservation',
          rating: 'Évaluation',
          status: 'Statut',
          date: 'Date',
          time: 'Heure',
          actions: 'Actions',
        },

        // Actions
        actions: {
          view_details: 'Voir les Détails',
          approve: 'Approuver',
          reject: 'Rejeter',
        },

        // Détails de la Revue
        review_details: 'Détails de la Revue',
        room: 'Chambre',
        reservation: 'Réservation',
        feedback_form: 'Formulaire',
        responses: 'Réponses',
        technical_info: 'Informations Techniques',
        created_at: 'Créé le',
        updated_at: 'Mis à jour le',
        review_id: 'ID de la Revue',
        plugin_space_id: "ID de l'Espace Plugin",
        anonymous_response: 'Réponse Anonyme',
        no_reservation_linked: "Cette réponse n'est liée à aucune réservation spécifique",
        no_detailed_responses: 'Aucune réponse détaillée disponible pour cette revue',
        anonymous_label: 'Anonyme',
        email_anonymous: 'E-mail non disponible (réponse anonyme)',
        email_not_informed: 'E-mail non renseigné',
        response_title: 'Titre',
        no_rating_provided: 'Aucune évaluation fournie',
        no_items_selected: 'Aucun élément sélectionné',
        no_option_selected: 'Aucune option sélectionnée',
        no_answer_provided: 'Aucune réponse fournie',
        form_label: 'Formulaire :',
        client_not_identified: 'Client non identifié',
      },
      stores_pages_edit: {
        title: "Modifier l'Établissement",
        subtitle: "Modifiez les données de l'établissement.",
        form: {
          establishment: 'Établissement',
          select_placeholder: 'Sélectionnez...',
          link: 'Lien',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Statut',
          status_options: { active: 'Actif', inactive: 'Inactif' },
          payment_integrated: 'Paiement Intégré',
          payment_options: { active: 'Actif', inactive: 'Inactif' },
          order: 'Ordre',
          image_label: "Image de l'Établissement",
          image_smalltext: "Sélectionnez une image représentative de l'établissement",
          description: 'Description',
          info_title: "Informations de l'Établissement",
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Type',
          vinculation_label: 'Type de liaison',
          vinculation_options: { default: 'Par défaut', dynamic: 'Dynamique' },
          empty_message: 'Aucun établissement trouvé.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID du magasin',
        },
        console_messages: {
          image_upload_error: "Erreur de téléchargement de l'image",
          image_remove_error: "Erreur lors de la suppression de l'image à la sauvegarde",
        },
        messages: {
          success_updated: 'Établissement mis à jour avec succès.',
          error_updating:
            "Une erreur est survenue lors de la mise à jour de l'établissement. Veuillez réessayer.",
          payment_change_warning_title: 'Attention',
          payment_change_warning_text:
            'Cette modification peut changer la valeur des réservations en cours au moment du départ.',
          payment_confirm: 'Oui, continuer',
          cancel: 'Annuler',
        },
      },
      hospitality_section: {
        index: {
          page_title: 'Pages de Publication',
          page_subtitle:
            'Voici les pages de publication de contenu listées avec leurs actions respectives.',
          add_button: 'Ajouter une Page de Publication',
          filters: {
            sections: 'Page de Publication',
          },
          table: {
            headers: {
              title: 'Titre',
              order: 'Ordre',
              formTitle: 'Titre du Formulaire',
              type: 'Type',
              actions: 'Actions',
            },
          },
          actions: {
            edit: 'Modifier les Pages de Publication',
            delete: 'Supprimer les Pages de Publication',
          },
        },
        create: {
          page_title: 'Créer une Page de Publication',
          page_subtitle: "Créez une nouvelle page de publication de contenu pour l'hôtel.",
          add_button: 'Ajouter une Page de Publication',
          filters: {
            sections: 'Sections',
          },
        },
        edit: {
          page_title: 'Modifier la Page de Publication',
          page_subtitle: 'Modifiez les données de la page de publication de contenu.',
        },
        // Traductions dynamiques pour les sections
        types: {
          category: 'Catégorie',
          content: 'Contenu',
          simple: 'Simple',
          form: 'Formulaire',
          page: 'Restaurant et boutique',
        },
        status: {
          active: 'Actif',
          inactive: 'Inactif',
        },
        actions: {
          create: 'Créer',
          edit: 'Modifier',
          delete: 'Supprimer',
          save: 'Sauvegarder',
          cancel: 'Annuler',
          update: 'Mettre à jour',
          remove_icon: "Retirer l'Icône",
          select_icon: "Sélectionner l'Icône",
        },
        fields: {
          title: 'Titre du Bouton',
          type: 'Type de Page de Publication',
          category: 'Catégorie',
          order: 'Ordre',
          status: 'Statut',
          icon: 'Icône',
          icon_selected: 'Icône Sélectionnée',
          icon_not_selected: 'Aucune Icône Sélectionnée',
          icon_description: 'Sélectionnez une icône de la liste ci-dessous pour la section',
          icon_change_description:
            "Sélectionnez une icône différente de la liste ci-dessous ou supprimez l'actuelle",
        },
        placeholders: {
          title: 'Entrez le titre du bouton',
          type: 'Sélectionnez le type',
          category: 'Sélectionnez une catégorie',
          order: '0',
          search_icon: 'Rechercher une icône...',
          all_categories: 'Toutes les catégories',
        },
        warnings: {
          stores:
            "Aucun établissement de type Dynamique n'a été trouvé.\nPour continuer, accédez à Paramètres → Boutiques et Établissements et configurez un établissement de type Dynamique.",
        },
        messages: {
          validation: {
            title_required: 'Le titre est obligatoire !',
            category_required: 'Sélectionnez une catégorie !',
            icon_required: 'Sélectionnez une icône !',
          },
          success: {
            created: 'Page de Publication créée avec succès !',
            updated: 'Page de Publication mise à jour avec succès !',
            deleted: 'Page de Publication supprimée avec succès !',
          },
          error: {
            create: 'Erreur lors de la création de la Page de Publication !',
            update: 'Erreur lors de la mise à jour de la Page de Publication !',
            delete: 'Erreur lors de la suppression de la Page de Publication !',
            load: 'Erreur lors du chargement des données de la Page de Publication !',
          },
          confirm: {
            delete_title: 'Êtes-vous sûr ?',
            delete_text: 'Cette action ne peut pas être annulée !',
            delete_confirm: 'Oui, supprimer',
            delete_cancel: 'Annuler',
          },
          delete: {
            deleted_title: 'Pages de Publication supprimées',
            deleted_text: 'Suppression réussie !',
            error_title: 'Erreur lors de la suppression des Pages de Publication !',
            error_text:
              'Une erreur est survenue lors de la suppression des Pages de Publication. Veuillez réessayer.',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: 'Catégories de Publications',
          page_subtitle:
            'Voici les catégories de publications listées avec leurs actions respectives.',
          add_button: 'Ajouter une Catégorie de Publication',
          filter_all: 'All',
          table: {
            headers: {
              title: 'Titre',
              image: 'Image',
              summary: 'Résumé',
              status: 'Statut',
              classification: 'Classification',
              code: 'Code',
              actions: 'Actions',
            },
            actions: {
              edit: 'Modifier la Catégorie de Publication',
              delete: 'Supprimer la Catégorie de Publication',
            },
          },
        },
        create: {
          page_title: 'Créer une Catégorie de Publication',
          page_subtitle: "Créez une nouvelle catégorie de publication pour l'hôtel.",
          add_button: 'Ajouter une Catégorie de Publication',
          success: {
            created_title: 'Catégorie de Publication créée',
            created_text: 'Enregistrement effectué avec succès !',
          },
          error: {
            created_title: 'Erreur lors de la création de la Catégorie de Publication !',
            created_text:
              'Une erreur est survenue lors de la création de la catégorie. Veuillez réessayer.',
          },
        },
        edit: {
          page_title: 'Modifier la Catégorie de Publication',
          page_subtitle: 'Modifiez les données de la catégorie de publication.',
          error: {
            created_title: 'Erreur lors de la modification de la Catégorie de Publication !',
            created_text:
              'Une erreur est survenue lors de la modification de la catégorie. Veuillez réessayer.',
          },
          success: {
            created_title: 'Catégorie de Publication modifiée',
            created_text: 'Enregistrement effectué avec succès !',
          },
        },
      },
      hospitality_post: {
        posts: 'Publications',
        index: {
          page_title: 'Publications',
          page_subtitle:
            "Voici les publications de l'hôtel listées avec leurs actions respectives.",
          add_button: 'Ajouter une Publication',
          filter_all: 'Tous',
          filter: 'Catégories',
          table: {
            headers: {
              title: 'Titre',
              image: 'Image',
              summary: 'Résumé',
              order: 'Ordre',
              status: 'Statut',
              classification: 'Classification',
              actions: 'Actions',
            },
            actions: {
              edit: 'Modifier la Publication',
              delete: 'Supprimer la Publication',
            },
          },
        },
        create: {
          page_title: 'Créer une Publication',
          page_subtitle: "Créez une nouvelle publication pour l'hôtel.",
          success: {
            created_title: 'Publication créée',
            created_text: 'Enregistrement terminé avec succès !',
          },
          error: {
            created_title: 'Erreur lors de la création de la Publication !',
            created_text:
              'Une erreur est survenue lors de la création de la publication. Veuillez réessayer.',
          },
        },
        edit: {
          page_title: 'Modifier la Publication',
          page_subtitle: 'Modifiez les données de la publication.',
          success: {
            created_title: 'Publication modifiée',
            created_text: 'Enregistrement terminé avec succès !',
          },
          error: {
            created_title: 'Erreur lors de la modification de la Publication !',
            created_text:
              'Une erreur est survenue lors de la modification de la publication. Veuillez réessayer.',
          },
        },
        form_validate: {
          title_required: 'Le titre est obligatoire !',
          summary_required: 'Le résumé est obligatoire !',
          classification_required: 'La classification est obligatoire !',
          content_required: 'Le contenu est obligatoire !',
          fields_missing: 'Vérifiez que vous avez rempli tous les champs !',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'Simple',
          section: 'Section',
          form: 'Formulaire',
          category: 'Catégorie',
        },
        index: {
          page_title: 'Pages de Publications',
          page_subtitle:
            'Voici les pages de publication de contenu listées avec leurs actions respectives.',
          add_button: 'Ajouter une Page de Publication',
          edit_button: 'Modifier la Page de Publication',
          delete_button: 'Supprimer la Page de Publication',
        },
        create: {
          page_title: 'Créer une Page de Publication',
          page_subtitle: "Créez une nouvelle page de publication de contenu pour l'hôtel.",
          form: {
            title: 'Titre de la Page de Publication',
            type: 'Type de Page de Publication',
            status: 'Statut',
          },
          icon: {
            icon: 'Icône SVG',
            lib: "Bibliothèque d'Icônes SVG",
            search: 'Rechercher une icône...',
            category: "Catégorie d'Icône",
            description: 'Sélectionnez une icône dans la liste à côté pour la page de publication',
            selected: 'Icône Sélectionnée',
            no_selected: 'Aucune Icône Sélectionnée',
            selected_description:
              'Sélectionnez une icône dans la liste à côté pour la page de publication',
            no_selected_description:
              'Aucune icône sélectionnée. Sélectionnez une icône dans la liste à côté pour la page de publication',
            change_description:
              "Sélectionnez une icône différente dans la liste à côté ou supprimez l'actuelle",
          },
          success: {
            created_title: 'Page de Publication créée',
            created_text: 'Enregistrement terminé avec succès !',
          },
          error: {
            created_title: 'Erreur lors de la création de la Page de Publication !',
            created_text:
              'Une erreur est survenue lors de la création de la page. Veuillez réessayer.',
          },
        },
        edit: {
          page_title: 'Modifier la Page de Publication',
          page_subtitle: 'Modifiez les données de la page de publication de contenu.',
          form: {
            title: 'Titre de la Page de Publication',
            type: 'Type de Page de Publication',
            status: 'Statut',
          },
          icon: {
            icon: 'Icône SVG',
            lib: "Bibliothèque d'Icônes SVG",
            search: 'Rechercher une icône...',
            category: "Catégorie d'Icône",
            description: 'Sélectionnez une icône dans la liste à côté pour la page de publication',
            selected: 'Icône Sélectionnée',
            no_selected: 'Aucune Icône Sélectionnée',
            selected_description:
              'Sélectionnez une icône dans la liste à côté pour la page de publication',
            no_selected_description:
              'Aucune icône sélectionnée. Sélectionnez une icône dans la liste à côté pour la page de publication',
            change_description:
              "Sélectionnez une icône différente dans la liste à côté ou supprimez l'actuelle",
          },
          success: {
            created_title: 'Page de Publication modifiée',
            created_text: 'Modification terminée avec succès !',
          },
          error: {
            created_title: 'Erreur lors de la modification de la Page de Publication !',
            created_text:
              'Une erreur est survenue lors de la modification de la page. Veuillez réessayer.',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'Réservations de Services',
        page_subtitle: 'Gérer les réservations de services',
        breadcrumb_services: 'Services de Réservation',
        breadcrumb_booking: 'Services de Réservation',
        create_button: 'Créer une Réservation de Service',

        // Table headers
        table_image: 'Image',
        table_title: 'Titre',
        table_order: 'Ordre',
        table_status: 'Statut',
        table_actions: 'Actions',

        // Table actions
        action_edit: 'Modifier',
        action_delete: 'Supprimer',

        // Status
        status_active: 'Actif',
        status_inactive: 'Inactif',

        // Messages
        delete_success: 'Réservation supprimée',
        delete_error: 'Erreur lors de la suppression de la réservation',
        delete_confirm: 'Confirmer la suppression ?',

        // Create page
        create_title: 'Créer une Réservation de Service',
        create_subtitle:
          'Complétez les informations pour créer une nouvelle réservation de service',

        // Edit page
        edit_title: "Modifier une Réservation d'Hôtel",
        edit_subtitle: 'Modifier les informations de la réservation',

        // Form fields
        field_title_label: 'Titre',
        field_title_placeholder: 'Ex. : Réservation Spa',
        field_status_label: 'Statut',
        field_description_label: 'Description',
        field_image_label: 'Image',
        field_icon_label: 'Icône',

        // Icon picker
        icon_choose: 'Choisir une Icône',
        icon_choose_modal: 'Choisir une Icône',

        // Day configuration
        day_config_title: 'Configuration des Jours',
        day_configure: 'Configurer',
        day_periods_title: 'Périodes de Temps',
        day_period_add: 'Ajouter une Période',
        day_period_max: 'Maximum 3 périodes',
        day_period_none: 'Aucune période configurée. Ajoutez au moins une période.',
        day_period_overlap:
          'Les périodes ne peuvent pas se chevaucher. Ajustez les horaires configurés.',
        day_period_label: 'Période',
        day_period_remove: 'Supprimer',
        day_interval_label: 'Intervalle (min)',
        day_start_time_label: 'Heure de Début',
        day_end_time_label: 'Heure de Fin',

        // Day names
        day_sunday: 'Dimanche',
        day_monday: 'Lundi',
        day_tuesday: 'Mardi',
        day_wednesday: 'Mercredi',
        day_thursday: 'Jeudi',
        day_friday: 'Vendredi',
        day_saturday: 'Samedi',

        // Grid selection
        grid_title: 'Grilles Liées',
        grid_select: 'Sélectionner des Grilles',
        grid_selected: 'grille(s) sélectionnée(s)',
        grid_capacity: 'Capacité',
        grid_multiple: 'Multiple',
        grid_multiple_yes: 'Oui',
        grid_multiple_no: 'Non',
        grid_status_active: 'Actif',
        grid_status_inactive: 'Inactif',

        // Action buttons
        button_back: 'Retour',
        button_save: 'Sauvegarder',
        button_update: 'Mettre à Jour',
        button_create: 'Créer',
        button_cancel: 'Annuler',
        button_confirm: 'Confirmer',

        // Validation messages
        validation_title_required: 'Champ obligatoire',
        validation_title_text: 'Le titre est obligatoire.',
        validation_icon_required: 'Champ obligatoire',
        validation_icon_text: 'Sélectionnez une icône.',
        validation_day_required: 'Configuration requise',
        validation_day_text: 'Configurez au moins un jour de la semaine.',

        // Success messages
        success_created: 'Réservation créée',
        success_created_text: 'La réservation a été créée avec succès !',
        success_updated: 'Réservation mise à jour',
        success_updated_text: 'La réservation a été mise à jour avec succès !',

        // Error messages
        error_create: 'Erreur lors de la création',
        error_create_text: "Une erreur s'est produite lors de la création de la réservation.",
        error_update: 'Erreur lors de la mise à jour',
        error_update_text: "Une erreur s'est produite lors de la mise à jour de la réservation.",
        error_save: 'Erreur',
        error_save_text: "Une erreur s'est produite lors de la sauvegarde de la réservation.",
        error_load: 'Erreur',
        error_load_text: 'Erreur lors du chargement des données de réservation.',

        // Breadcrumbs
        breadcrumb_dashboard: 'Tableau de Bord',
        breadcrumb_hospitality: 'Hospitalité',
        breadcrumb_hotel_reservations: "Réservations d'Hôtel",
        breadcrumb_create: 'Créer',
        breadcrumb_edit: 'Modifier',
      },
      users: {
        houserkeeping: "Personnel d'étage",
        maintenancetechnician: 'Technicien de maintenance',
        receptionist: 'Réceptionniste',
        manager: 'Directeur',
        administrator: 'Administrateur',
        waiter: 'Serveur',
        kitchenchief: 'Chef de cuisine',
        warehouse: "Responsable de l'entrepôt",
        concierge: 'Concierge',
        messenger: 'Messager',
        receptionsupervisor: 'Superviseur de Réception',
        telephonist: 'Téléphoniste',
        cook: 'Cuisinier',
        barman: 'Barman / Bartender',
        roomserviceattendant: 'Préposé au Service de Chambre',
        steward: 'Steward (Nettoyage de Cuisine)',
        sommelier: 'Sommelier',
        plumber: 'Plombier',
        airconditiontechnician: 'Technicien de Climatisation',
        maintenancesupervisor: 'Superviseur de Maintenance',
        reservationagent: 'Agent de Réservation',
        reservationcoordinator: 'Coordinateur de Réservations',
        salesexecutive: 'Responsable des Ventes',
        revenuemanager: 'Gestionnaire de Revenue',
        commercialmanager: 'Directeur Commercial',
        administrativeassistant: 'Assistant Administratif',
        financeaccountspayable: 'Finance / Comptes Fournisseurs',
        accountant: 'Comptable',
        humanresources: 'Ressources Humaines',
        purchasingwarehouse: 'Achats / Entrepôt',
        recreator: 'Animateur',
        activityinstructor: "Instructeur d'Activités",
        experiencecoordinator: "Coordinateur d'Expériences",
        tourguide: 'Guide Touristique',
        childmonitor: 'Moniteur pour Enfants',
        securityguard: 'Agent de Sécurité',
        doorman: 'Portier',
        accesscontroller: "Contrôleur d'Accès",
        securitysupervisor: 'Superviseur de Sécurité',
        generalmanager: 'Directeur Général',
        assistantmanager: 'Directeur Adjoint',
        operationalmanager: 'Directeur Opérationnel',
        departmentsupervisorscoordinators: 'Superviseurs et Coordinateurs de Département',
        floormanager: 'Responsable des Étages',
        governancesupervisor: "Superviseur de l'Intendance",
        generalservicesassistant: 'Assistant aux Services Généraux',
        laundryattendant: 'Préposé à la Buanderie',
        laundrymanager: 'Responsable du Linge',
        machinist: 'Opérateur de Machines',
        ironer: 'Repasseur',
        electrician: 'Électricien',
        carpenter: 'Menuisier',
      },
      // Francês (Français - fr)
      aggregador_publicity: {
        title: 'Publicité de l\'Agrégateur',
        subTitle: 'Gérez les publicités. Contrôlez la période d\'affichage, l\'ordre et le statut.',
        title_create: 'Créer une Publicité d\'Agrégateur',
        subTitle_create: 'Créez une nouvelle publicité d\'agrégateur pour pluginSpace.',
        title_edit: 'Modifier la Publicité de l\'Agrégateur',
        subTitle_edit: 'Modifiez les données de la publicité d\'agrégateur.',
        table: {
          image: 'Image',
          title: 'Titre',
          description: 'Description',
          periodo: 'Période',
          name: 'Nom',
          order: 'Ordre',
          status: 'Statut',
          actions: 'Actions',
        },
        form: {
          image_label: 'Image',
          title_label: 'Titre',
          category_label: 'Catégorie',
          category_placeholder: 'Sélectionnez une catégorie',
          local_label: 'Emplacement',
          local_placeholder: 'Sélectionnez un emplacement',
          description_label: 'Description',
          start_date_label: 'Date de début',
          start_time_label: 'Heure de début',
          end_date_label: 'Date de fin',
          end_time_label: 'Heure de fin',
          external_link_checkbox: 'Lien externe',
          external_link_placeholder: 'https://www.exemple.fr',
          external_link_label: 'Lien',
          order_label: 'Ordre',
          status_label: 'Statut',
          description_smalltext: '(limite de {qtd} caractères)',
          button_label: 'Étiquette du Bouton',
          button_label_smalltext: 'Optionnel',
        },
        preview: {
          period_title: 'Période',
          start: 'Début',
          end: 'Fin',
          order: 'Ordre',
        }
      },
      // Francês (Français - fr)
      agregador_dinamic_page: {
        title: 'Page Dynamique de l\'Agrégateur',
        subTitle: 'Gérez les pages dynamiques de l\'agrégateur. Contrôlez l\'ordre et le statut.',
        create_title: 'Créer une Page Dynamique d\'Agrégateur',
        create_subTitle: 'Créez une nouvelle page dynamique d\'agrégateur.',
        edit_title: 'Modifier la Page Dynamique de l\'Agrégateur',
        edit_subTitle: 'Modifiez les données de la page dynamique d\'agrégateur.',
        tabs: {
          general: 'Métadonnées de la Page',
          general_title: 'Informations de la page',
          general_description: 'Remplissez les informations générales de la page dynamique d\'agrégateur.',
          grid: 'Grille d\'Informations',
          grid_title: 'Grilles de la page',
          grid_description: 'Faites glisser les cartes pour modifier l\'ordre.',
          grid_button: 'Ajouter une Grille',
          no_grid_message: 'Aucune grille ajoutée. Cliquez sur "Ajouter une Grille" pour en inclure une nouvelle.',
          no_grid_title: 'Aucune grille ajoutée',
        },
        table: {
          image: 'Image',
          title: 'Titre',
          description: 'Description',
          order: 'Ordre',
          slug: 'Slug',
          grid_qtd: 'Qté de Grilles',
          status: 'Statut',
          actions: 'Actions',
        },
        form: {
          title_label: 'Titre',
          title_placeholder: 'Saisissez le titre de la page',
          description_label: 'Description',
          description_placeholder: 'Saisissez la description de la page',
          order_label: 'Ordre',
          order_placeholder: 'Saisissez l\'ordre de la page',
          slug_label: 'Slug',
          slug_placeholder: 'Saisissez le slug de la page',
          category_label: 'Catégorie',
          category_placeholder: 'Sélectionnez une catégorie',
          local_label: 'Emplacement',
          local_placeholder: 'Sélectionnez un emplacement',
          title_seo_label: 'Titre SEO',
          title_seo_placeholder: 'Saisissez le titre SEO de la page',
          share_image_label: 'Image',
          share_image_small_text: 'La taille de l\'image doit être de 720x600',
          description_seo_label: 'Description SEO',
          description_seo_placeholder: 'Saisissez la description SEO de la page',
          status_label: 'Statut',
        },
        grid:{
          image: 'Image',
          carousel: 'Carrousel d\'Images (max 4)',
          hero: 'Section Hero',
          content: 'Contenu Titre + Texte',
          text: 'Texte seul',
        }
      },
    },
  },
}

export { messages }
